<template>
    <div class="indexContent">
        <!-- 超级IP智能体 -->
        <div class="ipContent column" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '1' && selectedHcid.hcid == '18' && setvoice.pitch_rate">
            <el-image :src="require('@/assets/image/ipBg.png')" fit="cover" class="ipBg"></el-image>
            <div class="ipList flex">
                <div class="ipBox column">
                    <div class="ipTopBox column">
                        <div class="ipTop">01 IP大脑</div>
                        <el-image :src="require('@/assets/icon/ip01.png')" fit="cover" class="ipTopIcon"></el-image>
                    </div>
                    <div class="ipTabList between">
                        <div :class="['ipTab',imitateActive == index ? 'ipTabOn' : '']" v-for="(item,index) in imitateTab" :key="index" @click="imitateActive = index">{{ item }}</div>
                    </div>
                    <template v-if="imitateActive == '0'">
                        <div class="ipTitleBox align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">任务名称</div>
                        </div>
                        <el-input placeholder="请输入任务名称" v-model="imitateName" maxlength="9999" class="ipIpt"></el-input>
                        <div class="ipTitleBox pdt12 between">
                            <div class="align">
                                <div class="ipTitleIcon"></div>
                                <div class="ipTitle">提取文案</div>
                            </div>
                            <div class="align">
                                <el-image :src="item" fit="cover" v-for="(item,index) in ipData.imgs" :key="index" class="ipTitleImg"></el-image>
                            </div>
                        </div>
                        <el-input placeholder="请粘贴短视频链接:如:https://v.douyin.com/xxxx" v-model="imitateLink" maxlength="9999" class="ipIpt"></el-input>
                        <div class="ipBtnList spb">
                            <div class="ipBtnClear" @click="imitateLink = ''">清空</div>
                            <div class="ipBtnBox center" @click="extractTap">
                                <div class="ipBtn">提取文案</div>
                                <el-image :src="require('@/assets/icon/star02.png')" fit="cover" class="ipBtnIcon"></el-image>
                                <div class="ipBtn">{{ ipData.tiquwenan }}</div>
                            </div>
                        </div>
                        <template v-if="extract != ''">
                            <div class="extractText">{{ extract }}</div>
                            <div class="ipTitleBox pdt12 align">
                                <div class="ipTitleIcon"></div>
                                <div class="ipTitle">文案长度</div>
                            </div>
                            <div class="countList flex">
                                <div :class="['count',countActive == index ? 'countOn' : '']" v-for="(item,index) in ipData.zishu" :key="index" @click="countActive = index">{{item}}</div>
                            </div>
                            <div class="ipBtnBoxTwo center" @click="imitateTap">
                                <div class="ipBtn">AI仿写</div>
                                <el-image :src="require('@/assets/icon/star04.png')" fit="cover" class="ipBtnIcon"></el-image>
                                <div class="ipBtn">{{ ipData.fangxie }}</div>
                            </div>
                            <div class="ipTitleBox pdt12 align" v-if="imitate != ''">
                                <div class="ipTitleIcon"></div>
                                <div class="ipTitle">仿写后文案</div>
                            </div>
                            <div class="extractText" v-if="imitate != ''">{{ imitate }}</div>
                        </template>
                    </template>
                    <template v-if="imitateActive == '1'">
                        <div class="ipTitleBox align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">任务名称</div>
                        </div>
                        <el-input placeholder="请输入任务名称" v-model="ipName" maxlength="9999" class="ipIpt"></el-input>
                        <div class="ipTitleBox pdt12 between">
                            <div class="align">
                                <div class="ipTitleIcon"></div>
                                <div class="ipTitle">提取文案</div>
                            </div>
                            <div class="align">
                                <el-image :src="item" fit="cover" v-for="(item,index) in ipData.imgs" :key="index" class="ipTitleImg"></el-image>
                            </div>
                        </div>
                        <el-input placeholder="请粘贴博主链接，例如:https://v.douyin.com/xxxx" v-model="ipLink" maxlength="9999" class="ipIpt"></el-input>
                        <div class="ipBtnList spb">
                            <div class="ipBtnClear" @click="ipLink = ''">清空</div>
                            <div class="ipBtnBox center">
                                <div class="ipBtn">对标学习</div>
                            </div>
                        </div>
                        <div class="ipTitleBox pdt12 align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">已对标学习</div>
                        </div>
                        <div class="standardList flex">
                            <div :class="['standardBox align',standardActive == index ? 'standardBoxOn' : '']" v-for="(item,index) in 8" :key="index" @click="standardActive = index">
                                <div class="standard">抖音用户名</div>
                                <el-image :src="require('@/assets/icon/close.png')" fit="cover" class="standardIcon" v-if="standardActive == index"></el-image>
                            </div>
                        </div>
                        <div class="ipBtnList spb">
                            <div class="ipBtnBox center">
                                <div class="ipBtn">生成选题</div>
                            </div>
                        </div>
                        <div class="areaBox">
                            <div :class="['topic',topicActive == index ? 'topicOn' : '']" v-for="(item,index) in 10" :key="index" @click="topicActive = index">顶流裁判马宁，登场世界杯顶流裁判马宁，登场世界杯顶流裁判马宁，登场世界杯</div>
                        </div>
                        <div class="ipBtnBoxTwo center">
                            <div class="ipBtn">大脑撰写</div>
                            <el-image :src="require('@/assets/icon/star04.png')" fit="cover" class="ipBtnIcon"></el-image>
                            <div class="ipBtn">3</div>
                        </div>
                        <div class="ipTitleBox pdt12 align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">撰写后文案</div>
                        </div>
                        <div class="extractText">{{ write }}</div>
                    </template>
                    <template v-if="imitateActive == '2'">
                        <div class="ipTitleBox align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">任务名称</div>
                        </div>
                        <el-input placeholder="请输入任务名称" v-model="ipName" maxlength="9999" class="ipIpt"></el-input>
                        <div class="ipTitleBox pdt12 between">
                            <div class="align">
                                <div class="ipTitleIcon"></div>
                                <div class="ipTitle">文案</div>
                            </div>
                        </div>
                        <div class="areaBox">
                            <el-input type="textarea" :rows="4" placeholder="输入一句话,一键AI生成爆款文案" v-model="aiAreaText" maxlength="500" show-word-limit :clearable="true" class="aiArea"></el-input>
                        </div>
                        <div class="ipBtnList spb">
                            <div class="aiLegalBtn">AI法务</div>
                            <div class="aiBtnBox center">
                                <div class="ipBtn">大脑撰写</div>
                                <el-image :src="require('@/assets/icon/star04.png')" fit="cover" class="ipBtnIcon"></el-image>
                                <div class="ipBtn">3</div>
                            </div>
                        </div>
                    </template>
                    <!-- <div class="LegalBtn" v-if="imitateActive != '2'">AI法务</div>
                    <div class="ipTitleBox pdt12 between">
                        <div class="align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">选择语言</div>
                        </div>
                        <el-switch v-model="imitateSwitch" active-color="#13ce66" inactive-color="#F8F9FA"></el-switch>
                    </div>
                    <template v-if="imitateSwitch">
                        <el-select clearable v-model="languageValue" placeholder="请选择语言" class="ipIpt" @change="languageChange">
                            <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <div class="ipTitleTwo">选择方言</div>
                        <el-select clearable v-model="dialectValue" placeholder="请选择方言" class="ipIpt">
                            <el-option v-for="item in dialectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </template> -->
                </div>
                <div class="ipBox column">
                    <div class="ipTopBox column">
                        <div class="ipTop">02 AI数字人</div>
                        <el-image :src="require('@/assets/icon/ip01.png')" fit="cover" class="ipTopIcon"></el-image>
                    </div>
                    <div class="ipTitleBox align">
                        <div class="ipTitleIcon"></div>
                        <div class="ipTitle">口播音色</div>
                    </div>
                    <div class="ipTitleTwo" style="margin-top: 8px;">选择适合的音色，让数字人口播更自然。</div>
                    <div class="ipTabList between">
                        <div :class="['ipTab',driveActive == index ? 'ipTabOn' : '']" v-for="(item,index) in driveTab" :key="index" @click="driveActive = index">{{ item.name }}</div>
                    </div>
                    <template v-if="driveActive == 0">
                        <div class="ipTitleTwo">文本</div>
                        <el-input type="textarea" autosize :rows="4" placeholder="请输入文本" v-model="driveText" class="driveArea"></el-input>
                        <div class="ipTitleTwo">选择配音</div>
                        <div class="dubbingSelectBox between" @click="xzpyTap">
                            <el-image :src="require('@/assets/icon/drive02.png')" fit="cover" class="dubbingSelectImg" v-if="soundSelectedType" @click.stop="stopSound"></el-image>
                            <el-image :src="require('@/assets/icon/drive01.png')" fit="cover" class="dubbingSelectImg" v-else @click.stop="playSound"></el-image>
                            <div class="flex" style="flex: 1;">
                                <div class="dubbingSelectName oneRow">{{ soundSelected.voice_name2 }}</div>
                            </div>
                            <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="dubbingSelectIcon"></el-image>
                        </div>
                        <div class="ipTitleTwo">语速调节</div>
                        <el-select v-model="setvoice.speech_ratemoren" placeholder="请选择语速" class="ipIpt" @change="speedChange">
                            <el-option v-for="item in setvoice.speech_rate" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <div class="selectList spb">
                            <div class="selectBox column">
                                <div class="ipTitleTwo">选择感情</div>
                                <el-select v-model="setvoice.qingxumoren" placeholder="请选择感情" class="ipIpt" @change="emotionChange">
                                    <el-option v-for="item in setvoice.qingxu" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                            <div class="selectBox column">
                                <div class="ipTitleTwo">语调调节</div>
                                <el-select v-model="setvoice.pitch_ratemoren" placeholder="请选择语调" class="ipIpt" @change="toneChange">
                                    <el-option v-for="item in setvoice.pitch_rate" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="ipTitleTwo">音量调节</div>
                        <div class="sliderBox">
                            <el-slider v-model="setvoice.volumemoren" :min="setvoice.volume.xiao || 0" :max="setvoice.volume.da || 100"></el-slider>
                        </div>
                        <div class="ipTitleBox between">
                            <div class="align">
                                <div class="ipTitleIcon"></div>
                                <div class="ipTitle">生成配音效果</div>
                            </div>
                            <div class="align" v-if="dubbingUrl != ''">
                                <div class="ipDel" @click="delDubbing == ''">删除</div>
                                <!-- <div class="ipChange">修改</div> -->
                            </div>
                        </div>
                        <div class="areaBox column" v-loading="dubbingLoading" element-loading-text="拼命生成中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-if="dubbingUrl == ''">
                            <el-image :src="require('@/assets/icon/drive04.png')" fit="cover" class="noneImg"></el-image>
                            <div class="noneText">暂无生成效果</div>
                        </div>
                        <div class="dubbingSelectBox align" v-else>
                            <el-image :src="require('@/assets/icon/drive02.png')" fit="cover" class="dubbingSelectImg" v-if="dubbingType" @click="stopDubbing"></el-image>
                            <el-image :src="require('@/assets/icon/drive01.png')" fit="cover" class="dubbingSelectImg" v-else @click="playDubbing"></el-image>
                            <div class="effectBox">
                                <div class="effectName oneRow">{{ dubbingName }}</div>
                                <!-- <div class="effectName effectTime">12:03</div> -->
                            </div>
                        </div>
                        <div class="ipBtnBoxTwo center" @click="dubbingTap">
                            <div class="ipBtn">生成音频</div>
                            <el-image :src="require('@/assets/icon/star04.png')" fit="cover" class="ipBtnIcon"></el-image>
                            <div class="ipBtn">
                                <div class="ipBtn">{{ ipData.yinpinshengcheng }}</div>
                             </div>
                        </div>
                        <div class="ipTitleBox align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">选择数字人</div>
                        </div>
                        <div class="ipTitleTwo" style="margin-top: 8px;">系统将尽量匹配你选定的人出镜，丰富视频表现力。</div>
                        <div class="ipBtnList spb">
                            <div class="ipBtnBox center" @click="newDigitalDrawer = true">
                                <div class="ipBtn">+ 创建新数字人</div>
                            </div>
                        </div>
                        <div class="dubbingSelectBox between" @click="digitalPopup = true">
                            <div class="dubbingSelectName oneRow">{{ digitalSelected.name || '' }}</div>
                            <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="dubbingSelectIcon"></el-image>
                        </div>
                        <div class="ipBtnBoxTwo center" @click="generateVideo">
                            <div class="ipBtn">生成口播视频</div>
                            <el-image :src="require('@/assets/icon/star04.png')" fit="cover" class="ipBtnIcon"></el-image>
                            <div class="ipBtn">
                                <div class="ipBtn">{{ ipData.shipinhecheng }}</div>
                            </div>
                        </div>
                        <div class="ipTitleTwo">视频预览效果</div>
                        <div class="areaBox column" style="width: calc(100% - 122px);padding: 108px 12px; " v-loading="textGenerateVideoLoading" element-loading-text="拼命生成中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-if="textGenerateVideoUrl == ''">
                            <el-image :src="require('@/assets/icon/drive04.png')" fit="cover" class="noneImg"></el-image>
                            <div class="noneText">暂无生成效果</div>
                        </div>
                        <div class="generateVideoBox" v-if="textGenerateVideoUrl != ''">
                            <video ref="textVideoPlayer" :src="textGenerateVideoUrl" controls="controls" width="100%" class="generateVideo"></video>
                        </div>
                        <div class="driveBtnList spb">
                            <div class="driveBtnLook" @click="previewVideo('textVideoPlayer')">预览</div>
                            <div class="driveBtnDownload center" @click="downloadVideo(textGenerateVideoUrl)">
                                <el-image :src="require('@/assets/icon/drive05.png')" fit="cover" class="driveBtnIcon"></el-image>
                                <div class="driveBtnText">下载</div>
                            </div>
                        </div>
                    </template>
                    <template v-if="driveActive == 1">
                        <div class="selectList spb">
                            <div class="selectBox column">
                                <div class="ipTitleTwo">上传声音</div>
                                <el-upload ref="soundUpload" accept="audio/*" action="/api/common/upload" :limit='1' :on-success="soundSuccess" :on-exceed="soundExceed" :before-upload="soundBeforeUpload" :show-file-list="false">
                                    <div class="soundBox between">
                                        <div class="soundTips">点击上传音频文件</div>
                                        <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="soundIcon"></el-image>
                                    </div>
                                </el-upload>
                            </div>
                            <div class="selectBox column">
                                <div class="ipTitleTwo">录音</div>
                                <div class="soundBox center" v-if="!recording" @click="startRecording">
                                    <el-image :src="require('@/assets/icon/drive06.png')" fit="cover" class="soundImg"></el-image>
                                    <div class="soundName oneRow">开始录音</div>
                                </div>
                                <div class="soundBox center" style="border: 1px solid #20F4AD;" v-else @click="stopRecording">
                                    <el-image :src="require('@/assets/icon/drive07.png')" fit="cover" class="soundImg"></el-image>
                                    <div class="soundName oneRow">结束录音</div>
                                </div>
                            </div>
                        </div>
                        <div class="ipTitleBox between" v-if="soundUrl != ''">
                            <div class="ipTitleThree">{{ isSound == 'sc' ? '上传声音' : isSound == 'ly' ? '录音文件' : '' }} </div>
                            <!-- <div class="align"> -->
                                <div class="ipDel">删除</div>
                                <!-- <div class="ipChange">修改</div> -->
                            <!-- </div> -->
                        </div>
                        <div class="dubbingSelectBox align" v-if="soundUrl != ''">
                            <el-image :src="require('@/assets/icon/drive01.png')" fit="cover" class="dubbingSelectImg"></el-image>
                            <div class="effectBox">
                                <div class="effectName oneRow">{{ soundName }}</div>
                                <!-- <div class="effectName effectTime">12:03</div> -->
                            </div>
                        </div>
                        <div class="ipTitleBox align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">选择数字人</div>
                        </div>
                        <div class="ipTitleTwo" style="margin-top: 8px;">系统将尽量匹配你选定的人出镜，丰富视频表现力。</div>
                        <div class="ipBtnList spb">
                            <div class="ipBtnBox center" @click="newDigitalDrawer = true">
                                <div class="ipBtn">+ 创建新数字人</div>
                            </div>
                        </div>
                        <div class="dubbingSelectBox between"@click="digitalPopup = true">
                            <div class="dubbingSelectName oneRow">{{ digitalSelected.name || '' }}</div>
                            <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="dubbingSelectIcon"></el-image>
                        </div>
                        <div class="ipBtnBoxTwo center"@click="generateVideo">
                            <div class="ipBtn">生成口播视频</div>
                            <el-image :src="require('@/assets/icon/star04.png')" fit="cover" class="ipBtnIcon"></el-image>
                            <div class="ipBtn">{{ ipData.shipinhecheng }}</div>
                        </div>
                        <div class="ipTitleTwo">视频预览效果</div>
                        <div class="areaBox column" style="width: calc(100% - 122px);padding: 108px 12px;" v-loading="audioGenerateVideoLoading" element-loading-text="拼命生成中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-if="audioGenerateVideoUrl == ''">
                            <el-image :src="require('@/assets/icon/drive04.png')" fit="cover" class="noneImg"></el-image>
                            <div class="noneText">暂无生成效果</div>
                        </div>
                        <div class="generateVideoBox" v-if="audioGenerateVideoUrl != ''">
                            <video ref="audioVideoPlayer" :src="audioGenerateVideoUrl" controls="controls" width="100%" class="generateVideo"></video>
                        </div>
                        <div class="driveBtnList spb">
                            <div class="driveBtnLook" @click="previewVideo('audioVideoPlayer')">预览</div>
                            <div class="driveBtnDownload center" @click="downloadVideo(audioGenerateVideoUrl)">
                                <el-image :src="require('@/assets/icon/drive05.png')" fit="cover" class="driveBtnIcon"></el-image>
                                <div class="driveBtnText">下载</div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="ipBox column">
                    <div class="ipTopBox column">
                        <div class="ipTop">03 智能剪辑</div>
                        <el-image :src="require('@/assets/icon/ip01.png')" fit="cover" class="ipTopIcon"></el-image>
                    </div>
                    <div class="ipTitleBox between">
                        <div class="align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">视频地址</div>
                        </div>
                        <div class="align" v-if="videoUrl != ''">
                            <div class="ipDel" @click="videoUrl = ''">删除</div>
                            <!-- <div class="ipChange">修改</div> -->
                        </div>
                    </div>
                    <div class="upVideoBox" v-if="videoUrl == ''">
                         <el-upload ref="jjVideoUpload" accept="video/*" action="/api/common/upload" :limit='1' :on-success="jjVideoSuccess" :on-exceed="jjVideoExceed" :before-upload="jjVideoBeforeUpload" :show-file-list="false">
                            <div class="upVideo">点击上传视频</div>
                        </el-upload>
                    </div>
                    <video :src="videoUrl" controls="controls" class="videoBox" v-if="videoUrl != ''"></video>
                    <div class="ipTitleBox align">
                        <div class="ipTitleIcon"></div>
                        <div class="ipTitle">字幕模板</div>
                    </div>
                    <div class="dubbingSelectBox mt12 between" @click="subtitlesPopup = true">
                        <div class="dubbingSelectName oneRow" v-if="subtitles.length > 0">{{ subtitles[subtitlesActive].name}}</div>
                        <div class="dubbingSelectName oneRow" style="height: 30px;" v-else></div>
                        <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="dubbingSelectIcon"></el-image>
                    </div>
                    <div class="ipTitleBox align">
                        <div class="ipTitleIcon"></div>
                        <div class="ipTitle">背景音乐</div>
                    </div>
                    <div class="ipTabList between">
                        <div :class="['ipTab',musicActive == index ? 'ipTabOn' : '']" v-for="(item,index) in musicTab" :key="index" @click="musicActive = index">{{ item }}</div>
                    </div>
                    <div class="dubbingSelectBox mt12 between" v-if="musicActive == 0" @click="bgmPopup = true">
                        <div class="dubbingSelectName oneRow" v-if="bgmList.length > 0" :style="{'color': bgmActive == -1 ? '#606266' : '#000'}">{{ bgmActive == -1 ? '请选择背景音乐' : bgmList[bgmActive].title || '' }}</div>
                        <div class="dubbingSelectName oneRow" style="height: 30px;" v-else></div>
                        <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="dubbingSelectIcon"></el-image>
                    </div>
                    <div class="upMusic">
                        <el-upload ref="musicUpload" accept="audio/*" action="/api/common/upload" :on-success="musicSuccess" :before-upload="musicBeforeUpload" :show-file-list="false" v-if="musicActive == 1">
                            <div class="dubbingSelectBox mt12 between">
                                <div class="dubbingSelectName oneRow" style="color: #6C6E73;" v-if="musicUrl == ''">点击上传音频文件</div>
                                <div class="dubbingSelectName oneRow" style="color: #000;" v-else>{{ musicName }}</div>
                                <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="dubbingSelectIcon"></el-image>
                            </div>
                        </el-upload>
                    </div>
                    <div class="ipTitleTwo" v-if="bgmActive != '-1'">音量调节</div>
                    <div class="sliderBox" v-if="bgmActive != '-1'">
                        <el-slider v-model="musicVolume" :min="1" :max="10"></el-slider>
                    </div>
                    <div class="ipTitleBox pt12 align">
                        <div class="ipTitleIcon"></div>
                        <div class="ipTitle">标题</div>
                    </div>
                    <div class="ipTitleTwo">主标题</div>
                    <el-input placeholder="视频主标题" v-model="videoTitle" maxlength="15" show-word-limit class="ipIpt"></el-input>
                    <div class="ipTitleTwo">副标题</div>
                    <el-input placeholder="视频副标题" v-model="videoDesc" maxlength="15" show-word-limit class="ipIpt"></el-input>
                    <div class="ipTitleTwo">视频标题时长</div>
                    <div class="titleTimeTabList flex">
                        <div :class="['titleTimeTab',titleTimeActive == index ? 'titleTimeTabOn' : '']" v-for="(item,index) in titleTimeTab" :key="index" @click="titleTimeActive = index">{{ item.name }}</div>
                    </div>
                    <div class="ipBtnList spb" v-if="driveText != ''">
                        <div class="ipBtnBox center" @click="generateTitleTopic">
                            <div class="ipBtn">一键生成主标题副标题</div>
                        </div>
                    </div>
                    <div class="ipTitleBox pdt12 between">
                        <div class="align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">实景混剪</div>
                        </div>
                        <el-switch v-model="editSwitch" active-color="#13ce66" inactive-color="#F8F9FA"></el-switch>
                    </div>
                    <template v-if="editSwitch">
                        <div class="ipTitleTwo" style="margin-top: 8px;width: 100%;">上传店铺和产品视频可用于爆款智能混剪。</div>
                        <div class="dubbingSelectBox mt12 between" @click="editPopup = true">
                            <div class="dubbingSelectName" style="color: #606266;" v-if="editActiveName == ''">请选择混剪视频</div>
                            <div class="dubbingSelectName oneRow" v-else>{{ editActiveName }}</div>
                            <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="dubbingSelectIcon"></el-image>
                        </div>
                        <div class="ipTitleTwo">取片间隔</div>
                        <div class="ipTitleFour">间隔越长分的片段越少，越短分的片段越多。</div>
                        <el-select v-model="intervalValue" placeholder="请选择取片间隔" class="ipIpt" @change="intervalChange">
                            <el-option v-for="item in intervalList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <div class="ipTitleTwo">混剪模式</div>
                        <div class="ipTitleFour">数字人和实景视频片段交叉混剪。</div>
                        <div class="titleTimeTabList flex">
                            <div :class="['titleTimeTab',editActive == index ? 'titleTimeTabOn' : '']" v-for="(item,index) in editTab" :key="index" @click="editActive = index">{{ item }}</div>
                        </div>
                    </template>
                    <div class="ipBtnBoxTwo center" @click="immediatelyClip">
                        <div class="ipBtn">立即剪辑</div>
                        <el-image :src="require('@/assets/icon/star04.png')" fit="cover" class="ipBtnIcon"></el-image>
                        <div class="ipBtn">{{ ipData.bgmzimu }}</div>
                    </div>
                    <div class="selectList spb">
                        <div class="effectBox">
                            <div class="ipTitleTwo">封面预览</div>
                            <div class="areaBox column" style="padding: 56px 12px;" v-loading="editVideoLoading" element-loading-text="拼命生成中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8) "v-if="editImgUrl == ''">
                                <el-image :src="require('@/assets/icon/drive04.png')" fit="cover" class="effectNoneImg"></el-image>
                                <div class="noneText">暂无生成效果</div>
                            </div>
                            <div class="editVideoBox" v-else>
                                <el-image :src="editImgUrl" fit="cover" class="editVideo"></el-image>
                            </div>
                            <div class="driveBtnList spb">
                                <div class="driveBtnLook" style="width: 52px;margin-right: 8px;" @click="previewImage(editImgUrl)">预览</div>
                                <div class="driveBtnDownload center" @click="downloadVideo(editImgUrl)">
                                    <el-image :src="require('@/assets/icon/drive05.png')" fit="cover" class="driveBtnIcon"></el-image>
                                    <div class="driveBtnText">下载</div>
                                </div>
                            </div>
                        </div>
                        <div class="effectBox">
                            <div class="ipTitleTwo">成品视频</div>
                            <div class="areaBox column" style="padding: 56px 12px;" v-loading="editVideoLoading" element-loading-text="拼命生成中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-if="editVideoUrl == ''">
                                <el-image :src="require('@/assets/icon/drive04.png')" fit="cover" class="effectNoneImg"></el-image>
                                <div class="noneText">暂无生成效果</div>
                            </div>
                            <div class="editVideoBox" v-else>
                                <video ref="editVideoPlayer" :src="editVideoUrl" controls="controls" width="100%" class="editVideo"></video>
                            </div>
                            <div class="driveBtnList spb">
                                <div class="driveBtnLook" style="width: 52px;margin-right: 8px;" @click="previewVideo('editVideoPlayer')">预览</div>
                                <div class="driveBtnDownload center" @click="downloadVideo(editVideoUrl)">
                                    <el-image :src="require('@/assets/icon/drive05.png')" fit="cover" class="driveBtnIcon"></el-image>
                                    <div class="driveBtnText">下载</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ipBox column">
                    <div class="ipTopBox column">
                        <div class="ipTop">04 自动发布</div>
                        <el-image :src="require('@/assets/icon/ip01.png')" fit="cover" class="ipTopIcon"></el-image>
                    </div>
                    <div class="ipTitleBox between">
                        <div class="align">
                            <div class="ipTitleIcon"></div>
                            <div class="ipTitle">视频地址</div>
                        </div>
                        <div class="align" v-if="fbVideoUrl != ''">
                            <div class="ipDel" @click="fbVideoUrl = ''">删除</div>
                            <!-- <div class="ipChange">修改</div> -->
                        </div>
                    </div>
                    <div class="upVideoBox" v-if="fbVideoUrl == ''">
                         <el-upload ref="fbVideoUpload" accept="video/*" action="/api/common/upload" :limit='1' :on-success="fbVideoSuccess" :on-exceed="fbVideoExceed" :before-upload="fbVideoBeforeUpload" :show-file-list="false">
                            <div class="upVideo">点击上传视频</div>
                        </el-upload>
                    </div>
                    <video :src="fbVideoUrl" controls="controls" class="videoBox" v-if="fbVideoUrl != ''"></video>
                    <div class="ipTitleBox align">
                        <div class="ipTitleIcon"></div>
                        <div class="ipTitle">发布设置</div>
                    </div>
                    <el-select clearable v-model="languageValue" placeholder="请选择发布账号" class="ipIpt">
                        <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <div class="ipTitleBox pdt12 align">
                        <div class="ipTitleIcon"></div>
                        <div class="ipTitle">标题</div>
                    </div>
                    <div class="ipTitleTwo">视频标题</div>
                    <el-input placeholder="视频标题" v-model="fbVideoTitle" maxlength="16" show-word-limit class="ipIpt"></el-input>
                    <div class="ipTitleTwo">视频话题</div>
                    <el-input placeholder="视频话题标签" v-model="fbVideoDesc" class="ipIpt"></el-input>
                    <div class="ipBtnList spb">
                        <div class="ipBtnBox center">
                            <div class="ipBtn">一键生成爆款标题话题</div>
                        </div>
                    </div>
                    <div class="ipTitleBox pdt12 align">
                        <div class="ipTitleIcon"></div>
                        <div class="ipTitle">选择发布的平台</div>
                    </div>
                    <div class="ipTitleFour" style="width: 100%;">支持多选</div>
                    <div class="titleTimeTabList mt12 flex">
                        <div :class="['titleTimeTab column',item.active ? 'titleTimeTabOn' : '']" v-for="(item,index) in platformTab" :key="index" @click="item.active = !item.active">
                            <el-image :src="item.img" fit="cover" class="platformTabImg"></el-image>
                            <div class="platformTabText">{{ item.name }}</div>
                        </div>
                    </div>
                    <div class="ipBtnBoxTwo center" style="margin-top: 24px;">
                        <div class="ipBtn">一键发布</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- AI生成 -->
        <div class="column" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '1' && selectedHcid.hcid != '18'">
            <div class="workList" ref="workList">
                <div v-if="workShow">
                    <div class="workItem" v-for="(item,index) in workData" :key="index" v-if="workData.length > 0">
                        <div class="reverse">
                            <div class="workImages">
                                <el-image v-for="(img, imgIndex) in item.newImgs.slice(0, 3)" :key="imgIndex" :src="img" fit="cover" class="workImage" :style="getImageStyle(imgIndex)"></el-image>
                            </div>
                        </div>
                        <div class="reverse">
                            <div class="workText">{{ item.prompt }}</div>
                        </div>
                        <div class="reverse" style="margin-top: 4px;">
                            <div class="againBox align" @click="reEditClick(item)">
                                <el-image :src="require('@/assets/icon/work01.png')" fit="cover" class="againIcon"></el-image>
                                <div class="againText">重新编辑</div>
                            </div>
                            <div class="workTime">{{ item.create_time }}</div>
                        </div>
                        <div class="workBox" @click="workClick(item.jieguo,item.status,item.download,item.type)">
                            <div class="workStatusBox" v-if="item.status == '2' && item.type == '1'">
                                <el-image :src="require('@/assets/icon/work07.png')" fit="cover" class="statusIcon"></el-image>
                            </div>
                            <div class="workStatusBox" v-if="item.status != '2'">
                                <el-image :src="item.status == '1' ? require('@/assets/icon/work05.gif') : require('@/assets/icon/work06.png')" fit="cover" class="statusIcon"></el-image>
                                <div class="statusName">{{item.status == '1' ? '生成中...' : '生成失败'}}</div>
                            </div>
                            <el-image :src="item.imgs" fit="cover" class="workImg" v-if="item.imgs != ''"></el-image>
                        </div>
                        <div class="workTipsBox align">
                            <el-image :src="require('@/assets/icon/work08.png')" fit="cover" class="workTipsIcon"></el-image>
                            <div class="workTips">内容由AI生成,仅供参考</div>
                        </div>
                        <div class="workBtnList align">
                            <div class="workBtnBox align" @click="againClick(item)">
                                <el-image :src="require('@/assets/icon/work02.png')" fit="cover" class="workBtnIcon"></el-image>
                                <div class="workBtn">重新生成</div>
                            </div>
                            <div class="workBtnBox align" @click="downloadClick(item.jieguo, item.status,item.download)">
                                <el-image :src="require('@/assets/icon/work03.png')" fit="cover" class="workBtnIcon"></el-image>
                                <div class="workBtn">下载</div>
                            </div>
                            <div class="workBtnBox align" @click="deleteClick(item.order_num)">
                                <el-image :src="require('@/assets/icon/work04.png')" fit="cover" class="workBtnIcon"></el-image>
                                <div class="workBtn">删除</div>
                            </div>
                        </div>
                    </div>
                    <div class="column" v-if="workData.length == 0">
                        <div class="dreamerNoData column">
                            <el-image :src="dreamerData.pcimg" fit="cover" class="dreamerNoImg"></el-image>
                            <div class="dreamerNoText">{{dreamerData.titlepc}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="generateBox" v-if="videoGenerateIndex !== ''">
                <div class="flex" v-if="videoGenerateIndex == '-1' || videoGenerate[videoGenerateIndex].model[modelActive].diagram_type == '1'">
                    <el-upload ref="videoUpload" action="/api/common/upload" list-type="picture-card" :limit='10' :file-list="videoFileList" :on-success="videoSuccess" :on-remove="videoRemove">
                        <div class="generateUpImg">
                            <el-image :src="require('@/assets/icon/work10.png')" fit="cover" class="addIcon"></el-image>
                            <div class="addName">添加图片</div>
                        </div>
                    </el-upload>
                </div>
                <div class="flex" v-if="videoGenerateIndex != '-1' &&videoGenerate[videoGenerateIndex].model[modelActive].diagram_type == '0'">
                    <el-upload class="generateUpImg" ref="firstFrameUpload" action="/api/common/upload" :limit='1' :show-file-list="false" :file-list="firstFrameFileList" :on-success="firstSuccess" :on-error="firstError">
                        <el-image v-if="firstFrame != ''" :src="firstFrame" fit="cover" class="generateImg"></el-image>
                        <div class="generateUpImgBox" v-else>
                            <el-image :src="require('@/assets/icon/work10.png')" fit="cover" class="addIcon"></el-image>
                            <div class="addName">添加首帧</div>
                        </div>
                    </el-upload>
                    <el-upload class="generateUpImg" ref="lastFrameUpload" action="/api/common/upload" :limit='1' :show-file-list="false" :file-list="lastFrameFileList" :on-success="lastSuccess">
                        <el-image v-if="lastFrame != ''" :src="lastFrame" fit="cover" class="generateImg"></el-image>
                        <div class="generateUpImgBox" v-else>
                            <el-image :src="require('@/assets/icon/work10.png')" fit="cover" class="addIcon"></el-image>
                            <div class="addName">添加尾帧</div>
                        </div>
                    </el-upload>
                </div>
                <el-input type="textarea" :rows="3" :placeholder="videoGenerateIndex == '-1' ? imgGenerate[imgGenerateIndex].imgtext : videoGenerate[videoGenerateIndex].imgtext" v-model="textarea" class="generateArea"></el-input>
                <div class="generateBtnBox between">
                    <div class="align">
                        <div class="generateSelest generateModelSelest align" v-if="videoGenerateIndex != '-1'">
                            <el-image :src="require('@/assets/icon/work11.png')" fit="cover" class="selectIcon"></el-image>
                            <div class="selectName">{{ videoGenerate[videoGenerateIndex].model[modelActive].model_desc }}</div>
                            <div class="generateOptionPos generateModelOptionPos">
                                <div class="generateOptionBox">
                                    <div class="optionType">选择模型</div>
                                    <div :class="['optionModelBox align', index == modelActive ? 'optionModelBoxOn' : '']" v-for="(item,index) in videoGenerate[videoGenerateIndex].model" :key="index" @click="modelActive = index">
                                        <div class="optionModel">{{ item.model_desc }}</div>
                                        <div class="modelStatus">{{ item.status_des }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="generateSelest generateTimeSelest align">
                            <el-image :src="require('@/assets/icon/work12.png')" fit="cover" class="selectMiniIcon"></el-image>
                            <div class="selectName">{{ videoGenerateIndex == '-1' ? imgGenerate[imgGenerateIndex].model[modelActive].duration_spec[timeActive].duration : videoGenerate[videoGenerateIndex].model[modelActive].duration_spec[timeActive].duration }}</div>
                            <div class="selectLine"></div>
                            <div class="selectName">{{ videoGenerateIndex == '-1' ? imgGenerate[imgGenerateIndex].model[modelActive].ratio_spec[proportionActive].ratio_size : videoGenerate[videoGenerateIndex].model[modelActive].ratio_spec[proportionActive].ratio_size }}</div>
                            <el-image :src="require('@/assets/icon/work13.png')" fit="cover" class="selectMiniIcon" style="margin-left: 4px;"></el-image>
                            <div class="generateOptionPos generateTimeOptionPos">
                                <div class="generateOptionBox">
                                    <div class="optionType">{{ videoGenerateIndex == '-1' ? '清晰度' : '时长选择' }}</div>
                                    <div class="optionList align">
                                        <div :class="['optionBox center', index == timeActive ? 'optionBoxOn' : '']" v-for="(item,index) in videoGenerateIndex == '-1' ? imgGenerate[imgGenerateIndex].model[modelActive].duration_spec : videoGenerate[videoGenerateIndex].model[modelActive].duration_spec" :key="index" @click="timeActive = index">
                                            <div class="optionName">{{ item.duration }}</div>
                                            <div :class="['timeStatus',item.style == '0' ? '' : 'timeStatusOn']">{{ item.quality }}</div>
                                        </div>
                                    </div>
                                    <div class="optionType" style="margin-top: 16px;">生成比例</div>
                                    <div class="optionList align">
                                        <div :class="['optionBox center column', index == proportionActive ? 'optionBoxOn' : '']" v-for="(item,index) in videoGenerateIndex == '-1' ? imgGenerate[imgGenerateIndex].model[modelActive].ratio_spec : videoGenerate[videoGenerateIndex].model[modelActive].ratio_spec" :key="index" @click="proportionActive = index">
                                            <el-image :src="item.ratio_icon_pc" fit="cover" class="optionIcon"></el-image>
                                            <div class="optionName">{{ item.ratio_size }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="generateSelest align">
                            <el-image :src="require('@/assets/icon/star.png')" fit="cover" class="selectMiniIcon"></el-image>
                            <div class="selectName direct">一键生成脚本</div>
                        </div>
                    </div>
                    <div class="align">
                        <el-image :src="require('@/assets/icon/star02.png')" fit="cover" class="pointsIcon"></el-image>
                        <div class="pointsText">{{ videoGenerateIndex == '-1' ? imgGenerate[imgGenerateIndex].model[modelActive].duration_spec[timeActive].true_points : videoGenerate[videoGenerateIndex].model[modelActive].duration_spec[timeActive].true_points }}</div>
                        <el-image :src="require('@/assets/icon/work14.png')" fit="cover" class="selectBtn" @click="generateBtnTap"></el-image>
                    </div>
                </div>
            </div>
        </div>
        <!-- 基础信息 -->
        <div class="geoBox" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '2' && selectedHcid.hcid == '11'">
            <div class="geoTopTitle">基础信息</div>
            <div class="geoTopTips">自动读取品牌基础信息、品牌业务、竞争对手、内容规则等，支持随时修改</div>
            <div class="basicBox">
                <div class="basicScroll">
                    <div class="basicItem flex">
                        <div class="basicTitle"><span class="basicTitleIcon">*</span>品牌名称</div>
                        <el-input placeholder="请输入品牌名称" v-model="basicName" maxlength="30" show-word-limit class="basicIpt"></el-input>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">品牌网站</div>
                        <el-input placeholder="例如 xiaodianke.com" v-model="basicWeb" maxlength="100" show-word-limit class="basicIpt"></el-input>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">品牌图片</div>
                        <div>
                            <el-upload ref="basicImgUpload" class="basicImgBox" action="/api/common/upload" :limit='1' :show-file-list="false" :file-list="basicImgFileList" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                                <el-image v-if="basicImg" :src="basicImg" fit="cover" class="basicImg"></el-image>
                                <div class="basicImgNoBox" v-else>
                                    <el-image :src="require('@/assets/icon/work10.png')" fit="cover" class="basicIcon"></el-image>
                                    <div class="basicImgNoText">上传图片</div> 
                                </div>
                            </el-upload>
                            <div class="basicTips">选填，建议 88x88 或正方形，不超过 2MB;未上传时品牌信息处显示品牌名称首字</div>
                        </div>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">品牌行业</div>
                        <el-cascader  placeholder="请选择行业" class="industryOption" v-model="industryValue" :options="industry" :props="{ expandTrigger: 'hover' }"  :show-all-levels="false"></el-cascader>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">品牌业务介绍</div>
                        <div>
                            <el-input type="textarea" :rows="4" placeholder="请输入品牌业务介绍" v-model="basicBusiness" maxlength="2048" show-word-limit class="basicArea"></el-input>
                            <div class="basicTips">详细描述品牌价值主张、品牌业务介绍</div>
                        </div>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">竞争对手</div>
                        <div>
                            <el-button @click="addCompetitor">+ 新增竞争对手</el-button>
                            <div class="basicTips">列出你的主要竞争对手,或者你的受众可能会考虑作为替代选项的其他品牌,最多可设置15 个</div>
                            <div class="competitorBox align" v-for="(item, index) in competitor" :key="index">
                                <el-image :src="item.logo" fit="cover" class="competitorIcon" v-if="item.logo != ''"></el-image>
                                <div class="competitorTextIcon" v-else>{{item.name[0]}}</div>
                                <div class="competitorName oneRow">{{item.name}}</div>
                                <el-button @click="competitorEdit(index)" type="text" size="small">编辑</el-button>
                                <el-button @click="competitorDel(index)" type="text" size="small" style="color: #F84025;margin-left: 16px;">删除</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">内容风格</div>
                        <div>
                            <el-input type="textarea" :rows="4" placeholder="请输入内容风格" v-model="basicStyle" maxlength="4096" show-word-limit class="basicArea"></el-input>
                            <div class="basicTips">概括适合品牌定位的内容风格(如:专业严谨风格、轻松幽默风格、小红书风格等)</div>
                        </div>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">内容规则</div>
                        <div>
                            <el-input type="textarea" :rows="4" placeholder="请输入内容规则" v-model="basicRule" maxlength="4096" show-word-limit class="basicArea"></el-input>
                            <div class="basicTips">列出具体的内容写作规范、注意事项(如:避免使用绝对词、多用主动语态等)</div>
                        </div>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">行动号召文案</div>
                        <div>
                            <el-input type="textarea" :rows="4" placeholder="请输入行动号召文案" v-model="basicCall" maxlength="4096" show-word-limit class="basicArea"></el-input>
                            <div class="basicTips">提供一个明确的客户行动号召语(如:立即咨询、了解更多等)</div>
                        </div>
                    </div>
                    <div class="basicItem flex">
                        <div class="basicTitle">获客联系方式</div>
                        <div>
                            <el-input placeholder="请填写获客联系方式" v-model="basicPhone" maxlength="256" show-word-limit class="basicIpt"></el-input>
                            <div class="basicTips">提供一个获客联系方式(如:电话号码等)</div>
                        </div>
                    </div>
                </div>
                <div class="basicBtnBox">
                    <el-button type="primary" @click="basicBtnTap">保存信息</el-button>
                </div>
            </div>
        </div>
        <!-- 目标用户 -->
        <div class="geoBox" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '2' && selectedHcid.hcid == '12'">
            <div class="geoTopTitle">目标用户</div>
            <div class="geoTopTips">自动生成品牌目标用户，支持自定义目标用户的品牌偏好、核心需求、地域</div>
            <div class="geoSearchBox between">
                <el-input placeholder="搜索目标用户名称" v-model="target" class="targetIpt" @keyup.enter.native="getTargetList(true)">
                    <template #suffix>
                        <i class="el-icon-search targetIptIcon" @click="getTargetList(true)"></i>
                    </template>
                </el-input>
                <el-button type="primary" @click="addTargetTap">+新增目标用户</el-button>
            </div>
            <div class="targetList">
                <div class="targetBox" v-for="(item, index) in targetData.list" :key="index">
                    <div class="between">
                        <div class="targetName oneRow">{{ item.image_name }}</div>
                        <div class="align">
                            <div class="targetBtn targetDelete" @click="targetDeleteTap(item.id)">删除</div>
                            <div class="targetBtn targetEdit" @click="targetEditTap(item)">编辑</div>
                        </div>
                    </div>
                    <div class="targetTextBox">
                        <div class="targetText">{{ item.image_desc }}</div>
                    </div>
                    <div class="preference oneRow" v-for="(el,ii) in item.dimensions" :key="ii"><span class="preferenceSpan">{{ el.name }}: </span>{{ el.desc }}</div>
                </div>
            </div>
            <div class="paginationBox reverse" v-if="targetData.list.length > 0">
                <el-pagination background
                    @size-change="targetSizeChange"
                    @current-change="targetCurrentChange"
                    :current-page="targetPage"
                    :page-sizes="[20, 40, 60, 80]"
                    :page-size="targetPageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="targetData.total">
                </el-pagination>
            </div>
        </div>
        <!-- 知识库 -->
        <div class="geoBox" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '2' && selectedHcid.hcid == '13'">
            <div class="geoTopTitle">知识库</div>
            <div class="geoTopTips">基于品牌真实信息构建知识图谱，支持上传本地知识库、飞书文档、公众号内容授权、网页内容等形式</div>
            <div class="geoSearchBox between">
                <el-input placeholder="搜索知识库" v-model="knowledge" class="targetIpt" @keyup.enter.native="knowledgeTap">
                    <template #suffix>
                        <i class="el-icon-search targetIptIcon" @click="knowledgeTap"></i>
                    </template>
                </el-input>
                <el-button type="primary" @click="knowledgePopup = true">+上传知识库</el-button>
            </div>
            <div class="knowledgeTabBox">
                <el-table :data="knowledgeTabData.list" style="width: 100%"  height="calc(100vh - 240px)">
                    <el-table-column prop="name" label="标题" min-width="36%"></el-table-column>
                    <el-table-column prop="type_name" label="知识库类型" min-width="12%">
                        <template slot-scope="scope">
                            <el-tag type="success" disable-transitions color="#EBF9F4" :hit="true">{{scope.row.type_name}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="file_size_format" label="文件大小" min-width="12%"></el-table-column>
                    <el-table-column prop="create_time" label="上传时间" min-width="22%"></el-table-column>
                    <el-table-column prop="operation" label="操作" min-width="18%">
                        <template slot-scope="scope">
                            <el-button @click="tabDelClick(scope)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                    <div slot="empty" class="empty">
                        <el-image :src="require('@/assets/icon/noKnowledge.png')" fit="cover" class="emptyImg"></el-image>
                        <div class="emptyText">暂无知识库数据</div>
                    </div>
                </el-table>
                <div class="paginationBox reverse" v-if="knowledgeTabData.list.length > 0">
                    <el-pagination background
                        @size-change="contentSizeChange"
                        @current-change="contentCurrentChange"
                        :current-page="knowledgePage"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="knowledgePageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="knowledgeTabData.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 内容生成 -->
        <div class="geoBox" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '2' && selectedHcid.hcid == '8'">
            <div v-if="contentCreate === ''">
                <div class="geoTopTitle">内容生成</div>
                <div class="geoTopTips">基于品牌真实信息、目标用户、知识库、用户意图，选择内容策略模版，自动生成结构化、易引用的高质量内容</div>
                <div class="geoSearchBox between">
                    <div class="align">
                        <el-input placeholder="搜索标题" v-model="contentKeyword" class="targetIpt" @keyup.enter.native="getContentList(true)">
                            <template #suffix>
                                <i class="el-icon-search targetIptIcon" @click="getContentList(true)"></i>
                            </template>
                        </el-input>
                        <el-select clearable v-model="contentTypeValue" placeholder="请选择状态" class="targetOption" @change="getContentList(true)">
                            <el-option v-for="item in contentType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-select clearable v-model="contentTemplateValue" placeholder="请选择模板" class="targetOption" @change="getContentList(true)">
                            <el-option v-for="item in templateData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="align">
                        <!-- <el-button type="primary" plain>内容规则</el-button> -->
                        <el-button type="primary" @click="templatePopup = true">+创建新内容</el-button>
                    </div>
                </div>
                <div class="contentTabBox">
                    <el-table :data="contentTabData.list" style="width: 100%" height="calc(100vh - 240px)">
                        <el-table-column prop="title" label="标题" min-width="26%"></el-table-column>
                        <el-table-column prop="brand_name" label="品牌" min-width="12%"></el-table-column>
                        <el-table-column prop="knowledge_base_name" label="知识库" min-width="12%"></el-table-column>
                        <el-table-column prop="template_name" label="模板" min-width="12%"></el-table-column>
                        <el-table-column prop="status_ch" label="状态" min-width="10%">
                            <template slot-scope="scope">
                                <el-tag type="success" disable-transitions color="#EBF9F4" :hit="true">{{scope.row.status_ch}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" label="上传时间" min-width="14%"></el-table-column>
                        <el-table-column prop="operation" label="操作" min-width="14%">
                            <template slot-scope="scope">
                                <el-button @click="contentExportClick(scope.row.download_url)" type="text" size="small">导出文章</el-button>
                                <el-button @click="contentEditClick(scope.row)" type="text" size="small">编辑</el-button>
                                <el-button @click="contentDelClick(scope.row.id)" type="text" size="small" style="color: #F84025;">删除</el-button>
                            </template>
                        </el-table-column>
                        <div slot="empty" class="contentEmpty">
                            <el-image :src="require('@/assets/icon/noKnowledge.png')" fit="cover" class="contentEmptyImg"></el-image>
                            <div class="contentEmptyText">暂无内容生成数据</div>
                        </div>
                    </el-table>
                    <div class="paginationBox reverse" v-if="contentTabData.list.length > 0">
                        <el-pagination background
                            @size-change="contentSizeChange"
                            @current-change="contentCurrentChange"
                            :current-page="contentPage"
                            :page-sizes="[20, 40, 60, 80]"
                            :page-size="contentPageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="contentTabData.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div class="configureContent" v-if="contentCreate !== '' && !generate">
                <div class="configureTop align">
                    <div class="backBox align" @click="contentBack()">
                        <el-image :src="require('@/assets/icon/back.png')" fit="cover" class="backIcon"></el-image>
                        <div class="backText">返回</div>
                    </div>
                     <el-alert title="请复核您生成的内容，确保符合《中华人民共和国广告法》等法律法规。若出现违法违规情形，将进行下线等处理，并报相关监管部门" type="warning" show-icon :closable="false"></el-alert>
                </div>
                <div class="configureBottom spb">
                    <div class="configureBox">
                        <div class="configureList">
                            <div class="configureTitle">内容配置</div>
                            <div class="configureTips">基于AI平台的引用癖好,生成品牌GEO内容</div>
                            <!-- <div class="configureSelectBox">
                                <div class="configureSelectTitle"><span class="configureSelectTitleIcon">*</span>优化单元</div>
                                <div class="configureSelectTextBox between">
                                    <div :class="['configureSelectText',createYhdy == '' ? 'configureSelectTextOn' : '']">{{ createYhdy == '' ? '未选择' : createYhdy }}</div>
                                    <el-image :src="require('@/assets/icon/down.png')" fit="cover" class="configureSelectTextIcon"></el-image>
                                </div>
                                <div class="configureSelectPos column">
                                    <el-input placeholder="搜索优化单元" v-model="createYhdyKey" class="configureSelectSearchIpt" @keyup.enter.native="createYhdySearchTap">
                                        <template #suffix>
                                            <i class="el-icon-search configureSelectSearchIcon" @click="createYhdySearchTap"></i>
                                        </template>
                                    </el-input>
                                    <div class="configureOptionBox">
                                        <div class="configureOption" v-for="(item, index) in 10" :key="index">优化单元{{ index + 1 }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="configureSelectBox">
                                <div class="configureSelectTitle"><span class="configureSelectTitleIcon">*</span>用户意图</div>
                                <div class="configureSelectTextBox between">
                                    <div :class="['configureSelectText',createYhyt == '' ? 'configureSelectTextOn' : '']">{{ createYhyt == '' ? '未选择' : createYhyt }}</div>
                                    <el-image :src="require('@/assets/icon/down.png')" fit="cover" class="configureSelectTextIcon"></el-image>
                                </div>
                            </div> -->
                            <div class="configureSelectBox" @click="createZskShow = !createZskShow">
                                <div class="configureSelectTitle"><span class="configureSelectTitleIcon">*</span>知识库</div>
                                <div class="configureSelectTextBox between">
                                    <div :class="['configureSelectText oneRow',createZskActiveName == '' ? 'configureSelectTextOn' : '']">{{ createZskActiveName == '' ? '未选择' : createZskActiveName }}</div>
                                    <el-image :src="require('@/assets/icon/down.png')" fit="cover" class="configureSelectTextIcon"></el-image>
                                </div>
                                <div class="configureSelectPos column" v-if="createZskShow" @click.stop="createZskShow = createZskShow">
                                    <el-input placeholder="搜索知识库" v-model="createZskKey" class="configureSelectSearchIpt" @keyup.enter.native="getCreateZsk">
                                        <template #suffix>
                                            <i class="el-icon-search configureSelectSearchIcon" @click="getCreateZsk"></i>
                                        </template>
                                    </el-input>
                                    <div class="configureOptionBox">
                                        <div class="configureOption align" v-for="(item, index) in createZskData" :key="index" @click="createZskTap(index)">
                                            <el-image :src="require(item.active ? '@/assets/icon/activeOn.png' : '@/assets/icon/active.png')" fit="cover" class="configureOptionIcon"></el-image>
                                            <div class="configureOptionName">{{ item.label }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="configureSelectBox">
                                <div class="configureSelectTitle"><span class="configureSelectTitleIcon">*</span>目标用户</div>
                                <div class="configureSelectTextBox between">
                                    <div :class="['configureSelectText',createMbyhActive == '-1' ? 'configureSelectTextOn' : '']">{{ createMbyhActive == '-1' ? '未选择' : createMbyhData[createMbyhActive].label }}</div>
                                    <el-image :src="require('@/assets/icon/down.png')" fit="cover" class="configureSelectTextIcon"></el-image>
                                </div>
                            </div> -->
                            <!-- <div class="configureSelectBox">
                                <div class="configureSelectTitle"><span class="configureSelectTitleIcon">*</span>AI平台</div>
                                <div class="configureSelectTextBox between">
                                    <div class="configureSelectText configureSelectTextOn" v-if="createAIActiveData.length == 0">未选择</div>
                                    <div class="createAIList flex" v-else></div>
                                    <el-image :src="require('@/assets/icon/down.png')" fit="cover" class="configureSelectTextIcon"></el-image>
                                </div>
                                <div class="aiSelectPos">
                                    <div :class="['aiOptionBox align',item.active ? 'aiOptionBoxOn' : '']" v-for="(item, index) in createAIData" :key="index" @click="aiOptionTap(index)">
                                        <el-image :src="require(item.active ? '@/assets/icon/activeOn.png' : '@/assets/icon/active.png')" fit="cover" class="aiOptionIcon"></el-image>
                                        <el-image :src="item.icon" fit="cover" class="aiOptionHead"></el-image>
                                        <div class="aiOptionName">{{ item.label }}</div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="configureTitle" style="margin-top: 44px;">文章标题</div>
                            <div class="configureTips">根据内容配置将为您推荐文章标题,您也可自己定义文章标题</div>
                            <div class="configureSelectBox">
                                <div class="configureSelectTitle"><span class="configureSelectTitleIcon">*</span>文章标题</div>
                                <el-input placeholder="请输入文章标题" v-model="createTitle" class="configureSelectIpt"></el-input>
                            </div>
                        </div>
                        <div class="configureBtnBox center" @click="configureBtnTap">
                            <el-image :src="require('@/assets/icon/star03.png')" fit="cover" class="configureBtnIcon"></el-image>
                            <div class="configureBtnText">生成内容</div>
                        </div>
                    </div>
                    <div class="noConfigureBox">
                        <el-image :src="require('@/assets/icon/noCreate.png')" fit="cover" class="noConfigureImg"></el-image>
                        <div class="noConfigureText">基于企业真实信息生成品牌GEO内容</div>
                        <div class="noConfigureTips">请先在左侧输入内容配置、文章标题</div>
                    </div>
                </div>
            </div>
            <div class="configureContent" v-if="contentCreate !== '' && generate">
                <div class="generateTop between">
                    <div class="align">
                        <div class="backBox align" @click="generateBack()">
                            <el-image :src="require('@/assets/icon/back.png')" fit="cover" class="backIcon"></el-image>
                            <div class="backText">返回</div>
                        </div>
                        <div style="flex: 1;">
                            <div class="generateTitle">{{ createTitle }}</div>
                            <div class="align">
                                <el-image :src="require('@/assets/icon/tips.png')" fit="cover" class="generateTipsIcon"></el-image>
                                <div class="generateTips oneRow">请复核你生成的内容，确保符合《中华人民共和国广告法》等法律法规。若出现违法违规情形，将进行下线的处理，并报相关监管部门</div>
                            </div>
                        </div>
                    </div>
                    <div :class="['align',resultData.id == '' ? 'generateTopBtnBox' : '']">
                        <el-button @click="contentDownClick(resultData.download_url)">导出</el-button>
                        <el-button @click="copyContent">复制内容</el-button>
                        <el-button type="primary" @click="saveContent">保存</el-button>
                    </div>
                </div>
                <div class="generateBottom spb">
                    <div class="generateTabBox column" v-if="!contentEdit">
                        <div class="generateTabList spb">
                            <div class="generateTab generateTabOn">生成进度</div>
                        </div>
                        <div class="generateProgressContent">
                            <div class="generateProgressBox between">
                                <div class="generateProgressTitle">生成进度</div>
                                <div class="generateProgressTips">{{ step }}/8已完成</div>
                            </div>
                            <el-progress :percentage="step * 12.5" :show-text="false"></el-progress>
                            <div class="generateProgressNum">{{ step * 12.5 }}%</div>
                            <div class="stepList">
                                <div class="stepBox between" v-for="(item, index) in stepData" :key="index">
                                    <div :class="['stepName',index > step ? 'stepNameOn' : '']">{{ item }}</div>
                                    <el-image :src="require('@/assets/icon/complete.png')" fit="cover" class="stepIcon" v-if="index < step"></el-image>
                                    <el-image :src="require('@/assets/icon/loading.png')" fit="cover" class="stepIcon stepLoadingIcon" v-if="index == step"></el-image>
                                </div>
                            </div>
                            <div class="stepTipsBox spb">
                                <el-image :src="require('@/assets/icon/tips.png')" fit="cover" class="stepTipsIcon"></el-image>
                                <div class="stepTipsText">在此跟踪您的内容生成步骤的实时进度，已完成的进度以绿色标记，您可以监控当前正在运行的步骤，并一目了然地查看整体完成情况</div>
                            </div>
                        </div>
                    </div>
                    <div class="resultBox">
                        <div class="resultSkeletonBox" v-if="resultData.id == ''">
                            <div class="resultSkeleton">
                                <div class="resultSkeletonTitle">{{ createTitle }}</div>
                                <div class="resultSkeletonTips">此过程可能需要5至10分钟,请您耐心等待...</div>
                                <el-skeleton :rows="20" animated />
                            </div>
                            <div class="resultSkeletonText"></div>
                        </div>
                        <TinymceEditor v-model="resultData.rich_text" height="calc(100vh - 106px)" :type-writer="!contentEdit" :type-writer-speed="10" :content-id="resultData.id" v-else></TinymceEditor>
                    </div>
                </div>
            </div>
        </div>
        <!-- 品牌话题 -->
        <div class="geoBox" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '2' && selectedHcid.hcid == '6'">
            <div class="topicTabList flex">
                <div :class="['topicTab',topicActive == index ? 'topicTabOn' : '']" v-for="(item, index) in topicTab" :key="index" @click="topicActive = index">{{ item }}</div>
            </div>
            <div class="topicBox" v-show="topicActive == '0'">
                <div class="flex">
                    <el-button type="primary" @click="addScene">+添加场景问题</el-button>
                    <el-button class="batchBtn" @click="batchBtnTap('1')">批量停用</el-button>
                    <el-button class="batchBtn" @click="batchBtnTap('2')">批量启用</el-button>
                    <el-button class="batchBtn" @click="batchBtnTap('3')">批量删除</el-button>
                </div>
                <div class="topicFilterList flex">
                    <div class="topicFilterBox align">
                        <div class="topicFilterTitle">所属话题</div>
                        <el-select clearable v-model="topicSourceValue" placeholder="全部话题" class="topicFilterSelect" @change="getSceneList(true)">
                            <el-option v-for="item in topicSource" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="topicFilterBox align">
                        <div class="topicFilterTitle">状态</div>
                        <el-select clearable v-model="topicTypeValue" placeholder="全部状态" class="topicFilterSelect" @change="getSceneList(true)">
                            <el-option v-for="item in topicType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                    <div class="topicFilterBox align">
                        <div class="topicFilterTitle">创建时间</div>
                        <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" v-model="topicTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="topicFilterSelect" @change="getSceneList(true)"></el-date-picker>
                    </div>
                </div>
                <div class="sceneTabBox">
                    <el-table :data="sceneTabData.list" style="width: 100%" height="calc(100vh - 300px)" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="discussion" label="场景问题" min-width="24%">
                            <template slot-scope="scope">
                                <div class="sceneTitle">{{ scope.row.discussion }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="topic" label="话题" min-width="18%"></el-table-column>
                        <el-table-column prop="create_time" label="创建时间" min-width="18%"></el-table-column>
                        <el-table-column prop="status" label="状态" min-width="18%">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.status" :inactive-text="scope.row.status ? '启用中' : '禁用中'" @change="sceneTabStatusChange(scope)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operation" label="操作" min-width="18%">
                            <template slot-scope="scope">
                                <el-button @click="sceneTabEditClick(scope)" type="text" size="small">编辑</el-button>
                                <el-button @click="sceneTabDelClick(scope)" type="text" size="small" style="color: #F84025;">删除</el-button>
                            </template>
                        </el-table-column>
                        <div slot="empty" class="sceneEmpty">
                            <el-image :src="require('@/assets/icon/noKnowledge.png')" fit="cover" class="sceneEmptyImg"></el-image>
                            <div class="sceneEmptyText">暂无场景问题，请先进行配置</div>
                            <el-button type="primary" @click="addScene">+添加场景问题</el-button>
                        </div>
                    </el-table>
                    <div class="paginationBox reverse" v-if="sceneTabData.list.length > 0">
                        <el-pagination background
                            @size-change="sceneSizeChange"
                            @current-change="sceneCurrentChange"
                            :current-page="scenePage"
                            :page-sizes="[20, 40, 60, 80]"
                            :page-size="scenePageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="sceneTabData.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div class="topicBox" v-show="topicActive == '1'">
                <div class="flex">
                    <el-button type="primary" @click="addTopic">+添加话题</el-button>
                </div>
                <div class="topicRemaining">剩余可用话题数量:<span class="topicRemainingNum">{{ 100 - topicTabData.total }}</span>个/100个</div>
                <div class="sceneTabBox" style="max-height: calc(100vh - 212px);">
                    <el-table :data="topicTabData.list" style="width: 100%" height="calc(100vh - 282px)">
                        <el-table-column prop="name" label="场景问题" min-width="24%"></el-table-column>
                        <el-table-column prop="name" label="话题" min-width="18%"></el-table-column>
                        <el-table-column prop="create_time" label="创建时间" min-width="18%"></el-table-column>
                        <el-table-column prop="status" label="状态" min-width="18%">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.status" :inactive-text="scope.row.status == 1 ? '启用中' : '禁用中'" @change="topicTabStatusChange(scope)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operation" label="操作" min-width="18%">
                            <template slot-scope="scope">
                                <el-button @click="topicTabEditClick(scope)" type="text" size="small">编辑</el-button>
                                <el-button @click="topicTabDelClick(scope)" type="text" size="small" style="color: #F84025;">删除</el-button>
                            </template>
                        </el-table-column>
                        <div slot="empty" class="sceneEmpty">
                            <el-image :src="require('@/assets/icon/noKnowledge.png')" fit="cover" class="sceneEmptyImg"></el-image>
                            <div class="sceneEmptyText">暂无话题，点击上方“添加话题”按钮创建新的话题</div>
                            <el-button type="primary" @click="addTopic">+添加话题</el-button>
                        </div>
                    </el-table>
                    <div class="paginationBox reverse" v-if="topicTabData.list.length > 0">
                        <el-pagination background
                            @size-change="topicSizeChange"
                            @current-change="topicCurrentChange"
                            :current-page="topicPage"
                            :page-sizes="[20, 40, 60, 80]"
                            :page-size="topicPageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="topicTabData.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 会员 -->
        <div class="geoBox column" style="max-height: 100vh; overflow: scroll;" v-if="selectedHcid && selectedHcid.tabId && selectedHcid.tabId == '3' && selectedHcid.hcid == '0'">
            <div class="vipTabList align" v-if="vipData.length > 1">
                <div :class="['tab',tabActive == index ? 'tabOn' : '']" v-for="(item,index) in vipData" :key="index" @click="tabActive = index">{{ item.title }}</div>
            </div>
            <div class="exchangeBox align">
                <div class="exchange">兑换码兑换</div>
                <el-image :src="require('@/assets/icon/vip01.png')" fit="cover" class="exchangeIcon"></el-image>
            </div>
            <div class="vipList center" v-if="vipData.length > 0">
                <div class="vipBox" v-for="(item,index) in vipData[tabActive].plans" :key="index">
                    <div class="vipTop">
                        <el-image :src="item.img" fit="cover" class="vipImg"></el-image>
                        <div class="vipName">{{ item.name }}</div>
                        <div class="vipPrice"><span class="vipPriceIcon">￥</span>{{ item.price }}<span class="vipPriceTime">每月</span></div>
                        <div class="flex">
                            <div class="vipNew" v-if="item.is_new_user != ''">{{ item.is_new_user }}</div>
                        </div>
                        <div class="vipPoints">{{ item.points_show1 }}</div>
                    </div>
                    <div :class="['vipBtn',item.is_vip == '1' ? 'vipBtnOn' : '']" @click="vipBtnTap(item)">{{ item.is_vip == '1' ? '当前计划' : '立即购买' }}</div>
                    <div class="vipAgreementBox center">
                        <el-image :src="require(item.active ? '@/assets/icon/vip03.png' : '@/assets/icon/vip02.png')" fit="cover" class="vipAgreementIcon" @click="item.active = !item.active"></el-image>
                        <div class="vipAgreement" @click="item.active = !item.active">已阅读并同意</div>
                        <div class="vipAgreementText" @click="getAgreement('3')">{{ vipAgreementName }}</div>
                    </div>
                    <div class="averageBox center" v-if="item.points_show2 != ''">
                        <el-image :src="require('@/assets/icon/vip04.png')" fit="cover" class="averageIcon"></el-image>
                        <div class="averageText">{{ item.points_show2 }}</div>
                    </div>
                    <div class="privilegeList">
                        <div class="privilegeBox flex" v-for="(item,index) in vipData[tabActive].rights" :key="index">
                            <el-image :src="item.icon" fit="cover" class="privilegeIcon"></el-image>
                            <div class="privilegeText">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 支付弹窗 -->
        <el-dialog title="会员支付" :visible.sync="vipPayPopup" width="340px">
            <el-image :src="payData.code_url" fit="cover" class="payCode"></el-image>
        </el-dialog>
        <!-- 添加竞争对手弹窗 -->
        <el-dialog title="新增竞争对手" :visible.sync="competitorPopup" width="500px">
            <div class="competitorPopupBox">
                <div class="competitorPopupItem flex">
                    <div class="competitorTitle"><span class="competitorTitleIcon">*</span>品牌名称</div>
                    <el-input placeholder="请填写品牌名称" v-model="competitorName" maxlength="30" show-word-limit class="competitorIpt"></el-input>
                </div>
                <div class="competitorPopupItem flex">
                    <div class="competitorTitle">品牌网站</div>
                    <el-input placeholder="例如xiaoliebian.com" v-model="competitorWeb" maxlength="100" show-word-limit class="competitorIpt"></el-input>
                </div>
                <div class="competitorPopupItem flex">
                    <div class="competitorTitle">品牌logo</div>
                    <el-upload ref="competitorImgUpload" class="competitorImgBox" action="/api/common/upload" :limit='1' :show-file-list="false" :file-list="competitorImgFileList" :on-success="competitorImgSuccess" :before-upload="competitorImgUpload">
                        <el-image v-if="competitorImg" :src="competitorImg" fit="cover" class="competitorImg"></el-image>
                        <div class="competitorImgNoBox" v-else>
                            <el-image :src="require('@/assets/icon/work10.png')" fit="cover" class="competitorIcon"></el-image>
                            <div class="competitorImgNoText">上传图片</div> 
                        </div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="competitorPopup = false">取消</el-button>
                <el-button type="primary" @click="competitorTap">确定</el-button>
            </span>
        </el-dialog>
        <!-- 上传知识库弹窗 -->
        <el-dialog title="上传知识库" :visible.sync="knowledgePopup" width="720px">
            <el-alert title="请确保上传品牌真实的内容，符合《中华人民共和国广告法》等法律法规，若出现违法违规情形，将进行下线等处理，并报相关监管部门" type="warning" show-icon :closable="false"></el-alert>
            <div class="knowledgePopupBox">
                <div class="knowledgePopupItem flex">
                    <div class="knowledgeTitle"><span class="knowledgeTitleIcon">*</span>知识库名称</div>
                    <el-input placeholder="请输入知识库名称" v-model="knowledgeName" maxlength="15" show-word-limit class="knowledgeIpt"></el-input>
                </div>
                <div class="knowledgePopupItem flex">
                    <div class="knowledgeTitle"><span class="knowledgeTitleIcon">*</span>知识库类型</div>
                    <div class="knowledgeTypeList flex">
                        <div :class="['knowledgeType',knowledgeActive == index ? 'knowledgeTypeOn' : '']" v-for="(item, index) in knowledgeType" :key="index" @click="knowledgeActive = index">
                            <div class="align">
                                <el-image :src="item.icon" fit="cover" class="knowledgeTypeIcon"></el-image>
                                <div class="knowledgeTypeName">{{item.title}}</div>
                            </div>
                            <div class="knowledgeTypeText">{{item.text}}</div>
                        </div>
                    </div>
                </div>
                <div class="knowledgePopupItem flex" v-if="knowledgeActive == '0'">
                    <div class="knowledgeTitle"><span class="knowledgeTitleIcon">*</span>上传文件</div>
                    <el-upload ref="knowledgeUpload" class="upload-demo" drag action="/api/common/upload" multiple :on-success="knowledgeSuccess" :before-upload="knowledgeUpload" :file-list="fileList" :limit="1" :on-exceed="knowledgeExceed" :on-remove="knowledgeRemove" :on-preview="knowledgePreview">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或点击上传</div>
                        <div class="el-upload__tip" slot="tip">仅支持 PDF、DOCX、TXT,不支持图片格式</div>
                    </el-upload>
                </div>
                <div class="knowledgePopupItem flex" v-if="knowledgeActive == '1'">
                    <div class="knowledgeTitle"><span class="knowledgeTitleIcon">*</span>网页链接</div>
                    <el-input placeholder="请输入链接" v-model="knowledgeWeb" maxlength="500" show-word-limit class="knowledgeIpt"></el-input>
                </div>
                <!-- <div class="knowledgePopupItem flex" v-if="knowledgeActive == '2'">
                    <div class="knowledgeTitle"><span class="knowledgeTitleIcon">*</span>飞书链接</div>
                    <el-input placeholder="请输入链接" v-model="knowledgeLs" maxlength="500" show-word-limit class="knowledgeIpt"></el-input>
                </div> -->
                <div class="knowledgePopupItem flex" v-if="knowledgeActive == '2'">
                    <div class="knowledgeTitle"><span class="knowledgeTitleIcon">*</span>公众号链接</div>
                    <el-input placeholder="请输入链接" v-model="knowledgeGz" maxlength="500" show-word-limit class="knowledgeIpt"></el-input>
                </div>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="knowledgePopup = false">取消</el-button>
                <el-button type="primary" :disabled="knowledgeName == '' || (knowledgeActive == '0' && fileUrl == '') || (knowledgeActive == '1' && knowledgeWeb == '') || (knowledgeActive == '2' && knowledgeLs == '') || (knowledgeActive == '3' && knowledgeGz == '') ? true : false" @click="knowledgeUpTap">立即上传</el-button>
            </span> -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="knowledgePopup = false">取消</el-button>
                <el-button type="primary" :disabled="knowledgeName == '' || (knowledgeActive == '0' && fileUrl == '') || (knowledgeActive == '1' && knowledgeWeb == '') || (knowledgeActive == '2' && knowledgeGz == '') ? true : false" @click="knowledgeUpTap">立即上传</el-button>
            </span>
         </el-dialog>
         <!-- AI内容策略模板弹窗 -->
        <el-dialog title="AI内容策略模板" :visible.sync="templatePopup" width="1016px">
            <div class="templatePopupBox">
                <div class="templatePopupTips">基于AI内容偏好设计,选择对应模版可显著提升生成质量和准确性</div>
                <div class="templateList flex">
                    <div :class="['templateBoxBg', templateActive == index ? 'templateBoxBgOn' : '']" v-for="(item, index) in templateData" :key="index" @click="templateActive = index">
                        <el-image :src="require('@/assets/icon/hook.png')" fit="cover" class="templateIcon" v-if="templateActive == index"></el-image>
                        <div class="templateBox">
                            <div class="templateTitle oneRow">{{ item.name }}</div>
                            <div class="templateTips oneRow">{{ item.description }}</div>
                            <div class="templateTagBox">
                                <div class="templateTagTitle">适用场景</div>
                                <div class="templateTagList flex">
                                    <div class="templateTag" v-for="(el,ii) in item.scene" :key="ii">{{ el }}</div>
                                </div>
                                <div class="templateTagTitle">示例</div>
                                <div class="templateTagTips oneRow">{{ item.sample }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="templatePopup = false">取消</el-button>
                <el-button type="primary" @click="templatePopupTap">使用模板</el-button>
            </span>
        </el-dialog>
        <!-- 内容生产-内容配置-遮罩层 -->
        <div class="createMask" v-if="createZskShow || createMbyhShow" @click="createZskShow = false; createMbyhShow = false"></div>
        <!-- 添加场景问题弹窗 -->
        <el-drawer :title="sceneId == '' ? '新增场景问题' : '编辑场景问题'" :visible.sync="sceneDrawer" :size="736">
            <div class="portraitBox">
                <div class="portraitIptBox flex">
                    <div class="portraitIptTitle">选择话题</div>
                    <el-select clearable v-model="sceneVal" placeholder="请选择话题" class="portraitIpt">
                        <el-option v-for="item in topicSource" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="portraitIptBox flex">
                    <div class="portraitIptTitle">场景问题</div>
                    <el-input type="textarea" :rows="4" placeholder="请输入场景问题" v-model="sceneArea" class="portraitArea"></el-input>
                </div>
            </div>
            <div class="portraitBtn reverse">
                <el-button type="primary" style="margin-left: 10px;" @click="sceneDrawerTap">确定</el-button>
                <el-button @click="sceneDrawer = false">取消</el-button>
            </div>
        </el-drawer>
        <!-- 添加话题弹窗 -->
        <el-dialog :title="topicId == '' ? '添加话题' : '编辑话题'" :visible.sync="topicPopup" width="420px">
            <div class="topicPopupBox">
                <div class="topicPopupItem flex">
                    <div class="topicTitle"><span class="topicTitleIcon">*</span>话题</div>
                    <el-input placeholder="请输入话题" v-model="topicVal" maxlength="15" show-word-limit class="topicIpt"></el-input>
                </div>
                <div class="topicPopupItem flex">
                    <div class="topicTitle"></div>
                    <div class="topicPopupTips">填写要求:至少2个字,最多15个字<br>说明:收集用户的核心产品或者业务词<br>示例:门窗厂商、CRM软件、家具定制</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="topicPopup = false">取消</el-button>
                <el-button type="primary" @click="topicTap">确定</el-button>
            </span>
        </el-dialog>
        <!-- 新增目标用户弹窗 -->
         <el-drawer :title="targetId === '' ? '新增目标用户' : '编辑目标用户'" :visible.sync="portraitDrawer" :size="736">
            <div class="portraitBox">
                <div class="portraitTitle">基本信息</div>
                <div class="portraitIptBox flex">
                    <div class="portraitIptTitle"><span class="portraitIptTitleIcon">*</span>画像名称</div>
                    <el-input placeholder="请输入画像名称" v-model="portraitName" maxlength="15" show-word-limit class="portraitIpt"></el-input>
                </div>
                <div class="portraitIptBox flex">
                    <div class="portraitIptTitle"><span class="portraitIptTitleIcon">*</span>画像描述</div>
                    <el-input type="textarea" :rows="4" placeholder="请输入画像描述" v-model="portraitDesc" maxlength="500" show-word-limit class="portraitArea"></el-input>
                </div>
                <div class="portraitAreaTips">用于描述目标用户的核心特征，在创建优化单元、意图、文章时，选择画像可更精准的生成内容</div>
                <div class="portraitTitle">补充画像维度</div>
                <div class="portraitTitleTips">通过补充更多画像维度(如消费偏好、用户需求、用户地域等),AI平台可更精准识别生成对应内容,最多支持设置10个维度。</div>
                <el-button @click="addDimension('')">+新增画像维度</el-button>
                <div class="portraitItem" v-for="(item,index) in portraitList" :key="index">
                    <div class="between">
                        <div class="align">
                            <div class="dimensionTitle">{{ item.name }}</div>
                            <div class="dimensionType">{{ item.type }}</div>
                        </div>
                        <el-button type="text" @click="addDimension(index)">编辑</el-button>
                    </div>
                    <div class="dimensionText">{{ item.desc || '——' }}</div>
                </div>
            </div>
            <div class="portraitBtn reverse">
                <el-button type="primary" style="margin-left: 10px;" @click="portraitBtnTap">确定</el-button>
                <el-button @click="portraitDrawer = false">取消</el-button>
            </div>
        </el-drawer>
        <!-- 编辑画像维度弹窗 -->
        <el-dialog :title="portraitIndex === '' ? '新增画像维度' : '编辑画像维度'" :visible.sync="dimensionPopup" width="578px">
            <div class="dimensionPopupBox">
                <div class="dimensionPopupItem flex">
                    <div class="dimensionTitle"><span class="dimensionTitleIcon">*</span>维度名称</div>
                    <el-input placeholder="请输入维度名称" :disabled="portraitIndex !== '' && portraitList[portraitIndex].type !== '自定义维度'" v-model="dimensionName" maxlength="6" show-word-limit class="dimensionIpt"></el-input>
                </div>
                <div class="dimensionPopupItem flex">
                    <div class="dimensionTitle"><span class="dimensionTitleIcon">*</span>维度描述</div>
                    <el-input type="textarea" :rows="3" placeholder="请输入维度描述" v-model="dimensionDesc" maxlength="100" show-word-limit class="dimensionArea"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dimensionPopup = false">取消</el-button>
                <el-button type="primary" @click="dimensionTap">确定</el-button>
            </span>
        </el-dialog>
        <!-- 视频播放弹窗 -->
        <el-dialog title="作品详情" :visible.sync="workPopup" width="578px">
            <div class="column">
                <video :src="workUrl" controls="controls" style="width: 100%;" v-if="workType == '1'"></video>
                <el-image :src="workUrl" fit="cover" class="workPopupImg" v-if="workType == '2'"></el-image>
            </div>
        </el-dialog>
        <!-- GEO生成弹窗 -->
        <el-dialog title="GEO生成" :visible.sync="geoPopup" width="480px">
            <div class="geoPointPopup align">
                <div class="geoPointText">生成AI文章需消耗</div>
                <el-image :src="geoPopupData.popup_icon" fit="cover" class="geoIcon"></el-image>
                <div class="geoPoint">{{ geoPopupData.point }}</div>
                <div class="geoPointText">积分</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="geoPopup = false">取消</el-button>
                <el-button type="primary" @click="geoPopupTap">确定</el-button>
            </span>
        </el-dialog>
        <!-- 视频播放弹窗 -->
        <el-dialog title="协议" :visible.sync="agreementPopup" width="800px">
            <div class="agreement" v-html="agreementText"></div>
        </el-dialog>
        <!-- 选择音色弹窗 -->
        <el-dialog title="选择音色" :visible.sync="timbrePopup" width="726px">
            <div class="timbrePopupBox">
                <div class="timbreTabList flex">
                    <div :class="['timbreTab',voiceTabActive == index ? 'timbreTabOn' : '']" v-for="(item,index) in voiceTab" :key="index" @click="voiceTabActive = index">{{ item }}</div>
                </div>
                <el-input placeholder="请输入音色名称" v-model="timbreKeyword" class="timbreIpt" @keyup.enter.native="timbreSearch">
                    <template #suffix>
                        <i class="el-icon-search timbreIptIcon" @click="timbreSearch"></i>
                    </template>
                </el-input>
                <div class="timbreList flex" v-if="voiceTabActive == 0">
                    <div :class="['timbreItem align',commonvoiceActive == index ? 'timbreItemOn' : '']" v-for="(item,index) in commonvoice" :key="index" @click="commonvoiceActive = index;myvoiceActive = '-1'">
                        <el-image :src="require('@/assets/icon/drive02.png')" fit="cover" class="timbreIcon" v-if="item.tryType" @click.stop="stopTimbreSound(commonvoice, index)"></el-image>
                        <el-image :src="require('@/assets/icon/drive01.png')" fit="cover" class="timbreIcon" v-else @click.stop="playTimbreSound(commonvoice, index, myvoice)"></el-image>
                        <div class="timbreName oneRow">{{ item.voice_name2 }}</div>
                    </div>
                </div>
                <div class="timbreList flex" v-if="voiceTabActive == 1">
                    <div class="newTimbre between" @click="openNewTimbreDrawer">
                        <div class="newTimbreText">+ 新建音色</div>
                        <el-image :src="require('@/assets/icon/drive03.png')" fit="cover" class="newTimbreIcon"></el-image>
                    </div>
                    <div :class="['timbreItem align',myvoiceActive == index ? 'timbreItemOn' : '']" v-for="(item,index) in myvoice" :key="index" @click="myvoiceActive = index;commonvoiceActive = '-1'">
                        <el-image :src="require('@/assets/icon/drive02.png')" fit="cover" class="timbreIcon" v-if="item.tryType" @click.stop="stopTimbreSound(myvoice, index)"></el-image>
                        <el-image :src="require('@/assets/icon/drive01.png')" fit="cover" class="timbreIcon" v-else @click.stop="playTimbreSound(myvoice, index, commonvoice)"></el-image>
                        <div class="timbreName oneRow">{{ item.voice_name2 }}</div>
                    </div>
                </div>
                <div class="reverse">
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="timbrePopup = false">取消</el-button>
                        <el-button type="primary" @click="getSoundSelected(true)">确定</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- 新建音色弹窗 -->
        <el-drawer title="新建音色" :visible.sync="newTimbreDrawer" :size="560">
            <div class="newTimbreDrawerBox">
                <div class="newTimbreTitleBox align">
                    <div class="newTimbreTitleIcon"></div>
                    <div class="newTimbreTitle">音色名称</div>
                </div>
                <el-input placeholder="请输入音色名称" v-model="newTimbreName" class="newTimbreIpt"></el-input>
                <div class="newTimbreTabList between">
                    <div :class="['newTimbreTab',newTimbreActive == index ? 'newTimbreTabOn' : '']" v-for="(item,index) in newTimbreTab" :key="index" @click="newTimbreActive = index">{{ item }}</div>
                </div>
                <template v-if="newTimbreActive == 0">
                    <el-upload ref="timbreUpload" accept="audio/*" action="/api/common/upload" :limit='1' :on-success="timbreSuccess" :on-exceed="timbreExceed" :before-upload="timbreBeforeUpload" :show-file-list="false" v-if="newTimbreUpUrl == ''">
                        <div class="timbreUploadBox column">
                            <el-image :src="require('@/assets/icon/drive12.png')" fit="cover" class="timbreUploadIcon"></el-image>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">格式mp3/wav,时长建议10-60秒,不超10MB</div>
                        </div>
                    </el-upload>
                    <div class="timbreUploadData between" v-if="newTimbreUpUrl != ''">
                        <el-image :src="require('@/assets/icon/drive02.png')" fit="cover" class="timbreUploadImg" v-if="newTimbreUpType" @click="stopNewTimbreSound"></el-image>
                        <el-image :src="require('@/assets/icon/drive01.png')" fit="cover" class="timbreUploadImg" v-else @click="playNewTimbreSound"></el-image>
                        <div class="timbreUploadName oneRow">{{ newTimbreUpName }}</div>
                        <div class="timbreUploadDelete" @click="deleteNewTimbreSound">删除</div>
                    </div>
                </template>
                <template v-else-if="newTimbreActive == 1">
                    <div class="driveVoice column">
                        <template v-if="newTimbreLzStep == '1'">
                            <el-image :src="require('@/assets/icon/drive13.png')" fit="cover" class="voiceImg" @click="startRecord"></el-image>
                            <div class="playTips" style="margin-top: 10px;">点击录制自己的声音60秒以内</div>
                            <div class="playTips">若使用他人声音，请确认已获取他人授权</div>
                        </template>
                        <div class="voiceTime" v-if="newTimbreLzStep != '1'">{{newTimbreLzTime}}</div>
                        <div class="playTips" v-if="newTimbreLzStep != '1'">{{newTimbreLzStep == '2' ? '录音中' : newTimbreLzStep == '3' ? '录音完成' : ''}}</div>
                        <el-image :src="require('@/assets/icon/drive14.png')" fit="cover" class="voiceImg" style="margin-top: 12px;" v-if="newTimbreLzStep == '2'" @click="endRecord"></el-image>
                        <div class="voiceAgainBox center" v-if="newTimbreLzStep == '3'">
                            <div class="voiceAgain column" @click="againTap">
                                <el-image :src="require('@/assets/icon/drive17.png')" fit="cover" class="voiceAgainIcon"></el-image>
                                <div class="voiceAgainName">重录</div>
                            </div>
                            <el-image :src="require('@/assets/icon/drive16.png')" fit="cover" class="voiceImg" @click="onPause" v-if="newTimbreLzType"></el-image>
                            <el-image :src="require('@/assets/icon/drive15.png')" fit="cover" class="voiceImg" @click="onPlay" v-else></el-image>
                        </div>
                    </div>
                </template>
                <div class="newTimbreDrawerBtnList reverse">
                    <div class="newTimbreDrawerBtnBox center" @click="cloneTap">
                        <div class="newTimbreDrawerBtn">克隆音色</div>
                        <el-image :src="require('@/assets/icon/star02.png')" fit="cover" class="newTimbreDrawerIcon"></el-image>
                        <div class="ipBtn">{{ ipData.shengyinkelong }}</div>
                    </div>
                    <el-button>取消</el-button>
                </div>
            </div>
        </el-drawer>
        <!-- 选择数字人弹窗 -->
        <el-dialog title="数字人列表" :visible.sync="digitalPopup" width="726px">
            <div class="timbrePopupBox">
                <div class="timbreTabList flex">
                    <div :class="['timbreTab',digitalTabActive == index ? 'timbreTabOn' : '']" v-for="(item,index) in digitalTab" :key="index" @click="digitalTabActive = index">{{ item }}</div>
                </div>
                <el-input placeholder="请输入公共形象名称" v-model="digitalKeyword" class="timbreIpt" @keyup.enter.native="digitalSearch">
                    <template #suffix>
                        <i class="el-icon-search timbreIptIcon" @click="digitalSearch"></i>
                    </template>
                </el-input>
                <div class="timbreList flex" v-if="digitalTabActive == 0">
                    <div :class="['digitalItem align',commonDigitalActive == index ? 'digitalItemOn' : '']" v-for="(item,index) in commonDigital" :key="index" @click="commonDigitalActive = index;myDigitalActive = '-1'">
                        <video :src="item.url" controls="controls" width="162" height="230"></video>
                        <div class="digitalItemNameBox between">
                            <div class="digitalItemName oneRow">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="timbreList flex" v-if="digitalTabActive == 1">
                    <div class="newDigital column" @click="newDigitalDrawer = true">
                        <el-image :src="require('@/assets/icon/drive18.png')" fit="cover" class="newTimbreIcon"></el-image>
                        <div class="newDigitalText">新建数字人</div>
                    </div>
                    <div :class="['digitalItem align',myDigitalActive == index ? 'digitalItemOn' : '']" v-for="(item,index) in myDigital" :key="index" @click="myDigitalActive = index;commonDigitalActive = '-1'">
                        <video :src="item.url" controls="controls" width="162" height="230"></video>
                        <div class="digitalItemNameBox between">
                            <div class="digitalItemName oneRow">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="reverse">
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="digitalPopup = false">取消</el-button>
                        <el-button type="primary" @click="getDigitalSelected(true)">确定</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- 新建数字人弹窗 -->
        <el-drawer title="新建数字人" :visible.sync="newDigitalDrawer" :size="560">
            <div class="newTimbreDrawerBox">
                <div class="newTimbreTitleBox align">
                    <div class="newTimbreTitleIcon"></div>
                    <div class="newTimbreTitle">上传视频</div>
                </div>
                <el-upload ref="newDigitalUpload" accept="video/*" action="/api/common/upload" :limit='1' :on-success="newDigitalVideoSuccess" :on-exceed="newDigitalVideoExceed" :before-upload="newDigitalVideoBeforeUpload" :show-file-list="false" v-if="newDigitalUrl == ''">
                    <div class="timbreUploadBox column">
                        <el-image :src="require('@/assets/icon/drive12.png')" fit="cover" class="timbreUploadIcon"></el-image>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">格式mp4,,不超100MB</div>
                    </div>
                </el-upload>
                <div class="center" v-if="newDigitalUrl != ''">
                    <div class="newDigitalVideoBox">
                        <video :src="newDigitalUrl" controls="controls" width="100%"></video>
                    </div>
                </div>
                <div class="newTimbreDrawerBtnList reverse">
                    <div class="newTimbreDrawerBtnBox center" @click="cloneVideoTap">
                        <div class="newTimbreDrawerBtn">克隆形象</div>
                        <el-image :src="require('@/assets/icon/star02.png')" fit="cover" class="newTimbreDrawerIcon"></el-image>
                        <div class="ipBtn">{{ ipData.xingxiangkelong }}</div>
                    </div>
                    <el-button>取消</el-button>
                </div>
            </div>
        </el-drawer>
        <!-- 选择字幕弹窗 -->
        <el-dialog title="选择字幕模板" :visible.sync="subtitlesPopup" width="726px">
            <div class="timbrePopupBox">
                <div class="timbreList flex">
                    <div :class="['digitalItem align',subtitlesPopupActive == index ? 'digitalItemOn' : '']" v-for="(item,index) in subtitles" :key="index" @click="subtitlesPopupActive = index" style="height: 312px;">
                        <el-image :src="item.img" fit="cover" class="digitalItemImg"></el-image>
                        <div class="digitalItemNameBox">
                            <div class="digitalItemName oneRow" style="text-align: center;">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="reverse">
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="subtitlesPopup = false">取消</el-button>
                        <el-button type="primary" @click="subtitlesActive = subtitlesPopupActive;subtitlesPopup = false">确定</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- 选择背景音乐弹窗 -->
        <el-dialog title="选择背景音乐" :visible.sync="bgmPopup" width="726px">
            <div class="timbrePopupBox">
                <div class="timbreList flex">
                    <div :class="['timbreItem align',bgmPopupActive == index ? 'timbreItemOn' : '']" v-for="(item,index) in bgmList" :key="index" @click="bgmPopupActive = index">
                        <el-image :src="require('@/assets/icon/drive02.png')" fit="cover" class="timbreIcon" v-if="item.tryType" @click.stop="stopBgmSound(bgmList, index)"></el-image>
                        <el-image :src="require('@/assets/icon/drive01.png')" fit="cover" class="timbreIcon" v-else @click.stop="playBgmSound(bgmList, index)"></el-image>
                        <div class="timbreName oneRow">{{ item.title }}</div>
                    </div>
                </div>
                <div class="reverse">
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="bgmPopup = false">取消</el-button>
                        <el-button type="primary" @click="bgmActive = bgmPopupActive;bgmPopup = false">确定</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- 选择实景混剪弹窗 -->
        <el-dialog title="选择实景混剪" :visible.sync="editPopup" width="726px">
            <div class="timbrePopupBox">
                <div class="timbreList flex">
                    <el-upload ref="newEditUpload" accept="video/*" action="/api/common/upload" :on-success="newEditVideoSuccess" :before-upload="newEditVideoBeforeUpload" :show-file-list="false">
                        <div class="newDigital column">
                            <el-image :src="require('@/assets/icon/drive18.png')" fit="cover" class="newTimbreIcon"></el-image>
                            <div class="newDigitalText">上传视频</div>
                        </div>
                    </el-upload>
                    <div :class="['digitalItem align',item.active ? 'digitalItemOn' : '']" v-for="(item,index) in editList" :key="index" @click="editList[index].active = !editList[index].active">
                        <video :src="item.url" controls="controls" width="162" height="230"></video>
                        <div class="digitalItemNameBox between">
                            <div class="digitalItemName oneRow">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="reverse">
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="editPopup = false">取消</el-button>
                        <el-button type="primary" @click="getEditSelected()">确定</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import TinymceEditor from '@/components/TinymceEditor.vue'

    export default {
        props: {
            selectedHcid: {
                type: [Object, String, Number],
                default: null
            }
        },
        components: { TinymceEditor },
        data(){
            return {
                ipData: {
                    fangxie: 0,
                    tiquwenan: 0,
                    imgs: [],
                    zishu: []
                },
                // imitateTab: ['爆款模仿','IP对标','AI创作'],
                imitateTab: ['爆款模仿'],
				imitateActive: 0,
				imitateName: '',
				imitateLink: '',
				imitateStep: 1,
				countActive: 0,
				extract: '',
				imitate: '',
                imitateSwitch: true,
                languageList: [
                    {
                        value: '1',
                        label: '中文'
                    },
                    {
                        value: '2',
                        label: '英文'
                    },
                    {
                        value: '3',
                        label: '日文'
                    }
                ],
                languageValue: '1',
                dialectList: [
                    {
                        value: '1',
                        label: '普通话'
                    },
                    {
                        value: '2',
                        label: '粤语'
                    },
                    {
                        value: '3',
                        label: '蒙古语'
                    }
                ],
                dialectValue: '1',
                ipName: '',
				ipLink: '',
				ipStep: 1,
				standardTab: [],
				standardActive: 0,
				topicList: [],
				topicActive: 0,
				write: '撰写后文案撰写后文案撰写后文案',
                aiAreaText: '',
                driveTab:[
                    {
						name: '文本驱动',
						id: '1'
					},
					{
						name: '音频驱动',
						id: '2'
					}
				],
				driveActive: 0,
                driveText: '',
                setvoice: {},
                dubbingName: '',
                dubbingUrl: '',
                dubbingLoading: false,
                dubbingType: false,
                soundUrl: '',
                soundName: '',
                isSound: false,
                soundType: '',
                recording: false,
                mediaRecorder: null,
                audioChunks: [],
                videoUrl: '',
                musicTab: ['公共音乐','上传音乐'],
				musicActive: 0,
                musicUrl: '',
                musicName: '',
                musicVolume: 5,
                videoTitle: '',
                videoDesc: '',
                titleTimeTab: [
                    {
                        name: '全程',
                        value: '0'
                    },
                    {
                        name: '3秒',
                        value: '3'
                    },
                    {
                        name: '5秒',
                        value: '5'
                    },
                    {
                        name: '10秒',
                        value: '10'
                    }
                ],
                titleTimeActive: 0,
                editSwitch: false,
                editTab: ['交叉模式','开头模式','首尾模式'],
                editActive: 0,
                fbVideoUrl: '',
                fbVideoTitle: '',
                fbVideoDesc: '',
                platformTab: [
                    {
                        img: require('@/assets/icon/drive08.png'),
                        name: '抖音',
                        active: false
                    },
                    {
                        img: require('@/assets/icon/drive09.png'),
                        name: '快手',
                        active: false
                    },
                    {
                        img: require('@/assets/icon/drive10.png'),
                        name: '小红书',
                        active: false
                    },
                    {
                        img: require('@/assets/icon/drive11.png'),
                        name: '视频号',
                        active: false
                    },
                ],
                timbrePopup: false,
                voiceTab: ['公共音色','我的音色'],
				voiceTabActive: 0,
				commonvoice: [],
				myvoice: [],
				myvoiceActive: -1,
				commonvoiceActive: 0,
                timbreKeyword: '',
                soundSelected: {},
                soundSelectedType: false,
                audioPlayer: null,
                newTimbreDrawer: false,
                newTimbreName: '',
                newTimbreTab: ['上传音频','录制音频'],
                newTimbreActive: 0,
                newTimbreUpUrl: '',
                newTimbreUpName: '',
                newTimbreUpType: false,
                newTimbreLzUrl: '',
                newTimbreLzStep: '1',
				newTimbreLzTime: '00:00',
				newTimbreLzType: false,
                newTimbreLzRecordTimer: null,
                newTimbreLzRecordDuration: 0,
                digitalTab: ['公共形象','我的形象'],
				digitalTabActive: 0,
				commonDigital: [],
				commonDigitalActive: 0,
				myDigital: [],
				myDigitalActive: -1,
                digitalKeyword: '',
                digitalSelected: {},
                digitalPopup: false,
                newDigitalDrawer: false,
                newDigitalUrl: '',
                textGenerateVideoLoading: false,
                textGenerateVideoUrl: '',
                audioGenerateVideoLoading: false,
                audioGenerateVideoUrl: '',
                subtitlesPopup: false,
                subtitles: [],
				subtitlesPopupActive: 0,
                subtitlesActive: 0,
                bgmPopup: false,
                bgmList: [],
                editActiveName: '',
                editActiveUrl: '',
				bgmPopupActive: 0,
                bgmActive: -1,
                editList: [],
                editPopup: false,
                intervalList: [
                    {
                        value: '1',
                        label: '1秒'
                    },
                    {
                        value: '2',
                        label: '2秒'
                    },
                    {
                        value: '3',
                        label: '3秒'
                    },
                    {
                        value: '4',
                        label: '4秒'
                    },
                    {
                        value: '5',
                        label: '5秒'
                    }
                ],
                intervalValue: '1',
                editVideoLoading: false,
                editImgUrl: '',
                editVideoUrl: '',
                dreamerData: {},
                generateId: '',
                videoGenerate: [],
                imgGenerate: [],
                videoGenerateIndex: '',
                imgGenerateIndex: '',
                modelActive: 0,
                timeActive: 0,
				proportionActive: 0,
                videoReferenceImg: [],
                videoFileList: [],
                firstFrameFileList: [],
                lastFrameFileList: [],
                imgReferenceImg: [],
				firstFrame: '',
				lastFrame: '',
                workData: [],
                workShow: false,
                textarea: '',
                workUrl: '',
                workPopup: false,
                workType: '',
                basicName: '',
                basicWeb: '',
                basicImg: '',
                basicImgFileList: [],
                industry: [],
                industryValue: [],
                basicBusiness: '',
                competitorPopup: false,
                competitor: [],
                competitorName: '',
                competitorWeb: '',
                competitorImg: '',
                competitorImgFileList: [],
                basicStyle: '',
                basicRule: '',
                basicCall: '',
                basicPhone: '',
                knowledge: '',
                knowledgePage: 1,
                knowledgePageSize: 20,
                knowledgeTabData: {
                    list: [],
                    total: 0
                },
                knowledgePopup: false,
                knowledgeName: '',
                knowledgeActive: 0,
                knowledgeType: [
                    {
                        icon: require('@/assets/icon/knowledge01.png'),
                        title: '本地文件',
                        text: '支持PDF、DOCX、TXT'
                    },
                    {
                        icon: require('@/assets/icon/knowledge02.png'),
                        title: '网页',
                        text: '获取在线网页内容'
                    },
                    // {
                    //     icon: require('@/assets/icon/knowledge03.png'),
                    //     title: '飞书/腾讯文档',
                    //     text: '导入飞书文档到知识库'
                    // },
                    {
                        icon: require('@/assets/icon/knowledge04.png'),
                        title: '公众号',
                        text: '导入公众号到知识库中'
                    }
                ],
                fileList: [],
                fileUrl: '',
                knowledgeWeb: '',
                knowledgeLs: '',
                knowledgeGz: '',
                contentKeyword: '',
                contentType: [
                    {
                        id: '1',
                        name: '生成中'
                    },
                    {
                        id: '2',
                        name: '已完成'
                    },
                    {
                        id: '3',
                        name: '失败'
                    }
                ],
                contentTypeValue: '',
                contentTemplateValue: '',
                contentCreate: '',
                generate: false,
                contentEdit: false,
                templateData: [],
                templatePopup: false,
                templateActive: 0,
                createYhdy: '',
                createYhdyKey: '',
                createYhyt: '',
                createZskShow: false,
                createZskKey: '',
                createZskData: [],
                createZskActive: '-1',
                createZskActiveName: '',
                createZskActiveId: '',
                createMbyhShow: false,
                createMbyhKey: '',
                createMbyhData: [],
                createMbyhActive: '-1',
                createAIData: [],
                createAIActiveData: [],
                createTitle: '',
                resultData: {
                    rich_text: '',
                    id: ''
                },
                step: 0,
                stepData: ['开始生成文章', '收集引用知识库', '研究成果输出', '分析研究内容', '提取大纲框架', '撰写摘要简报', '添加元数据', '工作流程完成'],
                contentPage: 1,
                contentPageSize: 20,
                contentTabData: {
                    list: [],
                    total: 0
                },
                resultType: '0',
                topicTab: ['场景问题','话题'],
                topicActive: 0,
                topicSource: [],
                topicSourceValue: '',
                topicType: [
                    {
                        value: 'true',
                        label: '启用中'
                    },
                    {
                        value: 'false',
                        label: '禁用中'
                    }
                ],
                topicTypeValue: '',
                topicTime: [],
                scenePage: 1,
                scenePageSize: 20,
                sceneTabData: {
                    list: [],
                    total: 0
                },
                multipleSelection: [],
                topicPage: 1,
                topicPageSize: 20,
                topicTabData: {
                    list: [],
                    total: 0
                },
                sceneVal: '',
                sceneArea: '',
                sceneId: '',
                sceneIndex: '',
                sceneDrawer: false,
                topicVal: '',
                topicId: '',
                topicIndex: '',
                topicPopup: false,
                target : '',
                targetData: {
                    list: [],
                    total: 0
                },
                targetPage: 1,
                targetPageSize: 20,
                targetId: '',
                portraitDrawer: false,
                portraitName: '',
                portraitDesc: '',
                portraitList: [
                    {
                        name: '消费偏好',
                        type: '默认维度',
                        desc: ''
                    },
                    {
                        name: '用户需求',
                        type: '默认维度',
                        desc: ''
                    },
                    {
                        name: '用户地域',
                        type: '默认维度',
                        desc: ''
                    }
                ],
                portraitIndex: '',
                dimensionPopup: false,
                dimensionName: '',
                dimensionDesc: '',
                geoPopup: false,
                geoPopupData: {},
                vipData: [],
                vipAgreementName: '',
                tabActive: 0,
                vipPayPopup: false,
                payData: {},
                payPolling: false, // 控制支付轮询的标志
                agreementPopup: false,
                agreementText: ''
            }
        },
        mounted(){
            // 可以在这里处理选中的 hcid 和 tabId
            console.log('接收到的数据:', this.selectedHcid);
        },
        watch: {
            // 监听 selectedHcid 的变化
            selectedHcid(newVal) {
                console.log('数据发生变化:', newVal);
                if(newVal.dreamerItem){
                    this.dreamerData = newVal.dreamerItem
                }
                let userId = localStorage.getItem("userId") || 0
                if(userId == 0){
                    this.$router.push({ name: 'login' })
                    return
                }
                let hcid = 0;
                let tabId = 0;
                if(typeof newVal === 'object' && newVal !== null) {
                    hcid = newVal.hcid || 0;
                    tabId = newVal.tabId || 0;
                    console.log('hcid:', hcid, 'tabId:', tabId)
                    if(tabId != '1'){
                        // 清除所有上传图片的记录
                        this.clearAllUploadImages();
                    }
                    if(tabId == '1' && hcid != '18'){
                        this.modelActive = 0
                        this.timeActive = 0
                        this.proportionActive = 0
                        this.generateId = hcid
                        this.getGenerate()
                        this.getWork()
                    }
                    if(tabId == '1' && hcid == '18'){
                        this.getIPData()
                        this.getSetvoice()
                        this.getCommonvoice()
                        this.getMyvoice()
                        this.getDigitalPersonList('0')
                        this.getDigitalPersonList('1')
                        this.getSubtitlesList()
                        this.getBgmList()
                        this.getEditList()
                    }
                    if(tabId == '2' && hcid == '6'){
                        this.getTopicAll()
                        this.getSceneList()
                        this.getTopicList()
                    }
                    if(tabId == '2' && hcid == '13'){
                        this.getKnowledge()
                    }
                    if(tabId == '2' && hcid == '12'){
                        this.getTargetList()
                    }
                    if(tabId == '2' && hcid == '11'){
                        this.getIndustry()
                    }
                    if(tabId == '2' && hcid == '8'){
                        this.contentCreate = ''
                        this.generate = false
                        this.step = 0
                        this.resultData.rich_text = ''
                        this.resultData.id = ''
                        this.getContentList()
                        this.getTemplate()
                        this.getCreateZsk()
                        // this.getCreateAI()
                    }
                    if(tabId == '3' && hcid == '0'){
                        this.getVip()
                    }
                }
            },
            // 监听 vipPayPopup 弹窗关闭
            vipPayPopup(newVal) {
                if (!newVal) {
                    // 弹窗关闭时停止轮询
                    this.payPolling = false;
                }
            },
            // 监听 timbrePopup 弹窗关闭
            timbrePopup(newVal) {
                if (!newVal) {
                    // 弹窗关闭时停止音频播放
                    if (this.audioPlayer) {
                        this.audioPlayer.pause()
                        this.audioPlayer = null
                    }
                    // 重置音色列表播放状态
                    this.commonvoice.forEach((item, i) => {
                        this.$set(this.commonvoice[i], 'tryType', false)
                    })
                    this.myvoice.forEach((item, i) => {
                        this.$set(this.myvoice[i], 'tryType', false)
                    })
                }
            },
            // 监听 bgmPopup 弹窗变化
            bgmPopup(newVal) {
                // 弹窗开启或关闭时停止所有正在播放的声音
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                // 重置 bgmList 播放状态
                this.bgmList.forEach((item, i) => {
                    this.$set(this.bgmList[i], 'tryType', false)
                })
            }
        },
        beforeDestroy() {
            
        },
        methods: {
            // 开始录音
            startRecording() {
                this.audioChunks = []
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    this.$message.error('当前浏览器不支持录音功能，请使用最新版 Chrome 或 Edge')
                    return
                }
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(stream => {
                        this.mediaRecorder = new MediaRecorder(stream)
                        this.mediaRecorder.ondataavailable = (event) => {
                            if (event.data.size > 0) {
                                this.audioChunks.push(event.data)
                            }
                        }
                        this.mediaRecorder.onstop = () => {
                            const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })
                            this.uploadRecording(audioBlob)
                            // 停止所有音轨，释放麦克风
                            stream.getTracks().forEach(track => track.stop())
                        }
                        this.mediaRecorder.start()
                        this.recording = true
                    })
                    .catch(err => {
                        console.error('录音失败:', err)
                        this.$message.error('无法访问麦克风，请检查权限设置')
                    })
            },
            // 停止录音
            stopRecording() {
                if (this.mediaRecorder && this.recording) {
                    this.mediaRecorder.stop()
                    this.recording = false
                }
            },
            // 上传录音
            uploadRecording(blob) {
                const formData = new FormData()
                formData.append('file', blob, 'recording.wav')
                this.request.post('/api/common/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.code == 1) {
                        this.soundUrl = res.data || res.url || ''
                        this.soundName = '录音文件'
                        this.soundType = 'ly'
                        this.$message.success('录音上传成功')
                    } else {
                        this.$message.error(res.msg || '上传失败')
                    }
                }).catch(err => {
                    console.error('上传失败:', err)
                    this.$message.error('录音上传失败')
                })
            },
            // 选择配音
            xzpyTap() {
                this.stopSound()
                this.timbrePopup = true
            },
            // 播放音频
            playSound() {
                if (!this.soundSelected || !this.soundSelected.url) {
                    this.$message.warning('暂无音频可播放')
                    return
                }
                // 如果有正在播放的音频，先停止
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.audioPlayer = new Audio(this.soundSelected.url)
                this.audioPlayer.onended = () => {
                    this.soundSelectedType = false
                    this.audioPlayer = null
                }
                this.audioPlayer.play().catch(err => {
                    console.error('音频播放失败:', err)
                    this.$message.error('音频播放失败')
                })
                this.soundSelectedType = true
            },
            // 停止音频
            stopSound() {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.soundSelectedType = false
            },
            // 播放音色音频
            playTimbreSound(list, index, otherList) {
                // 停止当前播放的音频
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                // 清除当前列表所有 tryType
                list.forEach((item, i) => {
                    this.$set(list[i], 'tryType', false)
                })
                // 清除另一个列表所有 tryType
                if (otherList) {
                    otherList.forEach((item, i) => {
                        this.$set(otherList[i], 'tryType', false)
                    })
                }
                // 设置当前项 tryType = true
                this.$set(list[index], 'tryType', true)
                // 播放音频
                if (list[index].url) {
                    this.audioPlayer = new Audio(list[index].url)
                    this.audioPlayer.onended = () => {
                        this.$set(list[index], 'tryType', false)
                        this.audioPlayer = null
                    }
                    this.audioPlayer.play().catch(err => {
                        console.error('音频播放失败:', err)
                        this.$message.error('音频播放失败')
                    })
                }
            },
            // 停止音色音频
            stopTimbreSound(list, index) {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.$set(list[index], 'tryType', false)
            },
            // IP大脑数据
            getIPData() {
                this.request.get('api/zhineng/index')
                .then(res=>{
                    this.ipData = res.data
                })
            },
            // 提取文案
            extractTap(){
                if(this.imitateName == ''){
                    this.$message.warning('请输入任务名称');
                    return
                }
                if(this.imitateLink == ''){
                    this.$message.warning('请粘贴短视频链接');
                    return
                }
                const loading = this.$loading({
                    lock: true,
                    text: '努力提取中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.request.get('api/zhineng/tiqu',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        title: this.imitateName,
                        link: this.imitateLink
                    }
                })
                .then(res=>{
                    loading.close();
                    if(res.code != '1'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.extract = res.data.text
                    } 
                })
            },
            // AI仿写
            imitateTap(){
                const loading = this.$loading({
                    lock: true,
                    text: '努力仿写中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.request.post('api/zhineng/fangxie',{
                    userid: localStorage.getItem("userId") || 0,
                    type: this.countActive,
                    wenan: this.extract
                })
                .then(res=>{
                    loading.close();
                    if(res.code != '1'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.imitate = res.data.content
                        this.driveText = res.data.content
                    } 
                })
            },
            // 获取AI数字人生成参数
            getSetvoice(){
                this.request.get('api/zhineng/wenbenindex')
                .then(res=>{
                    this.setvoice = res.data
                })
            },
            // 选择语速
            speedChange(e){
                this.setvoice.speech_ratemoren = e
            },
            // 选择感情
            emotionChange(e){
                this.setvoice.qingxumoren = e
            },
            // 语调调节
            toneChange(e){
                this.setvoice.pitch_ratemoren = e
            },
            // 上传声音
            soundSuccess(res) {
                console.log(res);
                if( this.soundUrl != ''){
                    this.soundExceed()
                    return
                }
                this.soundUrl = res.data.fullurl
                this.isSound = 'sc'
            },
            soundBeforeUpload(file) {
                if( this.soundUrl != ''){
                    this.soundExceed()
                    return
                }
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isLt10M) {
                    this.$message.error('声音大小不能超过 10MB!');
                }else{
                    this.soundName = file.name
                }
            },
            // 超出上传限制
            soundExceed() {
                this.$message.warning('上传声音数量不能超过 1 个！');
            },
            // 智能剪辑上传视频
            jjVideoSuccess(res) {
                console.log(res);
                if( this.videoUrl != ''){
                    this.videoExceed()
                    return
                }
                this.videoUrl = res.data.fullurl
            },
            jjVideoBeforeUpload(file) {
                if( this.videoUrl != ''){
                    this.videoExceed()
                    return
                }
                const isLt50M = file.size / 1024 / 1024 < 50;
                if (!isLt50M) {
                    this.$message.error('视频大小不能超过 50MB!');
                }
            },
            // 超出上传限制
            jjVideoExceed() {
                this.$message.warning('上传视频数量不能超过 1 个！');
            },
            // 上传音乐
            musicSuccess(res) {
                this.musicUrl = res.data.fullurl
            },
            musicBeforeUpload(file) {
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isLt10M) {
                    this.$message.error('音乐大小不能超过 10MB!');
                }else{
                    this.musicName = file.name
                }
            },
            // 自动发布上传视频
            fbVideoSuccess(res) {
                console.log(res);
                if( this.fbVideoUrl != ''){
                    this.fbVideoExceed()
                    return
                }
                this.fbVideoUrl = res.data.fullurl
            },
            fbVideoBeforeUpload(file) {
                if( this.fbVideoUrl != ''){
                    this.fbVideoExceed()
                    return
                }
                const isLt50M = file.size / 1024 / 1024 < 50;
                if (!isLt50M) {
                    this.$message.error('视频大小不能超过 50MB!');
                }
            },
            // 超出上传限制
            fbVideoExceed() {
                this.$message.warning('上传视频数量不能超过 1 个！');
            },
            // 公共音色
            getCommonvoice() {
                this.request.get('api/shuziren/commonvoice',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        keyword: this.timbreKeyword
                    }
                })
                .then(res=>{
                    this.commonvoice = res.data
                    this.getSoundSelected(false)
                })
            },
            // 我的音色
            getMyvoice() {
                this.request.get('api/shuziren/myvoicezn',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        keyword: this.timbreKeyword
                    }
                })
                .then(res=>{
                    this.myvoice = res.data
                })
            },
            // 声音选择封装
			getSoundSelected(e){
				if(this.myvoiceActive != '-1'){
					this.soundSelected = this.myvoice[this.myvoiceActive]
				}
				if(this.commonvoiceActive != '-1'){
					this.soundSelected = this.commonvoice[this.commonvoiceActive]
				}
                if(e){
                    this.timbrePopup = false
                }
                // 停止播放音频，重置所有tryType
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.commonvoice.forEach((item, i) => {
                    this.$set(this.commonvoice[i], 'tryType', false)
                })
                this.myvoice.forEach((item, i) => {
                    this.$set(this.myvoice[i], 'tryType', false)
                })
                
			},
            // 搜索音色
            timbreSearch() {
                if(this.voiceTabActive == '0'){
                    this.commonvoiceActive = 0
                    this.myvoiceActive = '-1'
                    this.getCommonvoice()
                }
                if(this.voiceTabActive == '1'){
                    this.myvoiceActive = 0
                    this.commonvoiceActive = '-1'
                    this.getMyvoice()
                }
            },
            // 新建音色上传声音
            timbreSuccess(res) {
                console.log(res);
                if( this.newTimbreUpUrl != ''){
                    this.timbreExceed()
                    return
                }
                this.newTimbreUpUrl = res.data.fullurl
            },
            timbreBeforeUpload(file) {
                if( this.newTimbreUpUrl != ''){
                    this.timbreExceed()
                    return
                }
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isLt10M) {
                    this.$message.error('声音大小不能超过 10MB!');
                }else{
                    this.newTimbreUpName = file.name
                }
            },
            // 超出上传限制
            timbreExceed() {
                this.$message.warning('上传声音数量不能超过 1 个！');
            },
            // 打开新建音色弹窗
            openNewTimbreDrawer() {
                // 停止所有正在播放的音频
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                // 重置音色列表播放状态
                this.commonvoice.forEach((item, i) => {
                    this.$set(this.commonvoice[i], 'tryType', false)
                })
                this.myvoice.forEach((item, i) => {
                    this.$set(this.myvoice[i], 'tryType', false)
                })
                this.newTimbreUpType = false
                this.newTimbreDrawer = true
            },
            // 播放新建音色音频
            playNewTimbreSound() {
                if (!this.newTimbreUpUrl) {
                    this.$message.warning('暂无音频可播放')
                    return
                }
                // 如果有正在播放的音频，先停止
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.audioPlayer = new Audio(this.newTimbreUpUrl)
                this.audioPlayer.onended = () => {
                    this.newTimbreUpType = false
                    this.audioPlayer = null
                }
                this.audioPlayer.play().catch(err => {
                    console.error('音频播放失败:', err)
                    this.$message.error('音频播放失败')
                })
                this.newTimbreUpType = true
            },
            // 停止新建音色音频
            stopNewTimbreSound() {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.newTimbreUpType = false
            },
            // 删除新建音色音频
            deleteNewTimbreSound() {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.newTimbreUpType = false
                this.newTimbreUpUrl = ''
            },
            // 开始录音
            startRecord() {
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    this.$message.error('当前浏览器不支持录音功能')
                    return
                }
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(stream => {
                        this.audioChunks = []
                        this.mediaRecorder = new MediaRecorder(stream)
                        this.mediaRecorder.ondataavailable = (event) => {
                            if (event.data.size > 0) {
                                this.audioChunks.push(event.data)
                            }
                        }
                        this.mediaRecorder.onstop = () => {
                            stream.getTracks().forEach(track => track.stop())
                        }
                        this.mediaRecorder.start()
                        this.newTimbreLzStep = '2'
                        this.newTimbreLzRecordDuration = 0
                        this.newTimbreLzTime = '00:00'
                        this.newTimbreLzRecordTimer = setInterval(() => {
                            this.newTimbreLzRecordDuration++
                            const minutes = Math.floor(this.newTimbreLzRecordDuration / 60).toString().padStart(2, '0')
                            const seconds = (this.newTimbreLzRecordDuration % 60).toString().padStart(2, '0')
                            this.newTimbreLzTime = `${minutes}:${seconds}`
                            if (this.newTimbreLzRecordDuration >= 60) {
                                this.endRecord()
                            }
                        }, 1000)
                    })
                    .catch(err => {
                        console.error('录音失败:', err)
                        this.$message.error('无法访问麦克风，请检查权限设置')
                    })
            },
            // 结束录音
            endRecord() {
                if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
                    this.mediaRecorder.stop()
                }
                if (this.newTimbreLzRecordTimer) {
                    clearInterval(this.newTimbreLzRecordTimer)
                    this.newTimbreLzRecordTimer = null
                }
                // 延迟上传，等待 ondataavailable 完成
                setTimeout(() => {
                    const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })
                    const formData = new FormData()
                    formData.append('file', audioBlob, 'recording.wav')
                    this.request.post('/api/common/upload', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }).then(res => {
                        if (res.code == 1) {
                            this.newTimbreLzUrl = res.data.fullurl || res.data || ''
                            this.newTimbreLzStep = '3'
                        } else {
                            this.$message.error(res.msg || '上传失败')
                            this.newTimbreLzStep = '1'
                        }
                    }).catch(err => {
                        console.error('上传失败:', err)
                        this.$message.error('录音上传失败')
                        this.newTimbreLzStep = '1'
                    })
                }, 500)
            },
            // 重录
            againTap() {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.newTimbreLzUrl = ''
                this.newTimbreLzStep = '1'
                this.newTimbreLzTime = '00:00'
                this.newTimbreLzType = false
                this.newTimbreLzRecordDuration = 0
                if (this.newTimbreLzRecordTimer) {
                    clearInterval(this.newTimbreLzRecordTimer)
                    this.newTimbreLzRecordTimer = null
                }
            },
            // 播放录音
            onPlay() {
                if (!this.newTimbreLzUrl) {
                    this.$message.warning('暂无录音可播放')
                    return
                }
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.audioPlayer = new Audio(this.newTimbreLzUrl)
                const totalSeconds = this.newTimbreLzRecordDuration || 1
                let remainingSeconds = totalSeconds
                this.newTimbreLzType = true
                this.newTimbreLzRecordTimer = setInterval(() => {
                    remainingSeconds--
                    if (remainingSeconds <= 0) {
                        remainingSeconds = 0
                        clearInterval(this.newTimbreLzRecordTimer)
                        this.newTimbreLzRecordTimer = null
                        this.newTimbreLzType = false
                        this.audioPlayer = null
                    }
                    const minutes = Math.floor(remainingSeconds / 60).toString().padStart(2, '0')
                    const seconds = (remainingSeconds % 60).toString().padStart(2, '0')
                    this.newTimbreLzTime = `${minutes}:${seconds}`
                }, 1000)
                this.audioPlayer.onended = () => {
                    if (this.newTimbreLzRecordTimer) {
                        clearInterval(this.newTimbreLzRecordTimer)
                        this.newTimbreLzRecordTimer = null
                    }
                    this.newTimbreLzType = false
                    this.audioPlayer = null
                    // 重置时间
                    const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0')
                    const seconds = (totalSeconds % 60).toString().padStart(2, '0')
                    this.newTimbreLzTime = `${minutes}:${seconds}`
                }
                this.audioPlayer.play().catch(err => {
                    console.error('音频播放失败:', err)
                    this.$message.error('音频播放失败')
                    this.newTimbreLzType = false
                })
            },
            // 暂停播放
            onPause() {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                if (this.newTimbreLzRecordTimer) {
                    clearInterval(this.newTimbreLzRecordTimer)
                    this.newTimbreLzRecordTimer = null
                }
                this.newTimbreLzType = false
                // 重置时间为录音总时长
                const totalSeconds = this.newTimbreLzRecordDuration || 0
                const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0')
                const seconds = (totalSeconds % 60).toString().padStart(2, '0')
                this.newTimbreLzTime = `${minutes}:${seconds}`
            },
            // 克隆音色
            cloneTap() {
                if(this.newTimbreName == ''){
                    this.$message.warning('请输入音色名称！');
                    return
                }
                if(this.newTimbreActive == '0' && this.newTimbreUpUrl == ''){
                    this.$message.warning('请上传音色文件！');
                    return
                }
                if(this.newTimbreActive == '1' && this.newTimbreLzUrl == ''){
                    this.$message.warning('请录制音色！');
                    return
                }
                this.request.get('api/zhineng/zhinengtiyinse',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        video: this.newTimbreActive == '0' ? this.newTimbreUpUrl : this.newTimbreLzUrl,
                        prefix: this.newTimbreName
                    }
                })
                .then(res=>{
                    if(res.code != '1'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success(res.msg);
                        this.newTimbreDrawer = false
                        this.getMyvoice()
                        this.myvoiceActive = 0
                        this.commonvoiceActive = '-1'
                        this.newTimbreUpUrl = ''
                        this.newTimbreName = ''
                        this.newTimbreLzUrl = ''
                    }
                })
            },
            // 生成音频
            dubbingTap(){
                if(this.dubbingLoading){
                    this.$message.warning('正在生成音频，请稍候！');
                    return
                }
                if(this.driveText == ''){
                    this.$message.warning('请输入文本！');
                    return
                }
                this.dubbingUrl = ''
                this.dubbingName = ''
                this.dubbingLoading = true
                this.request.get('api/zhineng/createyinpin',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        voice_id: this.soundSelected.voice_id,
                        wenben: this.driveText,
                        volume: this.setvoice.volumemoren,
                        pitch_rate: this.setvoice.pitch_ratemoren,
                        speech_rate: this.setvoice.speech_ratemoren,
                        instruction: this.setvoice.qingxumoren
                    }
                })
                .then(res=>{
                    if(res.code != '1'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.dubbingUrl = res.data.audio
                        this.dubbingName = res.data.audio_name
                        this.dubbingLoading = false
                    }
                })
            },
            // 播放配音音频
            playDubbing() {
                if (!this.dubbingUrl) {
                    this.$message.warning('暂无音频可播放')
                    return
                }
                // 停止所有其他正在播放的音频
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                    this.soundSelectedType = false
                }
                this.audioPlayer = new Audio(this.dubbingUrl)
                this.audioPlayer.onended = () => {
                    this.dubbingType = false
                    this.audioPlayer = null
                }
                this.audioPlayer.play().catch(err => {
                    console.error('音频播放失败:', err)
                    this.$message.error('音频播放失败')
                })
                this.dubbingType = true
            },
            // 停止配音音频
            stopDubbing() {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.dubbingType = false
            },
            // 获取数字人列表
            getDigitalPersonList(e) {
                this.request.get('api/sucai/shuzirenlist',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        type: e
                    }
                })
                .then(res=>{
                    if(res.code == '1'){
                        if(e == '0'){
                            this.commonDigital = res.data
                            this.getDigitalSelected(false)
                        }else if(e == '1'){
                            this.myDigital = res.data
                        }
                    }
                })
            },
            // 数字人选择封装
			getDigitalSelected(e){
                console.log(this.commonDigitalActive);
                console.log(this.myDigitalActive);
                if(this.myDigitalActive != '-1' && this.myDigital[this.myDigitalActive]){
                    this.digitalSelected = this.myDigital[this.myDigitalActive]
                }
                if(this.commonDigitalActive != '-1' && this.commonDigital[this.commonDigitalActive]){
                    this.digitalSelected = this.commonDigital[this.commonDigitalActive]
                }
                if(e){
                    this.digitalPopup = false
                }
			},
            // 搜索数字人
            digitalSearch() {
                if(this.digitalTabActive == '0'){
                    this.commonDigitalActive = 0
                    this.myDigitalActive = '-1'
                    this.getDigitalPersonList('0')
                }
                if(this.digitalTabActive == '1'){
                    this.myDigitalActive = 0
                    this.commonDigitalActive = '-1'
                    this.getDigitalPersonList('1')
                }
            },
            // 新建数字人上传视频
            newDigitalVideoSuccess(res) {
                console.log(res);
                if( this.newDigitalUrl != ''){
                    this.newDigitalVideoExceed()
                    return
                }
                this.newDigitalUrl = res.data.fullurl
            },
            newDigitalVideoBeforeUpload(file) {
                if( this.newDigitalUrl != ''){
                    this.newDigitalVideoExceed()
                    return
                }
                const isLt100M = file.size / 1024 / 1024 < 50;
                if (!isLt100M) {
                    this.$message.error('视频大小不能超过 100MB!');
                }
            },
            // 超出上传限制
            newDigitalVideoExceed() {
                this.$message.warning('上传视频数量不能超过 1 个！');
            },
            // 克隆数字人
            cloneVideoTap(){
                if(this.newDigitalUrl == ''){
                    this.$message.warning('请上传视频！');
                    return
                }
                this.request.get('api/sucai/addshuziren',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        url: this.newDigitalUrl
                    }
                })
                .then(res=>{
                    if(res.code != '1'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success(res.msg);
                        this.newDigitalDrawer = false
                        this.getDigitalPersonList('1')
                        this.myDigitalActive = 0
                        this.commonDigitalActive = '-1'
                        this.newDigitalUrl = ''
                    }
                })
            },
            // 生成口播视频
            generateVideo() {
                if((this.driveActive == '0' && this.textGenerateVideoLoading) || (this.driveActive == '1' && this.audioGenerateVideoLoading)){
                    this.$message.warning('正在生成视频，请稍候！');
                    return
                }
                if(this.driveActive == '0' && this.dubbingUrl == ''){
                    this.$message.warning('请生成音频！');
                    return
                }
                if(this.driveActive == '1' && this.soundUrl == ''){
                    this.$message.warning('请上传音频或录音！');
                    return
                }
                if(this.driveActive == '0'){
                    this.textGenerateVideoUrl = ''
                    this.textGenerateVideoLoading = true
                }
                if(this.driveActive == '1'){
                    this.audioGenerateVideoUrl = ''
                    this.audioGenerateVideoLoading = true
                }
                this.request.get('api/zhineng/createshipin',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        audio_url: this.driveActive == '0' ? this.dubbingUrl : this.soundUrl,
                        video_url: this.digitalSelected.url
                    }
                })
                .then(res=>{
                    this.textGenerateVideoLoading = false
                    this.audioGenerateVideoLoading = false
                    if(res.code != '1'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success(res.msg);
                        if(this.driveActive == '0'){
                            this.textGenerateVideoUrl = res.data.jieguo
                        } else if(this.driveActive == '1'){
                            this.audioGenerateVideoUrl = res.data.jieguo
                        } 
                        this.videoUrl = res.data.jieguo
                    }
                })
            },
            // 预览视频
            previewVideo(refName) {
                const video = this.$refs[refName]
                if (video) {
                    video.play().catch(err => {
                        console.error('视频播放失败:', err)
                        this.$message.error('视频播放失败')
                    })
                }
            },
            // 预览图片
            previewImage(url) {
                if (!url) {
                    this.$message.warning('暂无图片可预览')
                    return
                }
                window.open(url)
            },
            // 下载视频
            downloadVideo(url) {
                if (!url) {
                    this.$message.warning('暂无视频可下载')
                    return
                }
                const a = document.createElement('a')
                a.href = url
                a.download = ''
                a.target = '_blank'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            },
            // 获取字幕模板列表
            getSubtitlesList() {
                this.request.get('api/zhineng1/zimulist',{
                    params:{
                        
                    }
                })
                .then(res=>{
                    if(res.code == '1'){
                        this.subtitles = res.data
                    }
                })
            },
            // 获取背景音乐列表
            getBgmList() {
                this.request.get('api/zhineng1/musiclist',{
                    params:{
                        
                    }
                })
                .then(res=>{
                    if(res.code == '1'){
                        this.bgmList = res.data
                    }
                })
            },
            // 一键生成主标题副标题
            generateTitleTopic() {
                if(this.driveText == ''){
                    this.$message.warning('请输入文本！');
                    return
                }
                const loading = this.$loading({
                    lock: true,
                    text: '努力生成中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.request.post('api/zhineng1/createtitle',{
                    userid: localStorage.getItem("userId") || 0,
                    wenan: this.driveText
                })
                .then(res=>{
                    loading.close();
                    if(res.code == '1'){
                        this.videoTitle = res.data.main_title
                        this.videoDesc = res.data.sub_title
                    } 
                })
                .catch(err => {
                    loading.close();
                    console.error('生成失败:', err)
                    this.$message.error('生成失败')
                })
            },
            // 获取实景混剪列表
            getEditList() {
                this.request.get('api/zhineng1/hunjianvideolist',{
                    params:{
                        userid: localStorage.getItem("userId") || 0
                    }
                })
                .then(res=>{
                    if(res.code == '1'){
                        this.editList = res.data
                    }
                })
            },
            // 获取实景混剪选中
            getEditSelected() {
                const activeItems = this.editList.filter(item => item.active)
                if (activeItems.length > 0) {
                    this.editActiveName = activeItems.map(item => item.name).join(',')
                    this.editActiveUrl = activeItems.map(item => item.url).join(',')
                } else {
                    this.editActiveName = ''
                    this.editActiveUrl = ''
                }
                this.editPopup = false
            },
            // 播放背景音乐
            playBgmSound(list, index) {
                // 停止当前播放的音频
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                // 清除所有 tryType
                list.forEach((item, i) => {
                    this.$set(list[i], 'tryType', false)
                })
                // 设置当前项 tryType = true
                this.$set(list[index], 'tryType', true)
                // 播放音频
                if (list[index].url) {
                    this.audioPlayer = new Audio(list[index].url)
                    this.audioPlayer.onended = () => {
                        this.$set(list[index], 'tryType', false)
                        this.audioPlayer = null
                    }
                    this.audioPlayer.play().catch(err => {
                        console.error('音频播放失败:', err)
                        this.$message.error('音频播放失败')
                    })
                }
            },
            // 停止背景音乐
            stopBgmSound(list, index) {
                if (this.audioPlayer) {
                    this.audioPlayer.pause()
                    this.audioPlayer = null
                }
                this.$set(list[index], 'tryType', false)
            },
            // 新建数字人上传视频
            newEditVideoSuccess(res) {
                console.log(res.data.fullurl);
                this.request.get('api/zhineng1/addhunjianvideo',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        url: res.data.fullurl
                    }
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success('上传成功');
                        this.getEditList()
                    } 
                })
            },
            newEditVideoBeforeUpload(file) {
                const isLt100M = file.size / 1024 / 1024 < 50;
                if (!isLt100M) {
                    this.$message.error('视频大小不能超过 100MB!');
                }
            },
            // 选择取片间隔
            intervalChange(e){
                this.intervalValue = e
            },
            // 立即剪辑
            immediatelyClip() {
                if(this.editVideoLoading){
                    this.$message.warning('正在生成视频，请稍候！');
                    return
                }
                // if(this.driveActive == '0' && this.dubbingUrl == ''){
                //     this.$message.warning('请生成音频！');
                //     return
                // }
                // if(this.driveActive == '1' && this.soundUrl == ''){
                //     this.$message.warning('请上传音频或录音！');
                //     return
                // }
                if(this.videoUrl == ''){
                    this.$message.warning('请上传视频！');
                    return
                }
                if(this.musicActive == '1' && this.musicUrl == ''){
                    this.$message.warning('请上传音乐！');
                    return
                }
                if(this.videoTitle == ''){
                    this.$message.warning('请输入主标题！');
                    return
                }
                if(this.videoDesc == ''){
                    this.$message.warning('请输入副标题！');
                    return
                }
                if(this.editSwitch && this.editActiveUrl == ''){
                    this.$message.warning('请选择混剪视频！');
                    return
                }
                this.editVideoLoading = true;
                this.editImgUrl = ''
                this.editVideoUrl = ''
                this.request.get('api/zhineng1/createvideo',{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        videourl: this.videoUrl,
                        audiourl: this.driveActive == '0' ? this.dubbingUrl : this.soundUrl,
                        main_title: this.videoTitle,
                        sub_title: this.videoDesc,
                        top_duration: this.titleTimeTab[this.titleTimeActive].value,
                        color: this.subtitles[this.subtitlesActive].rgb,
                        bgm: this.musicActive == '0' ? (this.bgmActive == '-1' ? '' : this.bgmList[this.bgmActive].url) : this.musicUrl,
                        bgmsize: this.musicVolume,
                        ishunjian: this.editSwitch ? '1' : '0',
                        hunjianvideo: this.editActiveUrl,
                        jiange: this.intervalValue,
                        hunjianmoshi: this.editActive+1
                    }
                })
                .then(res=>{
                    this.editVideoLoading = false;
                    if(res.code != '1'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.editImgUrl = res.data.img
                        this.editVideoUrl = res.data.video
                        this.fbVideoUrl = res.data.video
                    } 
                })
            },
            // 清除所有上传图片的记录
            clearAllUploadImages() {
                
                this.textarea = ''
                // 清空视频参考图片
                this.videoReferenceImg = []
                this.videoFileList = []
                if (this.$refs.videoUpload) {
                    this.$refs.videoUpload.clearFiles()
                }
                
                // 清空首帧图片
                this.firstFrame = ''
                this.firstFrameFileList = []
                if (this.$refs.firstFrameUpload) {
                    this.$refs.firstFrameUpload.clearFiles()
                }
                
                // 清空尾帧图片
                this.lastFrame = ''
                this.lastFrameFileList = []
                if (this.$refs.lastFrameUpload) {
                    this.$refs.lastFrameUpload.clearFiles()
                }
                
                // 清空品牌图片
                this.basicImg = ''
                this.basicImgFileList = []
                if (this.$refs.basicImgUpload) {
                    this.$refs.basicImgUpload.clearFiles()
                }
                
                // 清空竞争对手图片
                this.competitorImg = ''
                this.competitorImgFileList = []
                if (this.$refs.competitorImgUpload) {
                    this.$refs.competitorImgUpload.clearFiles()
                }
                
                // 清空知识库文件
                this.fileUrl = ''
                this.fileList = []
                if (this.$refs.knowledgeUpload) {
                    this.$refs.knowledgeUpload.clearFiles()
                }
                
            },
            // 获取图片样式 (倾斜效果)
            getImageStyle(index) {
                const rotations = ['-10deg', '10deg', '-3.5deg'];
                return {
                    transform: `rotate(${rotations[index]})`,
                    transition: 'transform 0.3s'
                };
            },
            // 获取视频生成参数
            getGenerate(){
                let url = this.dreamerData.generate_type ? "api/Generate/createPage1" : "api/Generate/createPage"
                this.request.get(url,{
                    params:{
                        type: this.dreamerData.generate_type ? 2 : 1
                    }
                })
                .then(res=>{
                    let obj = res.data
                    if(this.dreamerData.generate_type){
                        this.imgGenerate = obj
                        this.videoGenerateIndex = '-1'
                        obj.map((el,index) => {
                            if(el.hcid == this.generateId){
                                this.imgGenerateIndex = index
                            }
                        })
                    }else{
                        this.videoGenerate = obj
                        obj.map((el,index) => {
                            if(el.hcid == this.generateId){
                                this.videoGenerateIndex = index
                            }
                        })
                    }
                    
                })
            },
            // 获取作品
            getWork(){
                this.workShow = false
                let userId = localStorage.getItem("userId") || 0
                if(userId != 0){
                    this.request.get("api/order/orderlistPc",{
                        params:{
                           userid: userId,
                           cateid: this.generateId
                        }
                    })
                    .then(res=>{
                        let obj = res.data
                        obj.map(el => {
                            let arr = []
                            if(el.imgs_str.length > 0){
                                arr = el.imgs_str.split(',')
                            }
                            el.newImgs = arr
                        })
                        this.workData = obj
                        this.workShow = true
                        // 等待DOM更新后滚动到最底部
                        this.$nextTick(() => {
                            if (this.$refs.workList) {
                                this.$refs.workList.scrollTop = this.$refs.workList.scrollHeight
                            }
                        })
                    })
                }
			},
            // AI生成上传图片
            videoRemove(file, fileList) {
                console.log(file, fileList);
                console.log(this.videoReferenceImg);
                
                // 获取被删除文件的索引
                const removedIndex = this.videoReferenceImg.findIndex(url => {
                    // 根据 file 的 url 或 response 来匹配
                    return url === file.url || url === (file.response && file.response.data && file.response.data.fullurl)
                })
                
                console.log('被删除的是第', removedIndex, '个元素')
                
                // 从数组中移除对应的图片URL
                if (removedIndex !== -1) {
                    this.videoReferenceImg.splice(removedIndex, 1)
                }
                
                // 更新文件列表，确保是数组
                this.videoFileList = Array.isArray(fileList) ? fileList : []
                
                console.log('删除后的数组:', this.videoReferenceImg);
            },
            videoSuccess(response, file, fileList) {
                console.log(response);
                this.videoReferenceImg.push(response.data.fullurl);
                // 更新文件列表，确保是数组
                this.videoFileList = Array.isArray(fileList) ? fileList : [];
                console.log(this.videoReferenceImg);
            },
            // 上传首帧图片
            firstSuccess(res) {
                console.log('上传首帧图片')
                this.firstFrame = res.data.fullurl
                // 清除文件列表，允许重复上传同一文件
                this.firstFrameFileList = []
                this.$refs.firstFrameUpload.clearFiles()
            },
            firstError(err) {
                console.log('上传首帧图片失败', err)
            },
            // 上传尾帧图片
            lastSuccess(res) {
                this.lastFrame = res.data.fullurl
                // 清除文件列表，允许重复上传同一文件
                this.lastFrameFileList = []
                this.$refs.lastFrameUpload.clearFiles()
            },
            // 立即生成
            generateBtnTap(){
                let that = this
				if(that.videoGenerateIndex != '-1' && that.videoGenerate[that.videoGenerateIndex].model[that.modelActive].diagram_type == '1' && that.videoGenerate[that.videoGenerateIndex].model[that.modelActive].reference_is == '1' && that.videoReferenceImg.length == 0){
                    that.$message.warning('请上传参考图');
					return
				}
				if(that.videoGenerateIndex != '-1' && that.videoGenerate[that.videoGenerateIndex].model[that.modelActive].diagram_type == '0' && (that.firstFrame == '' || that.lastFrame == '')){
                    that.$message.warning('请上传首尾帧');
					return
				}
				if(that.textarea == ''){
                    that.$message.warning('请填写视频创意描述');
					return
				}
                const loading = that.$loading({
                    lock: true,
                    text: '正在生成中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)'
                });
                that.request.post("api/order/create",{
                    userid: localStorage.getItem("userId") || 0,
                    prompt: that.textarea,
                    imgs: that.videoReferenceImg,
                    first: that.videoGenerateIndex == '-1' ? '' : that.firstFrame,
                    last:that.videoGenerateIndex == '-1' ? '' :  that.lastFrame,
                    duration: that.videoGenerateIndex == '-1' ? that.imgGenerate[that.imgGenerateIndex].model[that.modelActive].duration_spec[that.timeActive].duration : that.videoGenerate[that.videoGenerateIndex].model[that.modelActive].duration_spec[that.timeActive].duration,
                    aspect_ratio: that.videoGenerateIndex == '-1' ? that.imgGenerate[that.imgGenerateIndex].model[that.modelActive].ratio_spec[that.proportionActive].ratio_size : that.videoGenerate[that.videoGenerateIndex].model[that.modelActive].ratio_spec[that.proportionActive].ratio_size,
                    num: 1,
                    specid: that.videoGenerateIndex == '-1' ? that.imgGenerate[that.imgGenerateIndex].model[that.modelActive].hcid : that.videoGenerate[that.videoGenerateIndex].model[that.modelActive].hcid,
                    cateid: that.videoGenerateIndex == '-1' ? that.imgGenerate[that.imgGenerateIndex].hcid : that.videoGenerate[that.videoGenerateIndex].hcid,
                    dif: that.videoGenerateIndex == '-1' ? 2 : 1,
                }, {
                    useFormData: true
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        that.clearAllUploadImages()
                        that.getWork()
                    }
                    loading.close();
                })
            },
            // 重新编辑
            reEditClick(e){
                this.textarea = e.prompt
                this.firstFrame = e.first
                this.lastFrame = e.last
                // 回填图片列表到上传组件
                if (e.imgs_str && e.imgs_str !== '') {
                    // 将逗号分隔的字符串转换为数组
                    const imgUrls = e.imgs_str.split(',').filter(url => url.trim() !== '')
                    
                    // 构建 videoFileList，Element UI 需要的格式
                    this.videoFileList = imgUrls.map((url, index) => ({
                        name: `image_${index + 1}`,
                        url: url.trim(),
                        uid: Date.now() + index // 唯一标识
                    }))
                    
                    // 同步更新 videoReferenceImg
                    this.videoReferenceImg = imgUrls.map(url => url.trim())
                    
                    console.log('回填图片列表:', this.videoFileList)
                } else {
                    // 如果没有图片，清空列表
                    this.videoFileList = []
                    this.videoReferenceImg = []
                }
            },
            // 作品查看
            workClick(e,s,d,t){
                if(s != '2'){
                    this.$message.warning('请等待作品完成后查看');
                    return
                }
                if(d == '0'){
                    this.$message.warning('作品已超过保留期限，请重新创作作品');
                    return
                }
                this.workType = t
                this.workUrl = e
                this.workPopup = true
            },
            // 重新生成
            againClick(e){
                let that = this
                that.$confirm('确定要重新生成该作品吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = that.$loading({
                        lock: true,
                        text: '正在生成中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.4)'
                    });
                    that.request.post("api/order/create",{
                        userid: localStorage.getItem("userId") || 0,
                        prompt: e.prompt,
                        imgs: e.imgs_str,
                        first: e.first,
                        last:e.last,
                        duration: e.duration,
                        aspect_ratio: e.aspect_ratio,
                        num: 1,
                        specid: e.specid,
                        cateid: e.cateid,
                        dif: e.type,
                    }, {
                        useFormData: true
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.warning(res.msg);
                        }
                        if(res.code == '1'){
                            that.clearAllUploadImages()
                            that.getWork()
                        }
                        loading.close();
                    })
                })
            },
            // 作品下载
            downloadClick(e,t,d){
                if(t != '2'){
                    this.$message.warning('请等待作品完成后下载');
                    return
                }
                if(d == '0'){
                    this.$message.warning('作品已超过保留期限，请重新创作作品');
                    return
                }
                window.open(e);
            },
            // 作品删除
            deleteClick(e){
                this.$confirm('确定要删除该作品吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.request.get("api/order/orderdelete",{
                        params:{
                           order_num: e
                        }   
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.warning(res.msg);
                        }
                        if(res.code == '1'){
                            this.$message.success('删除成功');
                            this.getWork()
                        }
                    })
                })
            },
            // 获取知识库列表
            getKnowledge(){
                let userId = localStorage.getItem("userId") || 0
                if(userId != 0){
                    this.request.get("index/Knowledgebase/list",{
                        params:{
                           userid: localStorage.getItem("userId") || 0,
                           page: this.knowledgePage,
                           pagesize: '20',
                           keyword: this.knowledge
                        }
                    })
                    .then(res=>{
                        let obj = res.data
                        if(obj.list.length == 0 && this.knowledgePage != 1){
                            this.knowledgePage--
                            this.getKnowledge()
                        }else{
                            this.knowledgeTabData = obj
                        }
                    })
                }
			},
            // 内容生产分页
            contentSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.contentPageSize = val
                this.getContentList()
            },
            contentCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.contentPage = val
                this.getContentList()
            },
            // 获取品牌行业
            getIndustry(){
                this.request.get("index/Basicinfo/getIndustryTree",{
                    params:{
                        
                    }
                })
                .then(res=>{
                    this.industry = res.data
                    this.getBasic()
                })
			},
            // 获取内容生成策略模板
            getTemplate(){
                this.request.get("index/Geo/geoTemplate",{
                    params:{
                        
                    }
                })
                .then(res=>{
                    this.templateData = res.data
                })
			},
            // 获取内容生成知识库下拉框数据
            getCreateZsk(){
                this.request.get("index/Knowledgebase/selectKnowledge",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        keyword: this.createZskKey
                    }
                })
                .then(res=>{
                    // this.createZskActive = '-1'
                    this.createZskActiveName = ''
                    this.createZskActiveId = ''
                    this.createZskData = res.data
                })
			},
            // 内容生产选择知识库
            createZskTap(e){
                this.createZskData[e].active = !this.createZskData[e].active
                this.createZskActiveName = ''
                this.createZskActiveId = ''
                this.createZskData.map((item, index) => {
                    if(item.active){
                        this.createZskActiveName = this.createZskActiveName == '' ? item.label : this.createZskActiveName + ',' + item.label
                        this.createZskActiveId = this.createZskActiveId == '' ? item.value : this.createZskActiveId + ',' + item.value
                    }
                })
            },
             // 获取内容生成AI平台下拉框数据
            getCreateAI(){
                this.request.get("index/Geo/aiPlatform",{
                    params:{
                        
                    }
                })
                .then(res=>{
                    this.createAIData = res.data
                })
			},
            // 目标用户列表
            getTargetList(e){
                if(e){
                    this.localStorage = 1
                }
                this.request.get("index/Targetuser/getList",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        page: this.targetPage,
                        pagesize: this.targetPageSize,
                        keyword: this.target
                    }
                })
                .then(res=>{
                    let obj = res.data
                    if(obj.list.length == 0 && this.targetPage != 1){
                        this.targetPage--
                        this.getTargetList()
                    }else{
                        this.targetData = obj
                    }
                })
            },
            // 新增目标用户
            addTargetTap(){
                this.targetId = ''
                this.portraitName = ''
                this.portraitDesc = ''
                this.portraitDrawer = true
                // 恢复 portraitList 到初始值
                this.portraitList = [
                    {
                        name: '消费偏好',
                        type: '默认维度',
                        desc: ''
                    },
                    {
                        name: '用户需求',
                        type: '默认维度',
                        desc: ''
                    },
                    {
                        name: '用户地域',
                        type: '默认维度',
                        desc: ''
                    }
                ]
            },
            // 删除目标用户
            targetDeleteTap(e){
                console.log(e);
                this.$confirm('确定要删除该目标用户吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.request.get("index/Targetuser/delete",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            id: e
                        }   
                    })
                    .then(res=>{
                        if(res.code == '1'){
                            this.$message.success('删除成功');
                            this.getTargetList()
                        }
                    })
                })
            },
            // 编辑目标用户
            targetEditTap(e){
                this.targetId = e.id
                this.portraitName = e.image_name
                this.portraitDesc = e.image_desc
                this.portraitList = e.dimensions
                this.portraitDrawer = true
            },
             // 目标用户分页
            targetSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.targetPageSize = val
                this.getTargetList()
            },
            targetCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.targetPage = val
                this.getTargetList()
            },
            // 新增/编辑画像维度
            addDimension(e){
                this.portraitIndex = e === '' ? '' : e // 新增时 e 为 undefined，编辑时 e 为当前维度的索引
                this.dimensionPopup = true
                if(this.portraitIndex === ''){
                    this.dimensionName = ''
                    this.dimensionDesc = ''
                }else{
                    this.dimensionName = this.portraitList[this.portraitIndex].name
                    this.dimensionDesc = this.portraitList[this.portraitIndex].desc
                }
            },
            // 保存画像维度
            dimensionTap(){
                if(this.dimensionName == ''){
                    this.$message.warning('请填写维度名称');
                    return
                }
                if(this.dimensionDesc == ''){
                    this.$message.warning('请填写维度描述');
                    return
                }
                if(this.portraitIndex !== ''){
                    this.portraitList[this.portraitIndex].name = this.dimensionName
                    this.portraitList[this.portraitIndex].desc = this.dimensionDesc
                }else{
                    this.portraitList.push({
                        name: this.dimensionName,
                        type: '自定义维度',
                        desc: this.dimensionDesc
                    })
                }
                this.dimensionPopup = false
                this.dimensionName = ''
                this.dimensionDesc = ''
            },
            // 保存目标用户
            portraitBtnTap(){
                let url = this.targetId === '' ? "index/Targetuser/add" : "index/Targetuser/doEdit"
                this.request.post(url,{
                    userid: localStorage.getItem("userId") || 0,
                    image_name: this.portraitName,
                    image_desc: this.portraitDesc,
                    dimensions: JSON.stringify(this.portraitList),
                    id: this.targetId
                }, {
                    useFormData: true
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success(this.targetId === '' ? '添加成功' : '编辑成功');
                        this.portraitDrawer = false
                        if(this.targetId === ''){
                            this.getTargetList(true)
                        }else{
                            this.getTargetList()
                        }
                    }
                })
            },
            // 查询基础信息
            getBasic(){
                this.request.get("index/Basicinfo/detail",{
                    params:{
                        userid: localStorage.getItem("userId") || 0
                    }
                })
                .then(res=>{
                    let obj = res.data
                    this.basicName = obj.brand_name
                    this.basicWeb = obj.brand_website
                    this.basicImg = obj.brand_logo
                    this.industryValue = obj.brand_industry
                    this.basicBusiness = obj.brand_description
                    this.competitor = obj.brand_competitor
                    this.basicStyle = obj.content_style
                    this.basicRule = obj.content_rules
                    this.basicCall = obj.call_to_action
                    this.basicPhone = obj.contact_info
                })
            },
            // 上传品牌图片
            handleAvatarSuccess(res) {
                this.basicImg = res.data.fullurl
                // 清除文件列表，允许重复上传同一文件
                this.basicImgFileList = []
                if (this.$refs.basicImgUpload) {
                    this.$refs.basicImgUpload.clearFiles()
                }
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传品牌图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 添加竞争对手
            addCompetitor(){
                this.competitorPopup = true
            },
            // 添加竞争对手上传品牌logo
            competitorImgSuccess(res) {
                this.competitorImg = res.data.fullurl
                // 清除文件列表，允许重复上传同一文件
                this.competitorImgFileList = []
                if (this.$refs.competitorImgUpload) {
                    this.$refs.competitorImgUpload.clearFiles()
                }
            },
            competitorImgUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传品牌logo大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 添加竞争对手确定
            competitorTap(){
                if(this.competitor.length >= 15){
                    this.$message.warning('最多可设置15个竞争对手');
                    return
                }
                if(this.competitorName == ''){
                    this.$message.warning('请填写品牌名称');
                    return
                }
                this.competitor.push({
                    name: this.competitorName,
                    website: this.competitorWeb,
                    logo: this.competitorImg
                })
                console.log(this.competitor)
                this.competitorPopup = false
                this.competitorName = ''
                this.competitorWeb = ''
                this.competitorImg = ''
            },
            // 编辑竞争对手
            competitorEdit(e){
                this.competitorName = this.competitor[e].name
                this.competitorWeb = this.competitor[e].website
                this.competitorImg = this.competitor[e].logo
                this.competitorPopup = true
            },
            // 删除竞争对手
            competitorDel(e){
                this.competitor.splice(e, 1)
            },
            // 基础信息保存
            basicBtnTap(){
                console.log('保存信息')
                if(this.basicName == ''){
                    this.$message.warning('请填写品牌名称');
                    return
                }
                this.request.post("index/Basicinfo/save",{
                    userid: localStorage.getItem("userId") || 0,
                    brand_name: this.basicName,
                    brand_website: this.basicWeb,
                    brand_logo: this.basicImg,
                    brand_industry: this.industryValue,
                    brand_description: this.basicBusiness,
                    brand_competitor: this.competitor,
                    content_style: this.basicStyle,
                    content_rules: this.basicRule,
                    call_to_action: this.basicCall,
                    contact_info: this.basicPhone
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success('保存成功');
                    }
                })
            },
            // 搜索知识库
            knowledgeTap(){
                this.knowledgePage = 1
                this.getKnowledge()
            },
            // 知识库删除
            tabDelClick(e){
                console.log(e)
                this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.request.get("index/Knowledgebase/delete",{
                        params:{
                           userid: localStorage.getItem("userId") || 0,
                           id: e.row.id
                        }
                    })
                    .then(res=>{
                        if(res.code == '1'){
                            this.getKnowledge()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            // 知识库上传文件
            knowledgeSuccess(res, file, fileList) {
                console.log(res)
                console.log('this.fileList')
                console.log(this.fileList)
                this.fileUrl = res.data.fullurl
                // 更新文件列表，确保是数组
                this.fileList = Array.isArray(fileList) ? fileList : []
            },
            knowledgeUpload(file) {
                console.log(file)
                // 获取文件扩展名
                const fileExtension = file.name.split('.').pop().toLowerCase();
                // 定义允许的文件格式
                const allowedFormats = ['pdf', 'docx', 'txt'];
                // 定义不支持的图片格式
                const imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
                
                // 判断是否为图片格式
                if (imageFormats.includes(fileExtension)) {
                    this.$message({
                        message: '不支持上传图片格式文件，仅支持 PDF、DOCX、TXT 格式',
                        type: 'warning'
                    });
                    return false;
                }
                
                // 判断是否为允许的格式
                if (!allowedFormats.includes(fileExtension)) {
                    this.$message({
                        message: '仅支持 PDF、DOCX、TXT 格式文件',
                        type: 'warning'
                    });
                    return false;
                }
                
                return true;
            },
            knowledgeRemove(file, fileList) {
                console.log(file, fileList);
                this.fileUrl = ''
                // 更新文件列表，确保是数组
                this.fileList = Array.isArray(fileList) ? fileList : []
            },
            knowledgePreview(file) {
                console.log(file);
            },
            knowledgeExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            // 立即上传
            knowledgeUpTap(){
                console.log('立即上传')
                let userId = localStorage.getItem("userId") || 0
                if(userId != 0){
                    this.request.get("index/Knowledgebase/add",{
                        params:{
                           userid: userId,
                           name: this.knowledgeName,
                           type: this.knowledgeActive,
                        //    file_url: this.knowledgeActive == '0' ? this.fileUrl : this.knowledgeActive == '1' ? this.knowledgeWeb : this.knowledgeActive == '2' ? this.knowledgeLs : this.knowledgeActive == '3' ? this.knowledgeGz : ''
                        file_url: this.knowledgeActive == '0' ? this.fileUrl : this.knowledgeActive == '1' ? this.knowledgeWeb : this.knowledgeActive == '2' ? this.knowledgeGz :  ''
                        }
                    })
                    .then(res=>{
                        if(res.code == '1'){
                            this.$message.success('上传成功')
                            this.knowledgePopup = false
                            this.knowledgeName = ''
                            this.fileUrl = ''
                            this.knowledgeActive = 0
                            this.knowledge = ''
                            this.knowledgeWeb = ''
                            this.knowledgeLs = ''
                            this.knowledgeGz = ''
                            this.knowledgePage = 1
                            this.getKnowledge()
                        } else {
                            this.$message.error(res.msg)
                        }
                        
                    })
                }
            },
            // 内容生成创建新内容弹窗
            templatePopupTap(){
                this.templatePopup = false
                this.contentCreate = this.templateActive
            },
            // 内容生成创建新内容
            configureBtnTap(){
                if(this.createZskActiveId == ''){
                    this.$message.warning('请选择知识库');
                    return
                }
                if(this.createTitle == ''){
                    this.$message.warning('请输入文章标题');
                    return
                }
                this.request.get("index/geo/geoPopup",{
                    params:{
                        
                    }
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.warning(res.msg);
                    }
                    if(res.code == '1' && res.data.show_popup == '1'){
                        this.geoPopupData = res.data
                        this.geoPopup = true
                    }
                    if(res.code == '1' && res.data.show_popup == '0'){
                        this.geoPopupTap()
                    }
                })
                console.log('创建新内容')
                
            },
            // 确定生成
            geoPopupTap(){
                this.geoPopup = false
                this.request.get("index/Geo/generateArticle",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        geo_template_id: this.templateData[this.contentCreate].id,
                        knowledge_base_id: this.createZskActiveId,
                        title: this.createTitle
                    }
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.error(res.msg);
                    }
                    if(res.code == '1'){
                        this.generate = true
                        setTimeout(() => {
                            this.getResult(res.data.id)
                        }, 80000);
                        this.resultType = '1'
                        this.getProgress()
                    }
                })
            },
            // 查询文章结果
            getResult(e){
                console.log('查询文章结果')
                this.request.get("index/Geo/generateRes",{
                    params:{
                        id: e
                    }
                })
                .then(res=>{
                    if(res.code == '0' && this.generate){
                        setTimeout(() => {
                            this.getResult(e)
                        }, 2000);
                    }
                    if(res.code == '1'){
                        this.resultType = '2'
                        this.resultData = res.data
                        this.step = 8
              
                  } 
                })
            },
            // 生成结果进度
            getProgress(){
                setTimeout(() => {
                    this.step = this.step == 8 ? 8 : this.step += 1
                    if(this.step < 7){
                        this.getProgress()
                    }
                }, 15000);
            },
            // 内容生成列表
            getContentList(e){
                if(e){
                    this.contentPage = 1
                }
                this.request.get("index/Geo/getList",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        status: this.contentTypeValue,
                        geo_template_id: this.contentTemplateValue,
                        keyword: this.contentKeyword,
                        page: this.contentPage,
                        pagesize: this.contentPageSize
                    }
                })
                .then(res=>{
                    let obj = res.data
                    if(obj.list.length == 0 && this.contentPage != 1){
                        this.contentPage--
                        this.getContentList()
                    }else{
                        this.contentTabData = obj
                    }
                })
            },
            // 内容生成导出文章
            contentExportClick(e){
                if(e == ''){
                    this.$message.warning('请等待生成结束后再导出文章');
                    return
                }
                window.open(e);
            },
            // 编辑内容生成文章
            contentEditClick(e){
                console.log(e)
                this.getResult(e.id)
                this.contentCreate = e.geo_template_id
                this.generate = true
                this.contentEdit = true
            },
            // 删除内容生成文章
            contentDelClick(e){
                this.$confirm('此操作将永久删除该内容，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.request.get("index/Geo/articleDelete",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            id: e
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.getContentList()
                            this.$message.success('删除成功');
                        }
                        
                    })
                }).catch(() => {});
            },
            // 内容生成结果页导出文章
            contentDownClick(e){
                if(this.resultData.id == ''){
                    this.$message.warning('请等待生成结束后再导出文章');
                    return
                }
                this.contentExportClick(e)
            },
            // 复制内容
            copyContent(){
                if(this.resultData.id == ''){
                    this.$message.warning('请等待生成结束后再复制内容');
                    return
                }
                // 创建临时文本区域
                const textarea = document.createElement('textarea');
                textarea.value = this.resultData.rich_text;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                
                // 选中文本
                textarea.select();
                
                try {
                    // 执行复制
                    document.execCommand('copy');
                    this.$message.success('复制成功');
                } catch (err) {
                    this.$message.error('复制失败，请手动复制');
                }
                
                // 移除临时元素
                document.body.removeChild(textarea);
            },
            // 保存内容
            saveContent(){
                if(this.resultData.id == ''){
                    this.$message.warning('请等待生成结束后再操作');
                    return
                }
                this.request.post("index/Geo/update",{
                    userid: localStorage.getItem("userId") || 0,
                    id: this.resultData.id,
                    rich_text: this.resultData.rich_text
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.error(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success('保存成功');
                        this.resultData.download_url = res.data
                    }
                })
            },
            // 内容生产分页
            contentSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.contentPageSize = val
                this.getContentList()
            },
            contentCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.contentPage = val
                this.getContentList()
            },
            // 内容生成返回
            contentBack(){
                this.contentCreate = ''
                this.getContentList()
            },
            // 内容生成中返回
            generateBack(){
                this.generate = false
                this.step = 0
                this.resultData.id = ''
                this.resultData.rich_text = ''
                if(this.contentEdit){
                    this.contentCreate = ''
                    this.contentEdit = false
                }
            },
            // 优化单元下拉框搜索
            createYhdySearchTap(){

            },
            // 添加场景问题弹窗显示
            addScene(){
                this.sceneId = ''
                this.sceneVal = ''
                this.sceneArea = ''
                this.sceneIndex = ''
                this.sceneDrawer = true
            },
            // 添加/编辑场景问题弹窗确定
            sceneDrawerTap(){
                if(this.sceneVal == ''){
                    this.$message.warning('请选择话题');
                    return
                }
                if(this.sceneArea == ''){
                    this.$message.warning('请输入场景问题');
                    return
                }
                if(this.sceneId == ''){
                    this.request.get("index/Brandtopic/addProblem",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            topicid: this.sceneVal,
                            discussion: this.sceneArea
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.$message.success('添加成功');
                            this.sceneDrawer = false
                            this.getSceneList(true)
                        }
                    })
                }else{
                    this.request.get("index/Brandtopic/doBrandTopicEdit",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            id: this.sceneId,
                            topic_id: this.sceneVal,
                            discussion: this.sceneArea
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.sceneTabData.list[this.sceneIndex].discussion = this.sceneArea
                            this.$message.success('编辑成功');
                            this.sceneDrawer = false
                            this.sceneVal = ''
                            this.sceneArea = ''
                            this.sceneId = ''
                            this.sceneIndex = ''
                        }
                    })
                }
                
            },
            // 品牌话题-场景问题列表
            getSceneList(e){
                if(e){
                    this.scenePage = 1
                }
                this.request.get("index/Brandtopic/brandTopicList",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        status: this.topicTypeValue,
                        topicid: this.topicSourceValue,
                        start_time: this.topicTime[0],
                        end_time: this.topicTime[1],
                        page: this.scenePage,
                        pagesize: this.scenePageSize
                    }
                })
                .then(res=>{
                    let obj = res.data
                    if(obj.list.length == 0 && this.scenePage != 1){
                        this.scenePage--
                        this.getSceneList()
                    }else{
                        this.sceneTabData = obj
                    }
                })
            },
            // 场景问题表格选择
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection);
            },
            // 场景问题批量操作
            batchBtnTap(e){
                if(this.multipleSelection.length == 0){
                    this.$message.warning('请选择要操作的数据');
                    return
                }
                let ids = ''
                this.multipleSelection.map(item => {
                    ids += ids == '' ? item.id : ',' + item.id
                });
                console.log(ids);
                let url = e == 1 ? 'index/Brandtopic/batchDisable' : e == 2 ? 'index/Brandtopic/batchEnable' : e=='3' ? 'index/Brandtopic/batchDelete' : ''
                this.request.get(url,{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        ids: ids
                    }
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.error(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success('操作成功');
                        this.getSceneList()
                    }
                })
            },
            // 场景问题分页
            sceneSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.scenePageSize = val
                this.getSceneList()
            },
            sceneCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.scenePage = val
                this.getSceneList()
            },
            // 场景问题状态切换
            sceneTabStatusChange(e){
                console.log(e.$index,e.row.status);
                this.request.get("index/Brandtopic/brandTopicStatus",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        id: e.row.id,
                        status: e.row.status
                    }
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.error(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success('操作成功');
                    }
                })
            },
            // 编辑场景问题
            sceneTabEditClick(e){
                console.log(e);
                this.sceneVal = e.row.topic_id
                this.sceneArea = e.row.discussion
                this.sceneId = e.row.id
                this.sceneIndex = e.$index
                this.sceneDrawer = true
            },
            // 删除场景问题
            sceneTabDelClick(e){
                console.log(e.$index);
                this.$confirm('是否删除该场景问题？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.request.get("index/Brandtopic/brandTopicDelete",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            id: e.row.id
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.getSceneList()
                            this.$message.success('删除成功');
                        }
                    })
                })
            },
            // 添加话题弹窗显示
            addTopic(){
                this.topicVal = ''
                this.topicId = ''
                this.topicIndex = ''
                this.topicPopup = true
            },
            // 全部话题
            getTopicAll(){
                this.request.get("index/Brandtopic/selectTopic",{
                    params:{
                        userid: localStorage.getItem("userId") || 0
                    }
                })
                .then(res=>{
                    this.topicSource = res.data
                })
            },
            // 品牌话题-话题列表
            getTopicList(e){
                if(e){
                    this.topicPage = 1
                }
                this.request.get("index/Brandtopic/topicList",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        page: this.topicPage,
                        pagesize: this.topicPageSize
                    }
                })
                .then(res=>{
                    let obj = res.data
                    if(obj.list.length == 0 && this.topicPage != 1){
                        this.topicPage--
                        this.getTopicList()
                    }else{
                        this.topicTabData = obj
                    }
                })
            },
            // 话题分页
            topicSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.topicPageSize = val
                this.getTopicList()
            },
            topicCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.topicPage = val
                this.getTopicList()
            },
            // 话题创建/编辑
            topicTap(){
                if(this.topicVal.length < 2){
                    this.$message.warning('请输入至少两个字符的话题名称');
                    return
                }
                if(this.topicId == ''){
                    this.request.get("index/Brandtopic/add",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            name: this.topicVal
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.getTopicList(true)
                            this.$message.success('添加成功');
                            this.topicPopup = false
                            this.topicVal = ''
                        }
                    })
                }else{
                    this.request.get("index/Brandtopic/doEdit",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            name: this.topicVal,
                            id: this.topicId
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.topicTabData.list[this.topicIndex].name = this.topicVal
                            this.$message.success('编辑成功');
                            this.topicPopup = false
                            this.topicVal = ''
                            this.topicId = ''
                            this.topicIndex = ''
                        }
                    })
                }
            },
            // 话题状态切换
            topicTabStatusChange(e){
                console.log(e.$index,e.row.status);
                this.request.get("index/Brandtopic/status",{
                    params:{
                        userid: localStorage.getItem("userId") || 0,
                        id: e.row.id,
                        status: e.row.status
                    }
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.error(res.msg);
                    }
                    if(res.code == '1'){
                        this.$message.success('操作成功');
                    }
                })
            },
            // 编辑话题
            topicTabEditClick(e){
                console.log(e);
                this.topicVal = e.row.name
                this.topicId = e.row.id
                this.topicIndex = e.$index
                this.topicPopup = true
            },
            // 删除话题
            topicTabDelClick(e){
                console.log(e.$index);
                this.$confirm('是否删除该话题？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.request.get("index/Brandtopic/delete",{
                        params:{
                            userid: localStorage.getItem("userId") || 0,
                            id: e.row.id
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.getTopicList()
                            this.$message.success('删除成功');
                        }
                    })
                })
            },
            // 获取会员数据
            getVip(){
                this.request.get("api/Membership/pclist",{
                    params:{
                        userid: localStorage.getItem("userId") || 0
                    }
                })
                .then(res=>{
                    this.vipData = res.data.list
                    this.vipAgreementName = res.data.xieyiname
                })
			},
             // 获取协议
            getAgreement(e){
                this.request.get("api/user/agreement",{
                    params:{
                        id: e
                    }
                })
                .then(res=>{
                    this.agreementText = res.data
                    this.agreementPopup = true
                })
			},
            // 购买会员
            vipBtnTap(e){
                if(!e.active){
                    this.$message.warning('请先阅读并同意《绘梦AI付费服务协议》');
                    return
                }
                this.request.get("api/Nativepay/createOrder",{
                    params:{
                        id: e.id,
                        type: e.type,
                        userid: localStorage.getItem("userId") || 0,
                    }
                })
                .then(res=>{
                    if(res.code == '0'){
                        this.$message.error(res.msg);
                    }
                    if(res.code == '1'){
                        this.payData = res.data
                        this.vipPayPopup = true
                        this.payPolling = true; // 启动轮询标志
                        this.getPayType()
                    }
                })
			},
            // 获取支付结果
            getPayType(){
                // 如果轮询标志为false，则停止轮询
                if (!this.payPolling) {
                    return;
                }
                
                this.request.get("api/Nativepay/payStatus",{
                    params:{
                        order_sn: this.payData.order_sn || 0,
                    }
                })
                .then(res=>{
                    if(res.data == '0'){
                        setTimeout(() => {
                            this.getPayType()
                        }, 3000);
                    }
                    if(res.data == '1'){
                        this.getVip()
                        this.$message.success('支付成功');
                        this.vipPayPopup = false
                    }
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .indexContent{
       flex: 1;
       max-height: 100vh;
       overflow-y: scroll;
       overflow-x: hidden;
        /deep/ .el-dialog__header {
            display: flex;
            // justify-content: center;
        }
        .ipContent{
            width: calc(100vw - 240px);
            background: linear-gradient( 0deg, #F8F9FA 46.15%, #C8FFED 78.48%);
            border-radius: 32px;
            overflow: hidden;
            position: relative;
            z-index: 1;
            .ipBg{
                width: calc(100vw - 240px);
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
            }
            .ipList{
                width: calc(100vw - 304px);
                padding: 7.8vw 32px 56px 32px;
                position: relative;
                z-index: 3;
                align-items: flex-start;
                .ipBox{
                    flex: 1;
                    padding: 24px 16px;
                    margin: 0 8px;
                    background: linear-gradient( 180deg, rgba(255,255,255,0.66) 0%, #FFFFFF 27.88%);
                    border-radius: 16px;
                    .ipTopBox{
                        width: 100%;
                        height: 40px;
                        position: relative;
                        z-index: 4;
                        .ipTop{
                            font: bold 20px/40px "Microsoft YaHei";
                            text-align: center;
                            position: relative;
                            z-index: 6;
                        }
                        .ipTopIcon{
                            width: 86px;
                            height: 17px;
                            margin-top: -20px;
                            position: relative;
                            z-index: 5;
                        }
                    }
                    .ipTabList{
                        width: calc(100% - 4px);
                        padding: 2px;
                        background: rgba(0,0,0,0.05);
                        border-radius: 19px;
                        margin-top: 12px;
                        .ipTab{
                            flex: 1;
                            height: 34px;
                            text-align: center;
                            font: 14px/32px "Microsoft YaHei";
                            color: #595959;
                            border-radius: 17px;
                            cursor: pointer;
                            &.ipTabOn{
                                color: #000;
                                background: #fff;
                            }
                        }
                    }
                    .ipTitleBox{
                        width: 100%;
                        margin-top: 12px;
                        .ipTitleIcon{
                            width: 4px;
                            height: 14px;
                            background: linear-gradient( 180deg, #2CFFEA 0%, #20F4AD 49.52%, #20F463 94.71%);
                            margin-right: 8px;
                        }
                        .ipTitle{
                            font: 16px/20px "Microsoft YaHei";
                        }
                        .ipTitleImg{
                            width: 20px;
                            height: 20px;
                            margin-left: 4px;
                        }
                        .ipDel{
                            font: 14px/20px "Microsoft YaHei";
                            color: #595959;
                            cursor: pointer;
                        }
                        .ipChange{
                            font: 14px/20px "Microsoft YaHei";
                            color: #00BF7F;
                            cursor: pointer;
                            margin-left: 10px;
                        }
                    }
                    .ipIpt{
                        width: 100%;
                        margin-top: 12px;
                        /deep/ .el-input__inner {
                            height: 46px;
                            font: 14px/46px "Microsoft YaHei";
                            background: #F8F9FA;
                            border-radius: 16px;
                        }
                        /deep/ .el-input__count-inner {
                            background: none;
                        }
                    }
                    .ipBtnList{
                        width: 100%;
                        margin-top: 12px;
                        .ipBtnClear{
                            width: 62px;
                            height: 38px;
                            border-radius: 8px;
                            border: 1px solid #00BF7F;
                            cursor: pointer;
                            font: 14px/38px "Microsoft YaHei";
                            color: #00BF7F;
                            text-align: center;
                            margin-right: 16px;
                        }
                        .ipBtnBox{
                            flex: 1;
                            height: 40px;
                            background: linear-gradient( 90deg, #2CFFEA 0%, #20F4AD 49.52%, #20F463 94.71%);
                            border-radius: 8px;
                            cursor: pointer;
                            .ipBtn{
                                font: 14px/40px "Microsoft YaHei";
                            }
                            .ipBtnIcon{
                                width: 16px;
                                height: 16px;
                                margin-left: 2px;
                            }
                        }
                        .aiLegalBtn{
                            flex: 1;
                            height: 40px;
                            background: #FFE9B9;
                            border-radius: 8px;
                            margin-top: 12px;
                            font: 14px/40px "Microsoft YaHei";
                            color: #804619;
                            text-align: center;
                            margin-right: 16px;
                            cursor: pointer;
                        }
                        .aiBtnBox{
                            flex: 1;
                            height: 40px;
                            background: #000;
                            border-radius: 8px;
                            margin-top: 12px;
                            cursor: pointer;
                            .ipBtn{
                                font: 14px/40px "Microsoft YaHei";
                                color: #20F4AD;
                            }
                            .ipBtnIcon{
                                width: 16px;
                                height: 16px;
                                margin-left: 2px;
                            }
                        }
                    }
                    .extractText{
                        width: calc(100% - 26px);
                        padding: 12px;
                        background: #F8F9FA;
                        border-radius: 16px;
                        border: 1px solid #F0F1F1;
                        margin-top: 12px;
                        font: 14px/22px "Microsoft YaHei";
                        color: #595959;
                    }
                    .countList{
                        width: 100%;
                        margin-top: 12px;
                        .count{
                            flex: 1;
                            height: 36px;
                            background: #F8F9FA;
                            border-radius: 8px;
                            border: 1px solid #F0F1F1;
                            font: 14px/36px "Microsoft YaHei";
                            color: #595959;
                            text-align: center;
                            margin-left: 12px;
                            cursor: pointer;
                            &:first-child{
                                margin-left: 0;
                            }
                        }
                        .countOn{
                            border: 1px solid #00BF7F;
                            color: #000;
                        }
                    }
                    .ipBtnBoxTwo{
                        width: 100%;
                        height: 40px;
                        background: #000;
                        border-radius: 8px;
                        margin-top: 12px;
                        cursor: pointer;
                        .ipBtn{
                            font: 14px/40px "Microsoft YaHei";
                            color: #20F4AD;
                        }
                        .ipBtnIcon{
                            width: 16px;
                            height: 16px;
                            margin-left: 2px;
                        }
                    }
                    .LegalBtn{
                        width: 100%;
                        height: 40px;
                        background: #FFE9B9;
                        border-radius: 8px;
                        margin-top: 12px;
                        font: 14px/40px "Microsoft YaHei";
                        color: #804619;
                        text-align: center;
                        cursor: pointer;
                    }
                }
                .ipTitleTwo{
                    width: calc(100% - 24px);
                    font: 14px/18px "Microsoft YaHei";
                    color: #6C6E73;
                    margin-top: 12px;
                }
                .ipTitleThree{
                    font: 14px/18px "Microsoft YaHei";
                    color: #6C6E73;
                }
                .ipTitleFour{
                    width: calc(100% - 24px);
                    font: 12px/14px "Microsoft YaHei";
                    color: #C0C4CC;
                    margin-top: 5px;
                }
                .standardList{
                    width: calc(100% - 18px);
                    padding: 8px;
                    background: #F8F9FA;
                    border: 1px solid #F0F1F1;
                    border-radius: 16px;
                    margin-top: 12px;
                    .standardBox{
                        padding: 0 15px;
                        height: 30rpx;
                        background: #FDFEFF;
                        border-radius: 8px;
                        border: 1px solid #F0F1F1;
                        margin: 8px;
                        cursor: pointer;
                        .standard{
                            font: 14px/30px "Microsoft YaHei";
                            color: #333;
                        }
                        .standardIcon{
                            width: 12px;
                            height: 12px;
                            margin-left: 2px;
                        }
                    }
                    .standardBoxOn{
                        background: #F5FAF8;
                        border: 1px solid #00BF7F;
                        .standard{
                            color: #000;
                        }
                    }
                }
                .areaBox{
                    width: calc(100% - 26px);
                    padding: 12px;
                    background: #F8F9FA;
                    border: 1px solid #F0F1F1;
                    border-radius: 16px;
                    margin-top: 12px;
                    .topic{
                        width: calc(100% - 34px);
                        padding: 8px 16px;
                        background: #FDFEFF;
                        border-radius: 8px;
                        border: 1px solid #F0F1F1;
                        font: 14px/20px "Microsoft YaHei";
                        color: #333;
                        margin-top: 8px;
                        cursor: pointer;
                        &:first-child{
                            margin: 0;
                        }
                    }
                    .topicOn{
                        background: #F5FAF8;
                        border: 1px solid #00BF7F;
                        color: #000;
                    }
                    .aiArea{
                        width: 100%;
                        /deep/ .el-textarea__inner {
                            font: 14px/22px "Microsoft YaHei";
                            height: 154px;
                            background: none;
                        }
                        /deep/ .el-input__count {
                            background: none;
                        }
                    }
                    .noneImg{
                        width: 180px;
                        height: 130px;
                    }
                    .noneText{
                        font: 12px/16px "Microsoft YaHei";
                        color: #8C8C8C;
                        margin-top: 8px;
                    }
                    .effectNoneImg{
                        width: calc(100% - 28px);
                        height: auto;
                    }
                }
                .driveArea{
                    width: 100%;
                    margin-top: 8px;
                    /deep/ .el-textarea__inner {
                        min-height: 46px;
                        font: 14px/22px "Microsoft YaHei";
                        padding: 12px 15px;
                        border-radius: 16px;
                        background: #F8F9FA;
                    }
                }
                .dubbingSelectBox{
                    width: calc(100% - 26px);
                    padding: 8px 12px;
                    background: #F8F9FA;
                    border-radius: 16px;
                    border: 1px solid #F0F1F1;
                    margin-top: 8px;
                    cursor: pointer;
                    .dubbingSelectImg{
                        width: 30px;
                        height: 30px;
                    }
                    .dubbingSelectName{
                        max-width: calc((100vw - 840px) / 4);
                        flex: 1;
                        font: 14px/30px "Microsoft YaHei";
                        padding: 0 4px;
                        text-align: left;
                    }
                    .dubbingSelectIcon{
                        width: 14px;
                        height: 14px;
                    }
                    .effectBox{
                        flex: 1;
                        margin-left: 4px;
                        .effectName{
                            max-width: calc((100vw - 840px) / 4);
                            font: 14px/22px "Microsoft YaHei";
                        }
                        .effectTime{
                            color: #8C8C8C;
                            margin-top: 4px;
                        }
                    }
                }
                .selectList{
                    width: 100%;
                    .selectBox{
                        flex: 1;
                        margin-left: 8px;
                        &:first-child{
                            margin-left: 0;
                        }
                    }
                    .effectBox{
                        flex: 1;
                        margin-left: 18px;
                        &:first-child{
                            margin-left: 0;
                        }
                    }
                }
                .sliderBox{
                    width: 100%;
                }
                .generateVideoBox{
                    width: calc(100% - 122px);
                    background: #000;
                    border: 1px solid #F0F1F1;
                    border-radius: 16px;
                    overflow: hidden;
                    margin-top: 12px;
                }
                .driveBtnList{
                    width: 100%;
                    margin-top: 8px;
                    .driveBtnLook{
                        width: 62px;
                        height: 38px;
                        border-radius: 8px;
                        border: 1px solid #00BF7F;
                        font: 14px/38px "Microsoft YaHei";
                        color: #00BF7F;
                        text-align: center;
                        cursor: pointer;
                        margin-right: 16px;
                    }
                    .driveBtnDownload{
                        flex: 1;
                        height: 40px;
                        background: #E0FFF5;
                        border-radius: 8px;
                        cursor: pointer;
                        .driveBtnIcon{
                            width: 16px;
                            height: 16px;
                            margin-right: 2px;
                        }
                        .driveBtnText{
                            font: 14px/40px "Microsoft YaHei";
                            color: #00BF7F;
                        }
                    }
                }
                .editVideoBox{
                    width: 100%;
                    height: 178px;
                    background: #000;
                    border: 1px solid #F0F1F1;
                    border-radius: 16px;
                    overflow: hidden;
                    margin-top: 12px;
                    .editVideo{
                        width: 100%;
                        height: 178px;
                    }
                }
                .soundBox{
                    width: calc(100% - 26px);
                    height: 44px;
                    padding: 0 12px;
                    background: #F8F9FA;
                    border-radius: 16px;
                    border: 1px solid #F0F1F1;
                    margin-top: 8px;
                    cursor: pointer;
                    .soundTips{
                        flex: 1;
                        font: 14px/22px "Microsoft YaHei";
                        color: #6C6E73;
                    }
                    .soundIcon{
                        width: 14px;
                        height: 14px;
                        margin-left: 4px;
                    }
                    .soundImg{
                        width: 24px;
                        height: 24px;
                        margin-right: 4px;
                    }
                    .soundName{
                        font: 14px/22px "Microsoft YaHei";
                    }
                }
                .upVideoBox{
                    width: 100%;
                    margin-top: 12px;
                    /deep/ .el-upload {
                        width: 100%;
                    }
                    .upVideo{
                        width: calc(100% - 26px);
                        padding: 8px 12px;
                        background: #F8F9FA;
                        border-radius: 16px;
                        border: 1px solid #F0F1F1;
                        font: 14px/22px "Microsoft YaHei";
                        color: #00BF7F;
                    }
                }
                
                .videoBox{
                    width: 100%;
                    height: auto;
                    border-radius: 16px;
                    background: #000;
                    margin-top: 12px;
                }
                .titleTimeTabList{
                    width: 100%;
                    gap: 12px;
                    margin-top: 8px;
                    .titleTimeTab{
                        flex: 1;
                        padding: 8px 0;
                        background: #F8F9FA;
                        border-radius: 8px;
                        border: 1px solid #F0F1F1;
                        font: 14px/36px "Microsoft YaHei";
                        color: #595959;
                        text-align: center;
                        cursor: pointer;
                        &.titleTimeTabOn{
                            border: 1px solid #00BF7F;
                            background: #F5FAF8;
                            color: #000;
                            .platformTabText{
                                color: #000;
                            }
                        }
                        .platformTabImg{
                            width: 36px;
                            height: 36px;
                        }
                        .platformTabText{
                            font: 14px/22px "Microsoft YaHei";
                            margin-top: 2px;
                        }
                    }
                }
                .upMusic{
                    width: 100%;
                    /deep/ .el-upload {
                        width: 100%;
                    }
                }
            }
        }
       .workList{
            width: 55%;
            min-width: 750px;
            height: calc(100vh - 330px);
            padding: 32px 0;
            overflow-y: scroll;
            // 隐藏滚动条 (Chrome, Safari, Opera)
            &::-webkit-scrollbar {
                display: none;
            }
            // 隐藏滚动条 (IE, Edge, Firefox)
            -ms-overflow-style: none;  // IE and Edge
            scrollbar-width: none;  // Firefox
            .workItem{
                width: 100%;
                margin-top: 24px;
                &:first-child {
                    margin-top: 0;
                }
                .workImages{
                    display: flex;
                    gap: -16px;
                    align-items: center;
                    justify-content: center;
                    .workImage{
                        width: 38px;
                        height: 50px;
                        margin-left: -4px;
                        border-radius: 6px;
                        cursor: pointer;
                        transition: transform 0.3s, z-index 0s;
                        &:hover {
                            transform: rotate(0deg) scale(1.1);
                            z-index: 10;
                        }
                    }
                }
                .workText{
                    max-width: 576px;
                    background: #EEEFF0;
                    border-radius: 16px;
                    padding: 16px;
                    font: 14px/22px "Microsoft YaHei";
                    margin-top: 8px;
                }
                .againBox{
                    cursor: pointer;
                    opacity: 0.35;
                    &:hover {
                        opacity: 1;
                    }
                    .againIcon{
                        width: 16px;
                        height: 16px;
                    }
                    .againText{
                        font: 13px/20px "Microsoft YaHei";
                        margin-left: 4px;
                    }
                }
                .workTime{
                    font: 13px/20px "Microsoft YaHei";
                    color: #8C8C8C;
                    padding-right: 24px;
                }
                .workBox{
					width: 172px;
                    height: 230px;
                    background: #000;
                    border-radius: 8px;
                    overflow: hidden;
					position: relative;
					z-index: 2;
                    margin-top: 24px;
                    cursor: pointer;
					.workStatusBox{
						width: 172px;
						height: 230px;
						position: absolute;
						left: 0;
						top: 0;
						z-index: 3;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						.statusIcon{
							width: 66px;
							height: 66px;
						}
						.statusName{
							font: 14px/20px "Microsoft YaHei";
							color: #fff;
							margin-top: 2px;
						}
					}
					.workImg{
						width: 172px;
						height: 230px;
					}
				}
                .workTipsBox{
                    margin-top: 8px;
                    .workTipsIcon{
                        width: 16px;
                        height: 16px;
                    }
                    .workTips{
                        font: 14px/18px "Microsoft YaHei";
                        color: #8C8C8C;
                        margin-left: 4px;
                    }
                }
                .workBtnList{
                    margin-top: 10px;
                    .workBtnBox{
                        padding: 0 12px;
                        height: 32px;
                        background: #EEEFF0;
                        border-radius: 8px;
                        margin-right: 4px;
                        cursor: pointer;
                        .workBtnIcon{
                            width: 16px;
                            height: 16px;
                        }
                        .workBtn{
                            font: 14px/32px "Microsoft YaHei";
                            margin-left: 4px;
                        }
                    }
                }
            }
            .dreamerNoData{
                max-width: 100%;
                width: 764px;
                .dreamerNoImg{
                    width: 128px;
                    height: 128px;
                }
                .dreamerNoText{
                    font: 14px/22px "Microsoft YaHei";
                    color: #595959;
                    margin-top: 24px;
                }
            }
       }
       .generateBox{
            width: 732px;
            padding: 16px;
            background: #FEFFFF;
            border-radius: 24px;
            border: 1px solid #F0F1F1;
            margin-top: 24px;
            /deep/ .el-upload-list__item {
                width: 50px;
                height: 68px;
            }
            /deep/ .el-upload--picture-card {
                width: 50px;
                height: 68px;
                border: none;
            }
            .generateUpImgBox{
                width: 50px;
                height: 74px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            .generateUpImg{
                width: 50px;
                height: 68px;
                border-radius: 8px;
                background: #F2F4F5;
                border: 1px solid #F0F1F1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-left: 6px;
                &:first-child{
                    margin-left: 0;
                }
                .generateImg{
                    width: 50px;
                    height: 74px;
                    border-radius: 8px;
                }
                .addIcon{
                    width: 16px;
                    height: 16px;
                }
                .addName{
                    font: 10px/14px "Microsoft YaHei";
                    color: #8C8C8C;
                }
            }
            .generateArea{
                width: 732px;
                font: 14px/20px "Microsoft YaHei";
                margin-top: 10px;
            }
            .generateBtnBox{
                margin-top: 4px;
                .generateModelSelest{
                    &:hover {
                        .generateModelOptionPos{
                            display: block;
                        }
                    }
                }
                .generateTimeSelest{
                    &:hover {
                        .generateTimeOptionPos{
                            display: block;
                        }
                    }
                }
                .generateSelest{
                    padding: 0 14px;
                    height: 36px;
                    border-radius: 8px;
                    border: 1px solid #F0F1F1;
                    cursor: pointer;
                    margin-right: 4px;
                    position: relative;
                    .selectIcon{
                        width: 24px;
                        height: 24px;
                    }
                    .selectMiniIcon{
                        width: 16px;
                        height: 16px;
                    }
                    .selectName{
                        font: 14px/36px "Microsoft YaHei";
                        padding-left: 4px;
                    }
                    .selectLine{
                        width: 1px;
                        height: 10px;
                        background: rgba(0,0,0,0.05);
                        margin: 0 4px;
                    }
                    .direct{
                        color: #00BF7F;
                    }
                    .generateOptionPos{
                        padding-bottom: 8px;
                        position: absolute;
                        bottom: 36px;
                        left: -12px;
                        z-index: 99;
                        display: none;
                        .generateOptionBox{
                            padding: 10px 16px;
                            background: #fff;
                            box-shadow: 0 4px 22px 0 rgba(0,0,0,0.08);
                            border-radius: 16px;
                            .optionType{
                                font: 12px/16px "Microsoft YaHei";
                                color: #8C8C8C;
                                padding-bottom: 8px;
                            }
                            .optionModelBox{
                                width: 164px;
                                height: 44px;
                                padding: 0 12px;
                                border-radius: 8px;
                                margin-top: 2px;
                                &:hover {
                                    background: rgba(0,0,0,0.03);
                                }
                                .optionModel{
                                    font: 14px/18px "Microsoft YaHei";
                                }
                                .modelStatus{
                                    padding: 0 4px;
                                    height: 18px;
                                    background: rgba(0,178,119,0.05);
                                    border-radius: 24px;
                                    font: 10px/18px "Microsoft YaHei";
                                    color: #00BF7F;
                                    margin-left: 4px;
                                }
                            }
                            .optionModelBoxOn{
                                background: rgba(0,0,0,0.03);
                            }
                            .optionList{
                                width: 308px;
                                background: #F8F9FA;
                                border-radius: 8px;
                                .optionBox{
                                    flex: 1;
                                    padding: 12px 0;
                                    border-radius: 8px;
                                    .optionName{
                                        font: 14px/18px "Microsoft YaHei";
                                    }
                                    .timeStatus{
                                        padding: 0 4px;
                                        height: 18px;
                                        background: rgba(0,0,0,0.04);
                                        border-radius: 24px;
                                        font: 10px/18px "Microsoft YaHei";
                                        color: #8C8C8C;
                                        margin-left: 4px;
                                    }
                                    .timeStatusOn{
                                        color: #00BF7F;
                                    }
                                    .optionIcon{
                                        width: 16px;
                                        height: 16px;
                                        margin-bottom: 4px;
                                    }
                                }
                                .optionBoxOn{
                                    background: rgba(0,0,0,0.05);
                                }
                            }
                        }
                    }
                }
                .pointsIcon{
                    width: 16px;
                    height: 16px;
                }
                .pointsText{
                    font: 14px/18px "Microsoft YaHei";
                }
                .selectBtn{
                    width: 30px;
                    height: 30px;
                    margin-left: 8px;
                    cursor: pointer;
                }
            }
       }
       .geoBox{
            width: calc(100% - 80px);
            padding: 0 40px;
            display: flex;
            flex-direction: column;
            .geoTopTitle{
                font: 20px/25px "Microsoft YaHei";
                margin-top: 38px;
            }
            .geoTopTips{
                font: 12px/15px "Microsoft YaHei";
                color: #8C8C8C;
                margin-top: 8px;
            }
            .geoSearchBox{
                padding: 24px 0;
                background: #F8F9FA;
            }
            .targetIpt{
                width: 240px;
                height: 36px;
                background: #fff;
                border-radius: 4px;
                font: 14px/36px "Microsoft YaHei";
                /deep/ .el-input__inner {
                    height: 36px;
                }
                .targetIptIcon {
                    padding: 0 8px;
                    cursor: pointer;
                }
            }
            .targetOption{
                width: 240px;
                height: 36px;
                background: #fff;
                border-radius: 4px;
                font: 14px/36px "Microsoft YaHei";
                margin-left: 16px;
                /deep/ .el-input__inner {
                    height: 36px;
                }
                /deep/ .el-input__icon {
                    line-height: 36px;
                }
            }
            .targetList{
                height: calc(100vh - 230px);
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
                gap: 16px;
                overflow-y: scroll;
                 // 隐藏滚动条 (Chrome, Safari, Opera)
                &::-webkit-scrollbar {
                    display: none;
                }
                // 隐藏滚动条 (IE, Edge, Firefox)
                -ms-overflow-style: none;  // IE and Edge
                scrollbar-width: none;  // Firefox
                .targetBox{
                    width: 338px;
                    padding: 24px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #F0F1F1;
                    .targetName{
                        max-width: 230px;
                        font: 14px/28px "Microsoft YaHei";
                    }
                    .targetBtn{
                        padding: 0 12px;
                        height: 28px;
                        border-radius: 4px;
                        font: 12px/28px "Microsoft YaHei";
                        cursor: pointer;
                        &:hover{
                            background: rgba(0,0,0,0.03);
                        }
                    }
                    .targetEdit{
                        color: #00BF7F;
                        margin-left: 8px;
                    }
                    .targetTextBox{
                        width: 316px;
                        height: 92px;
                        background: #F8F9FA;
                        border-radius: 8px;
                        padding: 12px;
                        margin-top: 12px;
                        .targetText{
                            width: 316px;
                            height: 92px;
                            font: 14px/18px "Microsoft YaHei";
                            color: #595959;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 5;
                            -webkit-box-orient: vertical;
                        }
                    }
                    .preference{
                        font: 14px/18px "Microsoft YaHei";
                        color: #333;
                        margin-top: 10px;
                        .preferenceSpan{
                            color: #8C8C8C;
                        }
                    }
                    
                }
            }
            .basicBox{
                width: calc(100% - 24px);
                height: calc(100vh - 142px);
                padding: 12px;
                border-radius: 24px;
                background: #fff;
                margin-top: 16px;
                position: relative;
                .basicScroll{
                    width: calc(100% - 24px);
                    height: calc(100vh - 219px);
                    border-radius: 24px;
                    overflow-y: scroll;
                    // 隐藏滚动条 (Chrome, Safari, Opera)
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    // 隐藏滚动条 (IE, Edge, Firefox)
                    -ms-overflow-style: none;  // IE and Edge
                    scrollbar-width: none;  // Firefox
                    .basicItem{
                        margin-top: 20px;
                        .basicTitle{
                            width: 136px;
                            font: 14px/42px "Microsoft YaHei";
                            color: #606266;
                            text-align: right;
                            margin-right: 12px;
                            .basicTitleIcon{
                                color: #F56C6C;
                            }
                        }
                        .basicIpt{
                            width: 320px;
                            height: 40px;
                            background: #fff;
                            border-radius: 4px;
                            font: 14px/40px "Microsoft YaHei";
                        }
                        .basicImgBox{
                            width: 86px;
                            height: 86px;
                            background: #fff;
                            border-radius: 4px;
                            border: 1px solid #E4E7ED;
                            overflow: hidden;
                            .basicImg{
                                width: 86px;
                                height: 86px;
                            }
                            .basicImgNoBox{
                                width: 86px;
                                height: 86px;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                .basicIcon{
                                    width: 16px;
                                    height: 16px;
                                }
                                .basicImgNoText{
                                    font: 14px/22px "Microsoft YaHei";
                                    color: #606266;
                                    margin-top: 4px;
                                }
                            }
                        }
                        .basicTips{
                            font: 12px/18px "Microsoft YaHei";
                            color: #909399;
                            margin-top: 4px;
                        }
                        .competitorBox{
                            width: 528px;
                            height: 56px;
                            padding: 0 16px;
                            background: #F8F9FA;
                            border-radius: 4px;
                            border: 1px solid #F0F1F1;
                            margin-top: 8px;
                            .competitorIcon{
                                width: 24px;
                                height: 24px;
                                border-radius: 50%;
                            }
                            .competitorTextIcon{
                                width: 24px;
                                height: 24px;
                                border-radius: 50%;
                                background: #E5F5F0;
                                font: 14px/24px "Microsoft YaHei";
                                color: #00BF7F;
                                text-align: center;
                            }
                            .competitorName{
                                flex: 1;
                                padding: 0 8px;
                                font: 14px/24px "Microsoft YaHei";
                            }
                        }
                        .industryOption{
                            width: 216px;
                            height: 40px;
                            background: #fff;
                            border-radius: 4px;
                            font: 14px/40px "Microsoft YaHei";
                        }
                        .basicArea{
                            width: 530px;
                            background: #fff;
                            border-radius: 4px;
                            font: 14px/40px "Microsoft YaHei";
                        }
                    }
                }
                .basicBtnBox{
                    width: 100%;
                    padding: 12px 0 24px 0;
                    display: flex;
                    justify-content: center;
                    border-top: 1px solid #F0F1F1;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: #fff;
                }
            }
            .knowledgeTabBox{
                height: calc(100vh - 180px);
                background: #fff;
                /deep/ .el-button--text {
                    color: #F84025;
                    &:hover {
                        color: #fa654e;
                    }
                }
                /deep/ .el-tag--success {
                    color: #00BF7F;
                    border: 1px solid #D8F3EA;
                }
                // /deep/ .el-table {
                //     .cell{
                //         overflow: hidden;
                //         white-space: nowrap;
                //         text-overflow: ellipsis;
                //     }
                // }
                .empty{
                    padding: 105px 0 175px 0;
                    .emptyImg{
                        width: 360px;
                        height: 260px;
                    }
                    .emptyText{
                        font: 12px/16px "Microsoft YaHei";
                        color: #8C8C8C;
                        margin-top: 22px;
                    }
                }
            }
            .contentTabBox{
                max-height: calc(100vh - 180px);
                background: #fff;
                /deep/ .el-tag--success {
                    color: #00BF7F;
                    border: 1px solid #D8F3EA;
                }
                .contentEmpty{
                    padding: 105px 0 175px 0;
                    .contentEmptyImg{
                        width: 360px;
                        height: 260px;
                    }
                    .contentEmptyText{
                        font: 12px/16px "Microsoft YaHei";
                        color: #8C8C8C;
                        margin-top: 22px;
                    }
                }
            }
            .configureContent{
                min-width: 920px;
                .configureTop{
                    margin-top: 32px;
                    height: 40px;
                    .backBox{
                        width: 90px;
                        cursor: pointer;
                        .backIcon{
                            width: 24px;
                            height: 24px;
                        }
                        .backText{
                            font: 16px/40px "Microsoft YaHei";
                            margin-left: 10px;
                        }
                    }
                }
                .configureBottom{
                    width: 100%;
                    height: calc(100vh - 104px);
                    margin: 16px 0;
                    .configureBox{
                        width: 400px;
                        height: calc(100vh - 154px);
                        background: #fff;
                        border-radius: 16px;
                        border: 1px solid #F0F1F1;
                        padding: 24px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        .configureList{
                            width: 400px;
                            height: calc(100vh - 214px);
                            overflow-y: scroll;
                            // 隐藏滚动条 (Chrome, Safari, Opera)
                            &::-webkit-scrollbar {
                                display: none;
                            }
                            // 隐藏滚动条 (IE, Edge, Firefox)
                            -ms-overflow-style: none;  // IE and Edge
                            scrollbar-width: none;  // Firefox
                            .configureTitle{
                                font: 20px/25px "Microsoft YaHei";
                            }
                            .configureTips{
                                font: 12px/15px "Microsoft YaHei";
                                color: #8C8C8C;
                                margin-top: 8px;
                                padding-bottom: 4px;
                            }
                            .configureSelectBox{
                                width: 374px;
                                padding: 10px 12px;
                                background: #fff;
                                border-radius: 16px;
                                border: 1px solid #F0F1F1;
                                margin-top: 12px;
                                cursor: pointer;
                                position: relative;
                                &:hover{
                                    border: 1px solid #00BF7F;
                                }
                                .configureSelectTitle{
                                    font: 14px/22px "Microsoft YaHei";
                                    color: #606266;
                                    .configureSelectTitleIcon{
                                        color: #F56C6C;
                                    }
                                }
                                .configureSelectTextBox{
                                    margin-top: 4px;
                                    .configureSelectText{
                                        max-width: 358px;
                                        font: 14px/32px "Microsoft YaHei";
                                    }
                                    .configureSelectTextOn{
                                        color: #C0C4CC;
                                    }
                                    .configureSelectTextIcon{
                                        width: 14px;
                                        height: 14px;
                                    }
                                }
                                .configureSelectPos{
                                    width: 248px;
                                    padding: 0 8px;
                                    background: #fff;
                                    border-radius: 16px;
                                    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
                                    position: absolute;
                                    left: 0;
                                    top: 90px;
                                    z-index: 9;
                                    .configureSelectSearchIpt{
                                        width: 248px;
                                        height: 36px;
                                        background: #fff;
                                        border-radius: 8px;
                                        font: 14px/36px "Microsoft YaHei";
                                        margin-top: 6px;
                                        /deep/ .el-input__inner {
                                            height: 36px;
                                        }
                                        .configureSelectSearchIcon {
                                            padding: 0 8px;
                                            cursor: pointer;
                                        }
                                    }
                                    .configureOptionBox{
                                        width: 248px;
                                        max-height: 234px;
                                        margin-top: 8px;
                                        overflow-y: scroll;
                                        // 隐藏滚动条 (Chrome, Safari, Opera)
                                        &::-webkit-scrollbar {
                                            display: none;
                                        }
                                        // 隐藏滚动条 (IE, Edge, Firefox)
                                        -ms-overflow-style: none;  // IE and Edge
                                        scrollbar-width: none;  // Firefox
                                        .configureOption{
                                            &.configureOptionOn{
                                                color: #00BF7F;
                                            }
                                            width: 232px;
                                            height: 38px;
                                            padding: 0 8px;
                                            border-radius: 8px;
                                            font: 14px/38px "Microsoft YaHei";
                                            color: #606266;
                                            cursor: pointer;
                                            &:hover{
                                                background: rgba(0,0,0,0.03);
                                            }
                                            .configureOptionIcon{
                                                width: 14px;
                                                height: 14px;
                                            }
                                            .configureOptionName{
                                                padding-left: 4px;
                                            }
                                        }
                                    }
                                }
                                .aiSelectPos{
                                    width: 212px;
                                    padding: 6px 8px;
                                    background: #fff;
                                    border-radius: 16px;
                                    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
                                    position: absolute;
                                    left: 0;
                                    top: 90px;
                                    z-index: 9;
                                    .aiOptionBox{
                                        width: 212px;
                                        height: 38px;
                                        border-radius: 8px;
                                        .aiOptionIcon{
                                            width: 14px;
                                            height: 14px;
                                        }
                                        .aiOptionHead{
                                            width: 16px;
                                            height: 16px;
                                            margin: 0 4px;
                                        }
                                        .aiOptionName{
                                            font: 14px/38px "Microsoft YaHei";
                                            color: #606266;
                                        }
                                    }
                                    .aiOptionBoxOn{
                                        .aiOptionName{
                                            color: #00BF7F !important;
                                        }
                                    }
                                }
                                .configureSelectIpt{
                                    width: 374px;
                                    height: 32px;
                                    margin-top: 4px;
                                    /deep/ .el-input__inner {
                                        height: 32px;
                                        border: none !important;
                                        background: none !important;
                                        padding: 0 !important;
                                    }
                                }
                            }
                        }
                        .configureBtnBox{
                            width: 400px;
                            height: 40px;
                            background: #00BF7F;
                            border-radius: 8px;
                            cursor: pointer;
                            .configureBtnIcon{
                                width: 16px;
                                height: 16px;
                            }
                            .configureBtnText{
                                font: 14px/40px "Microsoft YaHei";
                                color: #fff;
                                margin-left: 4px;
                            }
                        }
                    }
                    .noConfigureBox{
                        flex: 1;
                        margin-left: 20px;
                        height: calc(100vh - 254px);
                        padding-bottom: 148px;
                        background: #F5F6F7;
                        border-radius: 16px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        .noConfigureImg{
                            width: 360px;
                            height: 260px;
                        }
                        .noConfigureText{
                            font: 20px/25px "Microsoft YaHei";
                            margin-top: 32px;
                        }
                        .noConfigureTips{
                            font: 16px/20px "Microsoft YaHei";
                            color: #8C8C8C;
                            margin-top: 12px;
                        }
                    }
                }
                .generateTop{
                    margin-top: 32px;
                    height: 48px;
                    .backBox{
                        width: 90px;
                        cursor: pointer;
                        .backIcon{
                            width: 24px;
                            height: 24px;
                        }
                        .backText{
                            font: 16px/40px "Microsoft YaHei";
                            margin-left: 10px;
                        }
                    }
                    .generateTitle{
                        font: 20px/24px "Microsoft YaHei";
                        padding-bottom: 6px;
                    }
                    .generateTipsIcon{
                        width: 16px;
                        height: 16px;
                    }
                    .generateTips{
                        flex: 1;
                        font: 12px/16px "Microsoft YaHei";
                        color: #8C8C8C;
                        margin-left: 6px;
                    }
                    .generateTopBtnBox{
                        opacity: 0.2;
                    }
                }
                .generateBottom{
                    width: 100%;
                    height: calc(100vh - 112px);
                    margin: 16px 0;
                    .generateTabBox{
                        width: 450px;
                        height: calc(100vh - 114px);
                        background: #fff;
                        border-radius: 16px;
                        border: 1px solid #F0F1F1;
                        .generateTabList{
                            width: 402px;
                            padding: 0 24px;
                            border-bottom: 1px solid #F0F1F1;
                            .generateTab{
                                width: 86px;
                                height: 56px;
                                border: 2px solid #fff;
                                font: 14px/56px "Microsoft YaHei";
                                text-align: center;
                                cursor: pointer;
                            }
                            .generateTabOn{
                                border-bottom: 2px solid #00BF7F;
                                color: #00BF7F;
                            }
                        }
                        .generateProgressContent{
                            width: 402px;
                            padding: 24px;
                            .generateProgressBox{
                                padding-bottom: 10px;
                                .generateProgressTitle{
                                    font: 14px/18px "Microsoft YaHei";
                                }
                                .generateProgressTips{
                                    font: 14px/18px "Microsoft YaHei";
                                    color: #8C8C8C;
                                }
                            }
                            .generateProgressNum{
                                font: 14px/18px "Microsoft YaHei";
                                color: #8C8C8C;
                                padding: 10px 0;
                            }
                            .stepList{
                                width: 402px;
                                height: calc(100vh - 402px);
                                overflow-y: scroll;
                                // 隐藏滚动条 (Chrome, Safari, Opera)
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                // 隐藏滚动条 (IE, Edge, Firefox)
                                -ms-overflow-style: none;  // IE and Edge
                                scrollbar-width: none;  // Firefox
                                .stepBox{
                                    width: 368px;
                                    height: 54px;
                                    padding: 0 16px;
                                    background: #F8F9FA;
                                    border-radius: 16px;
                                    border: 1px solid #F0F1F1;
                                    margin-top: 12px;
                                    &:first-child{
                                        margin-top: 0;
                                    }
                                    .stepName{
                                        font: 14px/18px "Microsoft YaHei";
                                    }
                                    .stepNameOn{
                                        color: #8C8C8C;
                                    }
                                    .stepIcon{
                                        width: 16px;
                                        height: 16px;
                                    }
                                    .stepLoadingIcon{
                                        animation: rotate 1s linear infinite;
                                    }
                                }
                            }
                            .stepTipsBox{
                                width: 376px;
                                padding: 12px;
                                background: #FDF6EC;
                                border-radius: 8px;
                                border: 1px solid #FAECD8;
                                margin-top: 24px;
                                .stepTipsIcon{
                                    width: 16px;
                                    height: 16px;
                                }
                                .stepTipsText{
                                    width: 350px;
                                    font: 14px/22px "Microsoft YaHei";
                                    color: #E6A23C;
                                }
                            }
                        }
                    }
                    .resultBox{
                        flex: 1;
                        margin-left: 20px;
                        height: calc(100vh - 106px);
                        background: #fff;
                        border-radius: 16px;
                        .resultSkeletonBox{
                            height: calc(100vh - 170px);
                            padding: 32px;
                            overflow: hidden;
                            .resultSkeleton{
                                height: calc(100vh - 170px);
                                overflow: hidden;
                                .resultSkeletonTitle{
                                    font: bold 20px/25px "Microsoft YaHei";
                                    color: #C0C4CC;
                                    filter: blur(10px);
                                    border-radius: 16px;
                                }
                                .resultSkeletonTips{
                                    font: 16px/20px "Microsoft YaHei";
                                    margin: 36px 0 18px 0;
                                }
                            }
                        }
                    }
                }
            }
            @keyframes rotate {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
            .topicTabList{
                margin-top: 32px;
                .topicTab{
                    width: 86px;
                    height: 56px;
                    font: 14px/56px "Microsoft YaHei";
                    text-align: center;
                    cursor: pointer;
                    margin-right: 20px;
                }
                .topicTabOn{
                    border-bottom: 2px solid #00BF7F;
                    color: #00BF7F;
                }
            }
            .topicBox{
                min-width: 1200px;
                width: 100%;
                height: calc(100vh - 116px);
                margin-top: 24px;
                .batchBtn{
                    margin-left: 8px;
                }
                .topicFilterList{
                    height: 40px;
                    margin-top: 16px;
                    .topicFilterBox{
                        height: 38px;
                        background: #fff;
                        border-radius: 8px;
                        border: 1px solid #DCDFE6;
                        margin-right: 16px;
                        .topicFilterTitle{
                            font: 14px/14px "Microsoft YaHei";
                            color: #606266;
                            padding: 0 8px 0 15px;
                            border-right: 1px solid #F0F1F1;
                        }
                        .topicFilterSelect{
                                height: 38px !important;
                                border: none !important;
                                background: none !important;
                                /deep/ .el-input__inner {
                                    height: 38px !important;
                                    border: none !important;
                                    background: none !important;
                                }
                            }
                    }
                }
                .sceneTabBox{
                    width: calc(100% - 2px);
                    max-height: calc(100vh - 230px);
                    border: 1px solid #E4E7ED;
                    background: #fff;
                    border-radius: 16px;
                    margin-top: 16px;
                    /deep/ .is-active {
                        color: #C0C4CC;
                    }
                    /deep/ .el-table--fit{
                        border-radius: 16px 16px 0 0;
                    }
                    .sceneTitle{
                        color: #00BF7F;
                    }
                    .sceneEmpty{
                        padding: 80px 0 144px 0;
                        .sceneEmptyImg{
                            width: 360px;
                            height: 260px;
                        }
                        .sceneEmptyText{
                            font: 12px/16px "Microsoft YaHei";
                            color: #8C8C8C;
                            padding: 24px 0;
                        }
                    }
                }
                .topicRemaining{
                    font: 14px/22px "Microsoft YaHei";
                    color: #595959;
                    margin-top: 16px;
                    .topicRemainingNum{
                        color: #F84025;
                    }
                }
            }
            .vipTabList{
                padding: 4px;
                background: rgba(0,0,0,0.05);
                border-radius: 21px;
                margin-top: 30px;
                .tab{
                    width: 108px;
                    height: 34px;
                    border-radius: 17px;
                    font: 14px/34px "Microsoft YaHei";
                    text-align: center;
                    cursor: pointer;
                    &.tabOn{
                        background: #fff;
                    }
                }
            }
            .exchangeBox{
                margin-top: 24px;
                cursor: pointer;
                .exchange{
                    font: 16px/20px "Microsoft YaHei";
                }
                .exchangeIcon{
                    width: 16px;
                    height: 16px;
                    margin-left: 5px;
                }
            }
            .vipList{
                margin-top: 24px;
                .vipBox{
                    width: 320px;
                    padding: 0 0 86px 34px;
                    border-radius: 32px;
                    border: 1px solid #EBECED;
                    margin-right: 16px;
                    &:last-child{
                        margin-right: 0;
                    }
                    &:nth-child(1){
                        background: radial-gradient( 97.79% 45.54% at 50% 2.98%, #E0E9FF 0%, #fff 75.55%);
                    }
                    &:nth-child(2){
                        background: radial-gradient( 97.79% 45.54% at 50% 2.98%, #E9E6FF 0%, #fff 75.55%);
                    }
                    &:nth-child(3){
                        background: radial-gradient( 97.79% 45.54% at 50% 2.98%, #FBF4EB 0%, #fff 75.55%);
                    }
                    .vipTop{
                        width: 305px;
                        height: 181px;
                        position: relative;
                        margin-top: 34px;
                        .vipImg{
                            width: 133px;
                            height: 133px;
                            position: absolute;
                            top: 0;
                            right: 0;
                        }
                        .vipName{
                            font: 22px/28px "Microsoft YaHei";
                        }
                        .vipPrice{
                            font: bold 42px/52px "Microsoft YaHei";
                            margin-top: 40px;
                            .vipPriceIcon{
                                font: bold 22px/52px "Microsoft YaHei";
                            }
                            .vipPriceTime{
                                font: 14px/52px "Microsoft YaHei";
                                color: #8C8C8C;
                            }
                        }
                        .vipNew{
                            padding: 0 5px;
                            height: 24px;
                            background: #27FBD2;
                            border-radius: 12px;
                            font: 14px/24px "Microsoft YaHei";
                            margin-top: 4px;
                        }
                        .vipPoints{
                            font: 14px/16px "Microsoft YaHei";
                            color: #8C8C8C;
                            margin-top: 4px;
                        }
                    }
                    .vipBtn{
                        width: 305px;
                        height: 44px;
                        background: #000;
                        border-radius: 22px;
                        font: 16px/44px "Microsoft YaHei";
                        color: #fff;
                        text-align: center;
                        margin-top: 24px;
                        cursor: pointer;
                    }
                    .vipBtnOn{
                        background: #E1E2E5 !important;
                        cursor: no-drop;
                    }
                    .vipAgreementBox{
                        margin-top: 8px;
                        cursor: pointer;
                        .vipAgreementIcon{
                            width: 16px;
                            height: 16px;
                        }
                        .vipAgreement{
                            font: 14px/18px "Microsoft YaHei";
                            color: #8C8C8C;
                            padding-left: 2px;
                        }
                        .vipAgreementText{
                            font: 14px/18px "Microsoft YaHei";
                        }
                    }
                    .averageBox{
                        width: 305px;
                        height: 60px;
                        background: #F6F6F6;
                        border-radius: 16px;
                        margin-top: 20px;
                        .averageIcon{
                            width: 16px;
                            height: 16px;
                        }
                        .averageText{
                            font: 22px/60px "Microsoft YaHei";
                            margin-left: 4px;
                        }
                    }
                    .privilegeList{
                        padding-top: 8px;
                        .privilegeBox{
                            padding-right: 18px;
                            margin-top: 16px;
                            .privilegeIcon{
                                width: 16px;
                                height: 16px;
                            }
                            .privilegeText{
                                font: 14px/16px "Microsoft YaHei";
                                margin-left: 8px;
                            }
                        }
                    }
                }
            }
       }
       .competitorPopupBox{
            padding: 0 24px;
            .competitorPopupItem{
                width: 100%;
                margin-top: 12px;
                .competitorTitle{
                    width: 70px;
                    font: 14px/42px "Microsoft YaHei";
                    color: #606266;
                    text-align: right;
                    margin-right: 12px;
                    .competitorTitleIcon{
                        color: #F56C6C;
                    }
                }
                .competitorIpt{
                    width: 320px;
                    height: 40px;
                    background: #fff;
                    border-radius: 4px;
                    font: 14px/40px "Microsoft YaHei";
                }
                .competitorImgBox{
                    width: 86px;
                    height: 86px;
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #E4E7ED;
                    overflow: hidden;
                    .competitorImg{
                        width: 86px;
                        height: 86px;
                    }
                    .competitorImgNoBox{
                        width: 86px;
                        height: 86px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        .competitorIcon{
                            width: 16px;
                            height: 16px;
                        }
                        .competitorImgNoText{
                            font: 14px/22px "Microsoft YaHei";
                            color: #606266;
                            margin-top: 4px;
                        }
                    }
                }
            }
       }
       .knowledgePopupBox{
            .knowledgePopupItem{
                margin-top: 12px;
                .knowledgeTitle{
                    width: 118px;
                    font: 14px/42px "Microsoft YaHei";
                    color: #606266;
                    text-align: right;
                    margin-right: 12px;
                    .knowledgeTitleIcon{
                        color: #F56C6C;
                    }
                }
                .knowledgeIpt{
                    width: 320px;
                    height: 40px;
                    background: #fff;
                    border-radius: 4px;
                    font: 14px/40px "Microsoft YaHei";
                }
                .knowledgeTypeList{
                    width: 372px;
                    .knowledgeType{
                        width: 148px;
                        height: 46px;
                        padding: 8px 16px;
                        background: #F8F9FA;
                        border-radius: 8px;
                        border: 1px solid #F0F1F1;
                        margin: 8px 8px 0 0;
                        cursor: pointer;
                        &.knowledgeTypeOn{
                            background: #F5FAF8 !important;
                            border: 1px solid #00BF7F !important;
                        }
                        &:nth-child(1){
                            margin-top: 0;
                        }
                        &:nth-child(2){
                            margin-top: 0;
                        }
                        &:nth-child(2n){
                            margin-right: 0;
                        }
                        .knowledgeTypeIcon{
                            width: 16px;
                            height: 16px;
                        }
                        .knowledgeTypeName{
                            font: 14px/22px "Microsoft YaHei";
                            margin-left: 4px;
                        }
                        .knowledgeTypeText{
                            font: 12px/22px "Microsoft YaHei";
                            color: #8C8C8C;
                            margin-top: 2px;
                        }
                    }
                }
                /deep/ .el-upload-dragger {
                    width: 228px;
                    height: 123px;
                }
                /deep/ .el-icon-upload{
                    margin: 18px 0;
                }
            }
       }
       .templatePopupBox{
            width: 978px;
            .templatePopupTips{
                font: 12px/22px "Microsoft YaHei";
                color: #8C8C8C;
                text-align: center;
            }
            .templateList{
                width: 978px;
                max-height: 480px;
                overflow-y: scroll;
                margin-top: 8px;
                // 隐藏滚动条 (Chrome, Safari, Opera)
                &::-webkit-scrollbar {
                    display: none;
                }
                // 隐藏滚动条 (IE, Edge, Firefox)
                -ms-overflow-style: none;  // IE and Edge
                scrollbar-width: none;  // Firefox
                .templateBoxBg{
                    width: 310px;
                    height: 204px;
                    padding: 2px;
                    background: linear-gradient( 270deg, #F2FAF7 0%, #E8FCF6 100%);
                    border-radius: 16px;
                    margin: 6px;
                    position: relative;
                    cursor: pointer;
                    &.templateBoxBgOn{
                        background: #00BF7F;
                    }
                    .templateIcon{
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        top: 3px;
                        right: 3px;
                    }
                    .templateBox{
                        width: 298px;
                        height: 192px;
                        padding: 6px;
                        background: linear-gradient( 270deg, #F2FAF7 0%, #E8FCF6 100%);
                        border-radius: 16px 52px 16px 16px;
                        .templateTitle{
                            padding: 0 15px;
                            width: 268px;
                            font: bold 16px/20px "Microsoft YaHei";
                            color: #000;
                            margin-top: 15px;
                        }
                        .templateTips{
                            padding: 0 15px;
                            width: 268px;
                            font: 12px/15px "Microsoft YaHei";
                            color: #595959;
                            margin-top: 6px;
                        }
                        .templateTagBox{
                            width: 266px;
                            height: 92px;
                            padding: 16px;
                            background: linear-gradient( 270deg, rgba(255,255,255,0.32) 0%, #fff 100%);
                            border-radius: 16px;
                            margin-top: 12px;
                            .templateTagTitle{
                                font: 12px/15px "Microsoft YaHei";
                                color: #8C8C8C;
                            }
                            .templateTagList{
                                height: 29px;
                                margin: 5px 0 8px 0;
                                .templateTag{
                                    padding: 0 5px;
                                    height: 21px;
                                    background: rgba(0,178,119,0.05);
                                    border-radius: 8px;
                                    font: 12px/21px "Microsoft YaHei";
                                    color: #00BF7F;
                                    margin: 0 8px 8px 0;
                                }
                            }
                            .templateTagTips{
                                font: 12px/15px "Microsoft YaHei";
                                color: #595959;
                                margin-top: 5px;
                            }
                        }
                    }
                }
            }
       }
       .createMask{
            width: 100vw;
            height: 100vh;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 7;
       }
       .topicPopupBox{
            width: 370px;
            .topicPopupItem{
                width: 100%;
                margin-top: 12px;
                .topicTitle{
                    width: 50px;
                    font: 14px/42px "Microsoft YaHei";
                    color: #606266;
                    .topicTitleIcon{
                        color: #F56C6C;
                    }
                }
                .topicIpt{
                    width: 320px;
                    height: 40px;
                    background: #fff;
                    border-radius: 4px;
                    font: 14px/40px "Microsoft YaHei";
                }
                .topicPopupTips{
                    font: 12px/18px "Microsoft YaHei";
                    color: #909399;
                    margin-top: 4px;
                }
            }
       }
       .paginationBox{
            padding: 12px 20px;
        }
        .portraitBox{
            width: 688px;
            padding-bottom: 90px;
            overflow-y: scroll;
            // 隐藏滚动条 (Chrome, Safari, Opera)
            &::-webkit-scrollbar {
                display: none;
            }
            // 隐藏滚动条 (IE, Edge, Firefox)
            -ms-overflow-style: none;  // IE and Edge
            scrollbar-width: none;  // Firefox
            margin: 0 24px;
            .portraitTitle{
                font: 16px/22px "Microsoft YaHei";
            }
            .portraitIptBox{
                margin-top: 12px;
                .portraitIptTitle{
                    width: 106px;
                    padding-right: 12px;
                    font: 14px/40px "Microsoft YaHei";
                    text-align: right;
                    color: #606266;
                    .portraitIptTitleIcon{
                        color: #F56C6C;
                    }
                }
                .portraitIpt{
                    width: 320px;
                    height: 40px;
                    font: 14px/40px "Microsoft YaHei";
                }
                .portraitArea{
                    width: 520px;
                    height: 96px;
                    font: 14px/40px "Microsoft YaHei";
                }
            }
            .portraitAreaTips{
                padding-left: 118px;
                font: 12px/18px "Microsoft YaHei";
                color: #909399;
                margin: 4px 0 32px 0;
            }
            .portraitTitleTips{
                font: 12px/18px "Microsoft YaHei";
                color: #909399;
                margin: 8px 0 12px 0;
            }
            .portraitItem{
                width: 656px;
                padding: 16px;
                background: #F8F9FA;
                border-radius: 16px;
                margin-top: 8px;
                .dimensionTitle{
                    font: 14px/18px "Microsoft YaHei";
                    color: #333;
                }
                .dimensionType{
                    padding: 0 10px;
                    height: 28px;
                    background: #EBF9F4;
                    border-radius: 4px;
                    border: 1px solid #D8F3EA;
                    font: 14px/28px "Microsoft YaHei";
                    color: #00BF7F;
                    margin-left: 8px;
                }
                .dimensionText{
                    font: 14px/18px "Microsoft YaHei";
                    color: #333;
                    margin-top: 8px;
                }
            }
        }
        .portraitBtn{
            width: 100%;
            padding: 16px 24px;
            position: absolute;
            bottom: 0;
            right: 0;
            background: #fff;
        }
        .dimensionPopupBox{
            width: 536px;
            .dimensionPopupItem{
                width: 100%;
                margin-top: 12px;
                .dimensionTitle{
                    width: 84px;
                    font: 14px/40px "Microsoft YaHei";
                    color: #606266;
                    padding-right: 12px;
                    text-align: right;
                    .dimensionTitleIcon{
                        color: #F56C6C;
                    }
                }
                .dimensionIpt{
                    width: 240px;
                    height: 40px;
                    border-radius: 4px;
                    font: 14px/40px "Microsoft YaHei";
                }
                .dimensionArea{
                    width: 440px;
                    height: 78px;
                    background: #fff;
                    border-radius: 4px;
                    font: 14px/40px "Microsoft YaHei";
                }
            }
       }
       .workPopupImg{
            height: 50vh;
       }
       .geoPointPopup{
            padding-top: 16px;
            .geoPointText{
                font: 14px/22px "Microsoft YaHei";
            }
            .geoIcon{
                width: 16px;
                height: 16px;
            }
            .geoPoint{
                font: 14px/22px "Microsoft YaHei";
                color: #00BF7F;
            }
       }
       .payCode{
            width: 300px;
            height: 300px;
       }
       .agreement{
            max-height: 60vh;
            overflow-y: scroll;
        }
        .timbrePopupBox{
            width: 686px;
            .timbreTabList{
                width: 686px;
                height: 38px;
                border-bottom: 1px solid #F0F1F1;
                .timbreTab{
                    width: 96px;
                    height: 38px;
                    font: 14px/38px "Microsoft YaHei";
                    text-align: center;
                    cursor: pointer;
                    margin-right: 20px;
                }
                .timbreTabOn{
                    color: #00BF7F;
                    border-bottom: 2px solid #00BF7F;
                }
            }
            .timbreIpt{
                width: 686px;
                border-radius: 16px;
                font: 14px/36px "Microsoft YaHei";
                margin-top: 10px;
                /deep/ .el-input__inner{
                    height: 36px;
                    border-radius: 16px;
                }
                .timbreIptIcon {
                    padding: 0 8px;
                    cursor: pointer;
                }
            }
            .timbreList{
                width: 686px;
                max-height: 416px;
                overflow-y: scroll;
                scrollbar-width: none;
                -ms-overflow-style: none;
                &::-webkit-scrollbar {
                    display: none;
                }
                gap: 10px;
                margin: 10px 0;
                .timbreItem{
                    width: 196px;
                    height: 30px;
                    padding: 12px;
                    background: #F8F9FA;
                    border-radius: 16px;
                    border: 1px solid #F0F1F1;
                    cursor: pointer;
                    &.timbreItemOn{
                        box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.12);
                        border: 3px solid #00BF7F;
                        padding: 10px;
                    }
                    .timbreIcon{
                        width: 30px;
                        height: 30px;
                    }
                    .timbreName{
                        width: 162px;
                        font: 14px/22px "Microsoft YaHei";
                        margin-left: 4px;
                    }
                }
                .newTimbre{
                    width: 196px;
                    height: 30px;
                    padding: 12px;
                    background: #F8F9FA;
                    border-radius: 16px;
                    border: 1px dashed #00BF7F;
                    cursor: pointer;
                    .newTimbreText{
                        font: 14px/22px "Microsoft YaHei";
                    }
                    .newTimbreIcon{
                        width: 14px;
                        height: 14px;
                    }
                }
                .digitalItem{
                    width: 162px;
                    height: 230px;
                    background: #000;
                    border-radius: 16px;
                    border: 1px solid #F0F1F1;
                    overflow: hidden;
                    cursor: pointer;
                    position: relative;
                    &.digitalItemOn{
                        width: 158px;
                        height: 226px;
                        box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.12);
                        border: 3px solid #00BF7F;
                    }
                    .digitalItemNameBox{
                        width: 130px;
                        height: 32px;
                        background: linear-gradient( to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.75) 100%);
                        padding: 0 16px;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        .digitalItemName{
                            flex: 1;
                            font: 14px/32px "Microsoft YaHei";
                            color: #fff;
                        }
                    }
                    .digitalItemImg{
                        width: 162px;
                        height: 312px;
                    }
                }
                .newDigital{
                    width: 162px;
                    height: 230px;
                    background: #F8F9FA;
                    border-radius: 16px;
                    border: 1px dashed #00BF7F;
                    cursor: pointer;
                    align-items: center;
                    justify-content: center;
                    .newDigitalText{
                        font: 14px/22px "Microsoft YaHei";
                        margin-top: 4px;
                    }
                    .newDigitalIcon{
                        width: 32px;
                        height: 32px;
                    }
                }
            }
        }
        .newTimbreDrawerBox{
            width: 512px;
            padding: 0 24px;
            .newTimbreTitleBox{
                margin-top: 12px;
                .newTimbreTitleIcon{
                    width: 4px;
                    height: 14px;
                    background: linear-gradient(180deg, #2CFFEA 0%, #20F4AD 49.52%, #20F463 94.71%);
                    margin-right: 8px;
                }
                .newTimbreTitle{
                    font: 16px/20px "Microsoft YaHei";
                }
            }
            .newTimbreIpt{
                width: 512px;
                font: 14px/46px "Microsoft YaHei";
                margin-top: 12px;
                /deep/ .el-input__inner{
                    height: 46px;
                    background: #F8F9FA;
                    border-radius: 16px;
                }
            }
            .newTimbreTabList{
                width: 508px;
                height: 34px;
                padding: 2px;
                background: rgba(0,0,0,0.05);
                border-radius: 19px;
                margin-top: 12px;
                .newTimbreTab{
                    width: 254px;
                    height: 34px;
                    border-radius: 17px;
                    font: 14px/34px "Microsoft YaHei";
                    color: #595959;
                    text-align: center;
                    cursor: pointer;
                    &.newTimbreTabOn{
                        color: #000;
                        background: #fff;
                    }
                }
            }
            .timbreUploadBox{
                width: 510px;
                height: 150px;
                background: #F8F9FA;
                border-radius: 16px;
                border: 1px solid #F0F1F1;
                margin-top: 12px;
                align-items: center;
                justify-content: center;
                .timbreUploadIcon{
                    width: 54px;
                    height: 54px;
                }
            }
            .timbreUploadData{
                width: 486px;
                padding: 12px;
                background: #F8F9FA;
                border-radius: 16px;
                border: 1px solid #F0F1F1;
                margin-top: 12px;
                .timbreUploadImg{
                    width: 30px;
                    height: 30px;
                }
                .timbreUploadName{
                    width: 416px;
                    font: 14px/22px "Microsoft YaHei";
                }
                .timbreUploadDelete{
                    font: 14px/30px "Microsoft YaHei";
                    color: #F84025;
                    cursor: pointer;
                }
            }
            .driveVoice{
                width: 510px;
                height: 210px;
                background: #F8F9FA;
                border-radius: 16px;
                border: 1px solid #F0F1F1;
                margin-top: 12px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .voiceImg{
                    width: 94px;
                    height: 94px;
                    cursor: pointer;
                }
                .playTips{
                    font: 12px/15px "Microsoft YaHei";
                    color: #8C8C8C;
                }
                .voiceTime{
                    font: 20px/25px "Microsoft YaHei";
                    margin-bottom: 2px;
                }
                .voiceAgainBox{
                    margin-top: 12px;
                    .voiceAgain{
                        margin-right: 44px;
                        cursor: pointer;
                        .voiceAgainIcon{
                            width: 24px;
                            height: 24px;
                        }
                        .voiceAgainName{
                            font: 14px/18px "Microsoft YaHei";
                            margin-top: 8px;
                        }
                    }
                }
            }
            .newTimbreDrawerBtnList{
                width: 100%;
                padding: 16px 24px;
                position: absolute;
                bottom: 0;
                right: 0;
                background: #fff;
                .newTimbreDrawerBtnBox{
                    padding: 0 20px;
                    height: 40px;
                    background: linear-gradient( 90deg, #2CFFEA 0%, #20F4AD 49.52%, #20F463 94.71%);
                    border-radius: 8px;
                    cursor: pointer;
                    margin-left: 10px;
                    .newTimbreDrawerBtn{
                        font: 14px/40px "Microsoft YaHei";
                    }
                    .newTimbreDrawerIcon{
                        width: 16px;
                        height: 16px;
                        margin-left: 2px;
                    }
                }
            }
            .newDigitalVideoBox{
                width: 300px;
                margin-top: 12px;
            }
        }
    }
</style>